
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("chOte", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $gFEZF = parcelRequire("gFEZF");


var $kA6Zo = parcelRequire("kA6Zo");

var $buxP3 = parcelRequire("buxP3");




const $b536e81c4fe39d8c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    addItemText: {
        id: "company-hub.company-hub-common.config-panel.add-card-cta",
        defaultMessage: "Add card"
    }
});


const $e26f5718e2c89fff$var$addButtonContentWrapperStyles = (0, $buxP3.xcss)({
    height: '20px'
});
const $e26f5718e2c89fff$export$6cb731ac7be1981a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { actionSubjectIdSuffix: actionSubjectIdSuffix, analyticsSource: analyticsSource, addItem: addItem, onAddItemKeyPress: onAddItemKeyPress, label: label } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== actionSubjectIdSuffix || $[1] !== addItem || $[2] !== analyticsSource || $[3] !== createAnalyticsEvent) {
        t1 = ()=>{
            addItem();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: `add${actionSubjectIdSuffix}`,
                    source: analyticsSource
                }
            }).fire();
        };
        $[0] = actionSubjectIdSuffix;
        $[1] = addItem;
        $[2] = analyticsSource;
        $[3] = createAnalyticsEvent;
        $[4] = t1;
    } else t1 = $[4];
    const onAddItemButtonClick = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
            color: "currentColor",
            label: ""
        });
        $[5] = t2;
    } else t2 = $[5];
    const t3 = label || (0, $b536e81c4fe39d8c$export$defe85febe8b728c).addItemText;
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.050",
            xcss: $e26f5718e2c89fff$var$addButtonContentWrapperStyles
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t3));
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== onAddItemButtonClick || $[9] !== onAddItemKeyPress || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onAddItemButtonClick,
            onKeyPress: onAddItemKeyPress
        }, t4);
        $[8] = onAddItemButtonClick;
        $[9] = onAddItemKeyPress;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ actionSubjectIdSuffix: actionSubjectIdSuffix, analyticsSource: analyticsSource, addItem: addItem, onAddItemKeyPress: onAddItemKeyPress, label: label })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onAddItemButtonClick = ()=>{
        addItem();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `add${actionSubjectIdSuffix}`,
                source: analyticsSource
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onAddItemButtonClick,
        onKeyPress: onAddItemKeyPress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.050",
        xcss: $e26f5718e2c89fff$var$addButtonContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
        color: "currentColor",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label || (0, $b536e81c4fe39d8c$export$defe85febe8b728c).addItemText)));
};
module.exports["AddItemButton"] = $e26f5718e2c89fff$export$6cb731ac7be1981a;

});

parcelRegister("2VNQP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $4ikjJ = parcelRequire("4ikjJ");








var $hekY6 = parcelRequire("hekY6");





var $1LXnB = parcelRequire("1LXnB");


var $hjUDQ = parcelRequire("hjUDQ");

const $60cc3d30438398ac$var$CONTENT_WIDTH = 800;
const $60cc3d30438398ac$var$styles = {
    default: "_1bsb1c3h _4t3iv7uf",
    compact: "_4t3i16xz",
    containerStyles: "_1reo15vq _18m915vq _2rko1mok _1bsb1osq _kqswh2mm"
};
const $60cc3d30438398ac$export$73bba9cb9f06b02a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { layout: t1, previewSizeVariant: t2, PreviewComponent: PreviewComponent } = t0;
    const layout = t1 === undefined ? (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_RIGHT : t1;
    const previewSizeVariant = t2 === undefined ? "default" : t2;
    const [containerWidth, setContainerWidth] = (0, $cozmU.useState)(0);
    const calculatedScale = containerWidth ? containerWidth / $60cc3d30438398ac$var$CONTENT_WIDTH : 0;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $60cc3d30438398ac$var$styles.containerStyles
        ]);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.default), {
            setWidth: setContainerWidth
        });
        $[0] = t3;
        $[1] = t4;
    } else {
        t3 = $[0];
        t4 = $[1];
    }
    const t5 = `scale(${calculatedScale})`;
    let t6;
    if ($[2] !== t5) {
        t6 = {
            transform: t5,
            transformOrigin: "top left"
        };
        $[2] = t5;
        $[3] = t6;
    } else t6 = $[3];
    const t7 = $60cc3d30438398ac$var$styles[previewSizeVariant];
    let t8;
    if ($[4] !== t7) {
        t8 = (0, $hekY6.default)([
            $60cc3d30438398ac$var$styles.default,
            t7
        ]);
        $[4] = t7;
        $[5] = t8;
    } else t8 = $[5];
    let t9;
    if ($[6] !== PreviewComponent || $[7] !== layout) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PreviewComponent, {
            height: (0, $hjUDQ.Height).MEDIUM,
            layout: layout
        });
        $[6] = PreviewComponent;
        $[7] = layout;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== t8 || $[10] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t8
        }, t9);
        $[9] = t8;
        $[10] = t9;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== t10 || $[13] !== t6) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t3
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t6
        }, t10));
        $[12] = t10;
        $[13] = t6;
        $[14] = t11;
    } else t11 = $[14];
    return t11;
} : ({ layout: layout = (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_RIGHT, previewSizeVariant: previewSizeVariant = 'default', PreviewComponent: PreviewComponent })=>{
    const [containerWidth, setContainerWidth] = (0, $cozmU.useState)(0);
    const calculatedScale = containerWidth ? containerWidth / $60cc3d30438398ac$var$CONTENT_WIDTH : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $60cc3d30438398ac$var$styles.containerStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.default), {
        setWidth: setContainerWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            transform: `scale(${calculatedScale})`,
            transformOrigin: 'top left'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $60cc3d30438398ac$var$styles.default,
            $60cc3d30438398ac$var$styles[previewSizeVariant]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PreviewComponent, {
        height: (0, $hjUDQ.Height).MEDIUM,
        layout: layout
    }))));
};


const $4a9f6eb649378640$var$headingSizeMap = {
    default: 'xsmall',
    compact: 'xxsmall'
};
/**
 * Mapping layout variants to classnames
 */ const $4a9f6eb649378640$var$variantMap = {
    default: 'defaultLayoutOption',
    compact: 'compactLayoutOption'
};
const $4a9f6eb649378640$var$layoutOptionStyles = {
    defaultLayoutOption: "_2rko12b0 _1h6d1l7x _189ee4h9 _1dqonqa1 _bfhksm61 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _d0altlke",
    compactLayoutOption: "_ca0qutpp _n3tdutpp _19bv12x7 _u5f312x7",
    layoutOptionSelected: "_1h6dq98m",
    radioButtonWrapper: "_18u0r5cr _4cvr1h6o",
    layoutLabelHeadingWrapper: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _18u01i6y _19pkv77o"
};
const $4a9f6eb649378640$export$f4ca495c8982b022 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { updateLayout: updateLayout, source: source, layoutOptions: layoutOptions, variant: t1, PreviewComponent: PreviewComponent, previewImage: previewImage, currentLayoutSelection: currentLayoutSelection } = t0;
    const variant = t1 === undefined ? "default" : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t2 = (value)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "selected",
                    actionSubject: "layout",
                    actionSubjectId: "configPanelLayoutOptions",
                    source: source,
                    attributes: {
                        value: value
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t2;
    } else t2 = $[2];
    const handleClickAnalytics = t2;
    let t3;
    if ($[3] !== handleClickAnalytics || $[4] !== layoutOptions || $[5] !== updateLayout) {
        t3 = (event)=>{
            const selectedOption = layoutOptions.find((option)=>option.value === event.currentTarget.value);
            if (selectedOption) {
                handleClickAnalytics(selectedOption.value);
                updateLayout(selectedOption.value);
            }
        };
        $[3] = handleClickAnalytics;
        $[4] = layoutOptions;
        $[5] = updateLayout;
        $[6] = t3;
    } else t3 = $[6];
    const handleOnChange = t3;
    let t4;
    if ($[7] !== handleClickAnalytics || $[8] !== layoutOptions || $[9] !== updateLayout) {
        t4 = (newLayoutValue)=>{
            const selectedValue = layoutOptions.find((t5)=>{
                const { value: value_0 } = t5;
                return value_0 === newLayoutValue;
            })?.value;
            handleClickAnalytics(selectedValue);
            updateLayout(newLayoutValue);
        };
        $[7] = handleClickAnalytics;
        $[8] = layoutOptions;
        $[9] = updateLayout;
        $[10] = t4;
    } else t4 = $[10];
    const handleOptionClick = t4;
    let t5;
    if ($[11] !== PreviewComponent || $[12] !== currentLayoutSelection || $[13] !== formatMessage || $[14] !== handleOnChange || $[15] !== handleOptionClick || $[16] !== layoutOptions || $[17] !== previewImage || $[18] !== variant) {
        let t6;
        if ($[20] !== PreviewComponent || $[21] !== currentLayoutSelection || $[22] !== formatMessage || $[23] !== handleOnChange || $[24] !== handleOptionClick || $[25] !== previewImage || $[26] !== variant) {
            t6 = (t7)=>{
                const { value: layout, label: i18nLabel, description: i18nDescription } = t7;
                const label = formatMessage(i18nLabel);
                const description = i18nDescription && formatMessage(i18nDescription);
                const { imageSrc: imageSrc, imageSrcDark: imageSrcDark } = previewImage?.(layout) || {};
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                    xcss: (0, $w6R6I.cx)($4a9f6eb649378640$var$layoutOptionStyles.defaultLayoutOption, currentLayoutSelection === layout && $4a9f6eb649378640$var$layoutOptionStyles.layoutOptionSelected, $4a9f6eb649378640$var$layoutOptionStyles[$4a9f6eb649378640$var$variantMap[variant]]),
                    onClick: ()=>handleOptionClick(layout),
                    key: `${layout}${label}`,
                    testId: "layout-option"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    direction: "column",
                    gap: "space.100"
                }, PreviewComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60cc3d30438398ac$export$73bba9cb9f06b02a), {
                    layout: layout,
                    previewSizeVariant: variant,
                    PreviewComponent: PreviewComponent
                }), !PreviewComponent && previewImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                    src: imageSrc,
                    srcDark: imageSrcDark,
                    alt: "",
                    testId: `${layout}--image`
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    direction: "column",
                    gap: "space.050"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: (0, $w6R6I.cx)($4a9f6eb649378640$var$layoutOptionStyles.radioButtonWrapper)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                    value: layout,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                        alignItems: "center",
                        xcss: (0, $w6R6I.cx)($4a9f6eb649378640$var$layoutOptionStyles.layoutLabelHeadingWrapper)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                        size: $4a9f6eb649378640$var$headingSizeMap[variant]
                    }, label)),
                    name: label,
                    isChecked: layout === currentLayoutSelection,
                    onChange: handleOnChange
                })), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    align: "start",
                    color: "color.text.subtlest",
                    size: "small"
                }, description))));
            };
            $[20] = PreviewComponent;
            $[21] = currentLayoutSelection;
            $[22] = formatMessage;
            $[23] = handleOnChange;
            $[24] = handleOptionClick;
            $[25] = previewImage;
            $[26] = variant;
            $[27] = t6;
        } else t6 = $[27];
        t5 = layoutOptions.map(t6);
        $[11] = PreviewComponent;
        $[12] = currentLayoutSelection;
        $[13] = formatMessage;
        $[14] = handleOnChange;
        $[15] = handleOptionClick;
        $[16] = layoutOptions;
        $[17] = previewImage;
        $[18] = variant;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[28] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5);
        $[28] = t5;
        $[29] = t6;
    } else t6 = $[29];
    return t6;
} : ({ updateLayout: updateLayout, source: source, layoutOptions: layoutOptions, variant: variant = 'default', PreviewComponent: PreviewComponent, previewImage: previewImage, currentLayoutSelection: currentLayoutSelection })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClickAnalytics = (0, $cozmU.useCallback)((value)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'selected',
                actionSubject: 'layout',
                actionSubjectId: 'configPanelLayoutOptions',
                source: source,
                attributes: {
                    value: value
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const handleOnChange = (event)=>{
        const selectedOption = layoutOptions.find((option)=>option.value === event.currentTarget.value);
        if (selectedOption) {
            handleClickAnalytics(selectedOption.value);
            updateLayout(selectedOption.value);
        }
    };
    const handleOptionClick = (newLayoutValue)=>{
        const selectedValue = layoutOptions.find(({ value: value_0 })=>value_0 === newLayoutValue)?.value;
        handleClickAnalytics(selectedValue);
        updateLayout(newLayoutValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, layoutOptions.map(({ value: layout, label: i18nLabel, description: i18nDescription })=>{
        const label = formatMessage(i18nLabel);
        const description = i18nDescription && formatMessage(i18nDescription);
        const { imageSrc: imageSrc, imageSrcDark: imageSrcDark } = previewImage?.(layout) || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $w6R6I.cx)($4a9f6eb649378640$var$layoutOptionStyles.defaultLayoutOption, currentLayoutSelection === layout && $4a9f6eb649378640$var$layoutOptionStyles.layoutOptionSelected, $4a9f6eb649378640$var$layoutOptionStyles[$4a9f6eb649378640$var$variantMap[variant]]),
            onClick: ()=>handleOptionClick(layout),
            key: `${layout}${label}`,
            testId: "layout-option"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.100"
        }, PreviewComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60cc3d30438398ac$export$73bba9cb9f06b02a), {
            layout: layout,
            previewSizeVariant: variant,
            PreviewComponent: PreviewComponent
        }), !PreviewComponent && previewImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: imageSrc,
            srcDark: imageSrcDark,
            alt: "",
            testId: `${layout}--image`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($4a9f6eb649378640$var$layoutOptionStyles.radioButtonWrapper)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
            value: layout,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                alignItems: "center",
                xcss: (0, $w6R6I.cx)($4a9f6eb649378640$var$layoutOptionStyles.layoutLabelHeadingWrapper)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                size: $4a9f6eb649378640$var$headingSizeMap[variant]
            }, label)),
            name: label,
            isChecked: layout === currentLayoutSelection,
            onChange: handleOnChange
        })), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            align: "start",
            color: "color.text.subtlest",
            size: "small"
        }, description))));
    }));
};
module.exports["LayoutOptions"] = $4a9f6eb649378640$export$f4ca495c8982b022;

});

parcelRegister("jmFR8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4ez2K = parcelRequire("4ez2K");


var $bIp5p = parcelRequire("bIp5p");


var $cfM7x = parcelRequire("cfM7x");


var $9BXp4 = parcelRequire("9BXp4");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $9DHhW = parcelRequire("9DHhW");


var $38vK5 = parcelRequire("38vK5");


var $aqP4n = parcelRequire("aqP4n");


var $fXxpQ = parcelRequire("fXxpQ");


var $aDtKq = parcelRequire("aDtKq");


var $iSrRp = parcelRequire("iSrRp");


var $2wCqQ = parcelRequire("2wCqQ");

var $buxP3 = parcelRequire("buxP3");


var $93Axx = parcelRequire("93Axx");

const $d61eb097e52b52e6$var$wrapperStyles = (0, $buxP3.xcss)({
    gap: 'space.200'
});
const $d61eb097e52b52e6$var$isEqual = (base)=>(value)=>base === value;
const $d61eb097e52b52e6$var$isScroll = $d61eb097e52b52e6$var$isEqual('scroll');
const $d61eb097e52b52e6$var$isAuto = $d61eb097e52b52e6$var$isEqual('auto');
const $d61eb097e52b52e6$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $d61eb097e52b52e6$var$isElementScrollable = (element)=>{
    const style = window.getComputedStyle(element);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $d61eb097e52b52e6$var$isEither(overflow, $d61eb097e52b52e6$var$isScroll) || $d61eb097e52b52e6$var$isEither(overflow, $d61eb097e52b52e6$var$isAuto);
};
const $d61eb097e52b52e6$var$getClosestScrollableElement = (element)=>{
    if (!element) return null;
    if (element === document.body || element === document.documentElement) return null;
    if (!$d61eb097e52b52e6$var$isElementScrollable(element)) return $d61eb097e52b52e6$var$getClosestScrollableElement(element.parentElement);
    return element;
};
const $d61eb097e52b52e6$export$ca49a56e05207e2d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { analyticsSource: analyticsSource, children: children, defaultItems: defaultItems, setDraggedItem: setDraggedItem, updateItems: updateItems, shouldUseCardV2UI: t1 } = t0;
    const shouldUseCardV2UI = t1 === undefined ? false : t1;
    const items = (0, $cozmU.useRef)(defaultItems);
    const draggableZoneRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    let t3;
    if ($[0] !== analyticsSource || $[1] !== createAnalyticsEvent || $[2] !== defaultItems || $[3] !== setDraggedItem || $[4] !== updateItems) {
        t2 = ()=>{
            let cleanupAutoScroll = null;
            return (0, $aDtKq.combine)((0, $iSrRp.monitorForElements)({
                canMonitor: $d61eb097e52b52e6$var$_temp,
                onDragStart: ()=>{
                    if (cleanupAutoScroll) return;
                    const closestScrollable = $d61eb097e52b52e6$var$getClosestScrollableElement(draggableZoneRef.current);
                    if (!closestScrollable) return;
                    cleanupAutoScroll = (0, $38vK5.autoScrollForElements)({
                        element: closestScrollable
                    });
                },
                onDrop: (t4)=>{
                    const { location: location, source: source_0 } = t4;
                    const target = location.current.dropTargets[0];
                    if (!target) return;
                    const sourceData = source_0.data;
                    const targetData = target.data;
                    if (!(0, $93Axx.isItemData)(sourceData) || !(0, $93Axx.isItemData)(targetData)) return;
                    const indexOfSource = defaultItems.findIndex((item)=>item.cardId === sourceData.item.cardId);
                    const indexOfTarget = defaultItems.findIndex((item_0)=>item_0.cardId === targetData.item.cardId);
                    if (indexOfTarget < 0) return;
                    const closestEdgeOfTarget = (0, $aqP4n.extractClosestEdge)(targetData);
                    items.current = (0, $fXxpQ.reorderWithEdge)({
                        list: defaultItems,
                        startIndex: indexOfSource,
                        indexOfTarget: indexOfTarget,
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        axis: "vertical"
                    });
                    setDraggedItem?.();
                    updateItems(items.current);
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "reordered",
                            actionSubject: "items",
                            actionSubjectId: "draggableItemsZone",
                            source: analyticsSource
                        }
                    }).fire();
                }
            }), ()=>cleanupAutoScroll?.());
        };
        t3 = [
            analyticsSource,
            items,
            createAnalyticsEvent,
            defaultItems,
            updateItems,
            setDraggedItem
        ];
        $[0] = analyticsSource;
        $[1] = createAnalyticsEvent;
        $[2] = defaultItems;
        $[3] = setDraggedItem;
        $[4] = updateItems;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] !== shouldUseCardV2UI) {
        t4 = !shouldUseCardV2UI && {
            xcss: $d61eb097e52b52e6$var$wrapperStyles
        };
        $[7] = shouldUseCardV2UI;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== children || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            ref: draggableZoneRef,
            ...t4,
            testId: "draggable-item-zone"
        }, children);
        $[9] = children;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ analyticsSource: analyticsSource, children: children, defaultItems: defaultItems, setDraggedItem: setDraggedItem, updateItems: updateItems, shouldUseCardV2UI: shouldUseCardV2UI = false })=>{
    const items = (0, $cozmU.useRef)(defaultItems);
    const draggableZoneRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        let cleanupAutoScroll = null;
        return (0, $aDtKq.combine)((0, $iSrRp.monitorForElements)({
            canMonitor: ({ source: source })=>{
                return (0, $93Axx.isItemData)(source.data);
            },
            onDragStart: ()=>{
                if (cleanupAutoScroll) return;
                const closestScrollable = $d61eb097e52b52e6$var$getClosestScrollableElement(draggableZoneRef.current);
                if (!closestScrollable) return;
                cleanupAutoScroll = (0, $38vK5.autoScrollForElements)({
                    element: closestScrollable
                });
            },
            onDrop: ({ location: location, source: source_0 })=>{
                const target = location.current.dropTargets[0];
                if (!target) return;
                const sourceData = source_0.data;
                const targetData = target.data;
                if (!(0, $93Axx.isItemData)(sourceData) || !(0, $93Axx.isItemData)(targetData)) return;
                const indexOfSource = defaultItems.findIndex((item)=>item.cardId === sourceData.item.cardId);
                const indexOfTarget = defaultItems.findIndex((item_0)=>item_0.cardId === targetData.item.cardId);
                if (indexOfTarget < 0) return;
                const closestEdgeOfTarget = (0, $aqP4n.extractClosestEdge)(targetData);
                items.current = (0, $fXxpQ.reorderWithEdge)({
                    list: defaultItems,
                    startIndex: indexOfSource,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    axis: 'vertical'
                });
                setDraggedItem?.();
                updateItems(items.current);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'reordered',
                        actionSubject: 'items',
                        actionSubjectId: 'draggableItemsZone',
                        source: analyticsSource
                    }
                }).fire();
            }
        }), ()=>cleanupAutoScroll?.());
    }, [
        analyticsSource,
        items,
        createAnalyticsEvent,
        defaultItems,
        updateItems,
        setDraggedItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        ref: draggableZoneRef,
        ...!shouldUseCardV2UI && {
            xcss: $d61eb097e52b52e6$var$wrapperStyles
        },
        testId: "draggable-item-zone"
    }, children);
};
function $d61eb097e52b52e6$var$_temp(t0) {
    const { source: source } = t0;
    return (0, $93Axx.isItemData)(source.data);
}



var $gcu7p = parcelRequire("gcu7p");

const $1bf0224e71cbb588$var$upAccelerator = 'mod+option+shift+[';
const $1bf0224e71cbb588$var$downAccelerator = 'mod+option+shift+]';
const $1bf0224e71cbb588$export$ae634aeaeccf14ea = ({ items: items, removeItem: removeItem, analyticsSource: analyticsSource, actionSubjectIdPostFix: actionSubjectIdPostFix, itemsListRef: itemsListRef, shouldUseCardV2UI: shouldUseCardV2UI, updateItems: updateItems, itemLabel: itemLabel, canDeleteItem: canDeleteItem = true, renderItemContent: renderItemContent })=>{
    const { shortcutListener: shortcutListener } = (0, $cfM7x.useProductDependencies)();
    const isDeleteDisabled = items?.length === 1;
    const [{ selectedToEditCardId: selectedToEditCardId }, { setIsInViewMode: setIsInViewMode, setSelectedToEditCardId: setSelectedToEditCardId, setIsInAutoFocusMode: setIsInAutoFocusMode }] = (0, $bIp5p.useExtensionsState)();
    const firstItemId = items?.[0]?.cardId || null;
    (0, $cozmU.useEffect)(()=>{
        // the order is important here
        // view mode should goes first to allow the active item to be set
        setIsInViewMode(false);
        if (selectedToEditCardId !== 'dragged-item') setSelectedToEditCardId(firstItemId);
        return ()=>{
            // Only reset card-level state on unmount. Do NOT reset isInViewMode here
            // because this component does not own the view mode lifecycle — the editor does.
            // Resetting isInViewMode to true on unmount would leave the editor in an
            // inconsistent state where subsequent openConfigPanel calls silently fail
            // (setSelectedExtensionLocalId is guarded by isInViewMode).
            setSelectedToEditCardId(null);
            setIsInAutoFocusMode(true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        firstItemId,
        setIsInViewMode,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const setDraggedItem = ()=>setSelectedToEditCardId('dragged-item');
    const swapItems = (source, target)=>{
        const newItems = [
            ...items
        ];
        const temp = newItems[target];
        newItems[target] = newItems[source];
        newItems[source] = temp;
        updateItems(newItems);
    };
    const [focusedItem, setFocusedItem] = (0, $cozmU.useState)(undefined);
    const onMoveUp = ()=>{
        if (focusedItem !== undefined) {
            setDraggedItem();
            swapItems(focusedItem, focusedItem - 1);
            setFocusedItem(focusedItem - 1);
        }
    };
    const onMoveDown = ()=>{
        if (focusedItem !== undefined) {
            setDraggedItem();
            swapItems(focusedItem, focusedItem + 1);
            setFocusedItem(focusedItem + 1);
        }
    };
    const isFirstItemFocused = focusedItem === 0;
    const isLastItemFocused = focusedItem === items?.length - 1;
    const ShortcutListener = shortcutListener || (0, $cozmU.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        testId: "items-list-builder",
        gap: shouldUseCardV2UI ? undefined : 'space.200',
        ref: itemsListRef
    }, (0, $9BXp4.checkItems)(items) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d61eb097e52b52e6$export$ca49a56e05207e2d), {
        analyticsSource: analyticsSource,
        defaultItems: items,
        setDraggedItem: setDraggedItem,
        updateItems: updateItems,
        shouldUseCardV2UI: shouldUseCardV2UI
    }, !isFirstItemFocused && shortcutListener && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ShortcutListener, {
        accelerator: $1bf0224e71cbb588$var$upAccelerator,
        listener: onMoveUp
    }), !isLastItemFocused && shortcutListener && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ShortcutListener, {
        accelerator: $1bf0224e71cbb588$var$downAccelerator,
        listener: onMoveDown
    }), items.map((itemParameters, order)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gcu7p.Item), {
            actionSubjectIdPostFix: actionSubjectIdPostFix,
            analyticsSource: analyticsSource,
            itemParameters: itemParameters,
            isDeleteDisabled: isDeleteDisabled,
            isExpanded: selectedToEditCardId === itemParameters.cardId,
            isFirstItem: order === 0,
            isLastItem: order === items.length - 1,
            key: itemParameters.cardId,
            onFocus: ()=>setFocusedItem(order),
            onBlur: ()=>setFocusedItem(undefined),
            order: order + 1,
            removeItem: removeItem,
            renderItemContent: renderItemContent,
            setDraggedItem: setDraggedItem,
            setExpandedItem: setSelectedToEditCardId,
            swapItems: swapItems,
            shouldUseCardV2UI: shouldUseCardV2UI,
            itemLabel: itemLabel,
            canDeleteItem: canDeleteItem
        });
    })));
};
module.exports["ItemsListBuilder"] = $1bf0224e71cbb588$export$ae634aeaeccf14ea;

});

parcelRegister("gcu7p", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $j6vyT = parcelRequire("j6vyT");


var $iDfTs = parcelRequire("iDfTs");


var $kA6Zo = parcelRequire("kA6Zo");

var $kz1Yj = parcelRequire("kz1Yj");

var $kh0hi = parcelRequire("kh0hi");

var $2wCqQ = parcelRequire("2wCqQ");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $9vJye = parcelRequire("9vJye");


var $bIp5p = parcelRequire("bIp5p");











var $9kbTQ = parcelRequire("9kbTQ");


var $bB0i2 = parcelRequire("bB0i2");


var $aqP4n = parcelRequire("aqP4n");


var $vZEJe = parcelRequire("vZEJe");


var $aDtKq = parcelRequire("aDtKq");


var $iSrRp = parcelRequire("iSrRp");


var $fYWmN = parcelRequire("fYWmN");


var $cDMxg = parcelRequire("cDMxg");


var $3izAL = parcelRequire("3izAL");




















var $4nIKB = parcelRequire("4nIKB");


var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");


var $ldqjS = parcelRequire("ldqjS");


var $fS8Zl = parcelRequire("fS8Zl");


var $f6cdQ = parcelRequire("f6cdQ");


var $8aG6j = parcelRequire("8aG6j");











var $8LYsc = parcelRequire("8LYsc");

/* eslint-disable @atlaskit/design-system/no-deprecated-imports -- Preserve existing drag handle behavior while focus-ring usage is reviewed separately. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $b1FLc = parcelRequire("b1FLc");

function $f106b3686ad99520$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Cannot use `@atlaskit/button` here because it cancels `mousedown` events
 * which prevents dragging.
 */ const $f106b3686ad99520$var$buttonStyles = {
    name: "txaqq0",
    styles: "color:var(--ds-text, #292A2E);border-radius:var(--ds-radius-small, 4px);padding:var(--ds-space-0, 0px);width:max-content;border:none;cursor:grab;display:flex"
};
const $f106b3686ad99520$var$buttonAppearanceStyles = {
    default: {
        name: "1m0qggu",
        styles: "background-color:var(--ds-background-neutral, #0515240F);&:hover{background-color:var(--ds-background-neutral-hovered, #0B120E24);}&:active{background-color:var(--ds-background-neutral-pressed, #080F214A);}"
    },
    subtle: {
        name: "u8pb1t",
        styles: "background-color:var(--ds-background-neutral-subtle, #00000000);&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #0B120E24);}"
    },
    selected: {
        name: "1km59x1",
        styles: "background-color:var(--ds-background-selected, #E9F2FE);color:var(--ds-text-selected, #1868DB)"
    }
};
const $f106b3686ad99520$export$c099c65cfbd84d0a = /*#__PURE__*/ (0, $cozmU.forwardRef)(function DragHandleButton({ children: children, isSelected: isSelected = false, testId: testId, appearance: appearanceProp = 'default', type: /**
   * Defaulting to `button` instead of `submit` (native default in some cases).
   *
   * A type of `submit` only makes sense in a form context, and isn't very
   * relevant to a drag handle.
   *
   * `@atlaskit/button` also defaults to a type of `button` as well, as it
   * is more semantically appropriate in a wider range of cases.
   */ type = 'button', ...buttonProps }, ref) {
    const appearance = isSelected ? 'selected' : appearanceProp;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b1FLc.default), null, /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
        ref: ref,
        css: [
            $f106b3686ad99520$var$buttonStyles,
            $f106b3686ad99520$var$buttonAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        type: type,
        ...buttonProps
    }, children));
});


const $e839f5a330db254b$export$4c99a519d851f90c = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function DragHandleButton(t0, ref) {
    const $ = (0, $bDgLe.c)(9);
    let buttonProps;
    let label;
    if ($[0] !== t0) {
        ({ label: label, ...buttonProps } = t0);
        $[0] = t0;
        $[1] = buttonProps;
        $[2] = label;
    } else {
        buttonProps = $[1];
        label = $[2];
    }
    let t1;
    if ($[3] !== label) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8LYsc))), {
            spacing: "spacious",
            label: label,
            size: "small"
        });
        $[3] = label;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== buttonProps || $[6] !== ref || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f106b3686ad99520$export$c099c65cfbd84d0a), {
            ref: ref,
            ...buttonProps,
            children: t1
        });
        $[5] = buttonProps;
        $[6] = ref;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function DragHandleButton({ label: label, ...buttonProps }, ref) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f106b3686ad99520$export$c099c65cfbd84d0a), {
        ref: ref,
        ...buttonProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8LYsc))), {
            spacing: "spacious",
            label: label,
            size: "small"
        })
    });
});










const $87411eddeb456868$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    moveUp: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.move.up.label",
        defaultMessage: "Move up"
    },
    moveDown: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.move.down.label",
        defaultMessage: "Move down"
    },
    arrowUp: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.arrow.up",
        defaultMessage: "up"
    },
    arrowDown: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.arrow.down",
        defaultMessage: "down"
    },
    reorder: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.reorder",
        defaultMessage: "reorder"
    }
});


const $caec464509f9ce59$var$moveRowUp = (0, $ldqjS.makeKeyMapWithCommon)('Move Up', 'Ctrl-Alt-Shift-[');
const $caec464509f9ce59$var$moveRowDown = (0, $ldqjS.makeKeyMapWithCommon)('Move Down', 'Ctrl-Alt-Shift-]');
const $caec464509f9ce59$var$upKeyMap = (0, $ldqjS.tooltip)($caec464509f9ce59$var$moveRowUp);
const $caec464509f9ce59$var$downKeyMap = (0, $ldqjS.tooltip)($caec464509f9ce59$var$moveRowDown);
const $caec464509f9ce59$var$dragHandleStyles = (0, $buxP3.xcss)({
    backgroundColor: 'utility.elevation.surface.current',
    marginInline: 'space.050'
});
const $caec464509f9ce59$var$draggingStyles = (0, $buxP3.xcss)({
    opacity: '0.5'
});
const $caec464509f9ce59$var$shortcut = (0, $buxP3.xcss)({
    background: "var(--ds-background-neutral, #0515240F)",
    color: 'color.text.subtle',
    borderRadius: 'radius.small',
    padding: 'space.050',
    alignSelf: 'flex-end'
});
const $caec464509f9ce59$var$getStyles = (isDragHandleHovered, isDragHandleFocused)=>({
        justifyContent: 'center',
        width: '16px',
        backgroundColor: "var(--ds-elevation-surface-current, #FFFFFF)",
        ...isDragHandleHovered && {
            backgroundColor: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
        },
        ...isDragHandleFocused && {
            backgroundColor: "var(--ds-elevation-surface-current, #FFFFFF)"
        }
    });
const $caec464509f9ce59$export$d87bd93dda5de125 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { isDragHandleFocused: isDragHandleFocused, isDragging: isDragging, isFirst: isFirst, isLast: isLast, onMoveUp: onMoveUp, onMoveDown: onMoveDown, setIsDragHandleFocused: setIsDragHandleFocused, onFocus: onFocus, onBlur: onBlur } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const dragHandleRef = (0, $cozmU.useRef)(null);
    const [isDragHandleHovered, setIsDragHandleHovered] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== formatMessage || $[1] !== isDragHandleFocused || $[2] !== isDragHandleHovered || $[3] !== isDragging || $[4] !== onBlur || $[5] !== onFocus) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: [
                    $caec464509f9ce59$var$dragHandleStyles,
                    isDragging && $caec464509f9ce59$var$draggingStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e839f5a330db254b$export$4c99a519d851f90c), {
                style: $caec464509f9ce59$var$getStyles(isDragHandleHovered, isDragHandleFocused),
                ref: (0, $4nIKB.mergeRefs)([
                    dragHandleRef,
                    triggerRef
                ]),
                ...triggerProps,
                testId: "drag-handle",
                label: formatMessage((0, $87411eddeb456868$export$defe85febe8b728c).reorder),
                onMouseLeave: ()=>{
                    if (!triggerProps.isSelected) setIsDragHandleHovered(false);
                },
                onMouseEnter: ()=>{
                    if (!triggerProps.isSelected) setIsDragHandleHovered(true);
                },
                onFocus: onFocus,
                onBlur: onBlur
            }));
        };
        $[0] = formatMessage;
        $[1] = isDragHandleFocused;
        $[2] = isDragHandleHovered;
        $[3] = isDragging;
        $[4] = onBlur;
        $[5] = onFocus;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== setIsDragHandleFocused) {
        t2 = (args)=>{
            const { isOpen: isOpen } = args;
            setIsDragHandleFocused(isOpen);
            if (!isOpen) setIsDragHandleHovered(false);
        };
        $[7] = setIsDragHandleFocused;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== formatMessage) {
        t3 = formatMessage((0, $87411eddeb456868$export$defe85febe8b728c).arrowUp);
        $[9] = formatMessage;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
            label: t3
        });
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $caec464509f9ce59$var$shortcut
        }, $caec464509f9ce59$var$upKeyMap);
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $87411eddeb456868$export$defe85febe8b728c).moveUp);
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== isFirst || $[16] !== onMoveUp || $[17] !== t4) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: t4,
            elemAfter: t5,
            isDisabled: isFirst,
            onClick: onMoveUp
        }, t6);
        $[15] = isFirst;
        $[16] = onMoveUp;
        $[17] = t4;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== formatMessage) {
        t8 = formatMessage((0, $87411eddeb456868$export$defe85febe8b728c).arrowDown);
        $[19] = formatMessage;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fS8Zl))), {
            label: t8
        });
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $caec464509f9ce59$var$shortcut
        }, $caec464509f9ce59$var$downKeyMap);
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $87411eddeb456868$export$defe85febe8b728c).moveDown);
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== isLast || $[26] !== onMoveDown || $[27] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: t9,
            elemAfter: t10,
            isDisabled: isLast,
            onClick: onMoveDown
        }, t11);
        $[25] = isLast;
        $[26] = onMoveDown;
        $[27] = t9;
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== t12 || $[30] !== t7) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t7, t12);
        $[29] = t12;
        $[30] = t7;
        $[31] = t13;
    } else t13 = $[31];
    let t14;
    if ($[32] !== isDragHandleFocused || $[33] !== t1 || $[34] !== t13 || $[35] !== t2) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            trigger: t1,
            onOpenChange: t2,
            isOpen: isDragHandleFocused
        }, t13);
        $[32] = isDragHandleFocused;
        $[33] = t1;
        $[34] = t13;
        $[35] = t2;
        $[36] = t14;
    } else t14 = $[36];
    return t14;
} : ({ isDragHandleFocused: isDragHandleFocused, isDragging: isDragging, isFirst: isFirst, isLast: isLast, onMoveUp: onMoveUp, onMoveDown: onMoveDown, setIsDragHandleFocused: setIsDragHandleFocused, onFocus: onFocus, onBlur: onBlur })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const dragHandleRef = (0, $cozmU.useRef)(null);
    const [isDragHandleHovered, setIsDragHandleHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: [
                    $caec464509f9ce59$var$dragHandleStyles,
                    isDragging && $caec464509f9ce59$var$draggingStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e839f5a330db254b$export$4c99a519d851f90c), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: $caec464509f9ce59$var$getStyles(isDragHandleHovered, isDragHandleFocused),
                ref: (0, $4nIKB.mergeRefs)([
                    dragHandleRef,
                    triggerRef
                ]),
                ...triggerProps,
                testId: "drag-handle",
                label: formatMessage((0, $87411eddeb456868$export$defe85febe8b728c).reorder),
                onMouseLeave: ()=>{
                    if (!triggerProps.isSelected) setIsDragHandleHovered(false);
                },
                onMouseEnter: ()=>{
                    if (!triggerProps.isSelected) setIsDragHandleHovered(true);
                },
                onFocus: onFocus,
                onBlur: onBlur
            })),
        onOpenChange: (args)=>{
            const { isOpen: isOpen } = args;
            setIsDragHandleFocused(isOpen);
            if (!isOpen) setIsDragHandleHovered(false);
        },
        isOpen: isDragHandleFocused
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
            label: formatMessage((0, $87411eddeb456868$export$defe85febe8b728c).arrowUp)
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $caec464509f9ce59$var$shortcut
        }, $caec464509f9ce59$var$upKeyMap),
        isDisabled: isFirst,
        onClick: onMoveUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $87411eddeb456868$export$defe85febe8b728c).moveUp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fS8Zl))), {
            label: formatMessage((0, $87411eddeb456868$export$defe85febe8b728c).arrowDown)
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $caec464509f9ce59$var$shortcut
        }, $caec464509f9ce59$var$downKeyMap),
        isDisabled: isLast,
        onClick: onMoveDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $87411eddeb456868$export$defe85febe8b728c).moveDown))));
};



var $93Axx = parcelRequire("93Axx");

const $d609eeb705f04c19$var$idle = {
    type: 'idle'
};
const $d609eeb705f04c19$var$dragging = {
    type: 'is-dragging'
};
const $d609eeb705f04c19$var$itemContainer = (0, $buxP3.xcss)({
    alignItems: 'flex-start',
    position: 'relative'
});
const $d609eeb705f04c19$var$itemContainerV2 = (0, $buxP3.xcss)({
    alignItems: 'flex-start',
    position: 'relative',
    paddingTop: 'space.200',
    paddingBottom: 'space.200'
});
const $d609eeb705f04c19$var$itemDisabled = (0, $buxP3.xcss)({
    opacity: 0.4
});
const $d609eeb705f04c19$var$itemPreview = (0, $buxP3.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    maxWidth: '360px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $d609eeb705f04c19$var$draggableContent = (0, $buxP3.xcss)({
    width: '100%'
});
const $d609eeb705f04c19$export$f115a0a419405ac5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(49);
    const { item: item, children: children, headerTitle: headerTitle, index: index, isDragHandleFocused: isDragHandleFocused, isFirstItem: isFirstItem, isLastItem: isLastItem, setDraggedItem: setDraggedItem, setIsDragHandleFocused: setIsDragHandleFocused, swapItems: swapItems, shouldUseCardV2UI: shouldUseCardV2UI, onBlur: onBlur, onFocus: onFocus } = t0;
    const ref = (0, $cozmU.useRef)(null);
    const [draggableState, setDraggableState] = (0, $cozmU.useState)($d609eeb705f04c19$var$idle);
    let t1;
    let t2;
    if ($[0] !== index || $[1] !== item || $[2] !== setDraggedItem || $[3] !== setIsDragHandleFocused) {
        t1 = ()=>{
            const element = ref.current;
            (0, $bB0i2.default)(element);
            const data = (0, $93Axx.getItemData)({
                item: item,
                index: index
            });
            return (0, $aDtKq.combine)((0, $iSrRp.draggable)({
                element: element,
                getInitialData: ()=>data,
                onGenerateDragPreview: (t3)=>{
                    const { nativeSetDragImage: nativeSetDragImage } = t3;
                    (0, $cDMxg.setCustomNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage,
                        getOffset: (0, $fYWmN.pointerOutsideOfPreview)({
                            x: "var(--ds-space-200, 16px)",
                            y: "var(--ds-space-100, 8px)"
                        }),
                        render: (t4)=>{
                            const { container: container } = t4;
                            setDraggableState({
                                type: "preview",
                                container: container
                            });
                        }
                    });
                },
                onDragStart: ()=>{
                    setDraggableState($d609eeb705f04c19$var$dragging);
                    setIsDragHandleFocused(false);
                },
                onDrop: ()=>{
                    setDraggableState($d609eeb705f04c19$var$idle);
                    setDraggedItem();
                }
            }), (0, $iSrRp.dropTargetForElements)({
                element: element,
                canDrop: (t5)=>{
                    const { source: source } = t5;
                    if (source.element === element) return false;
                    return (0, $93Axx.isItemData)(source.data);
                },
                getData: (t6)=>{
                    const { input: input } = t6;
                    return (0, $aqP4n.attachClosestEdge)(data, {
                        element: element,
                        input: input,
                        allowedEdges: [
                            "top",
                            "bottom"
                        ]
                    });
                },
                getIsSticky: $d609eeb705f04c19$var$_temp,
                onDragEnter: (t7)=>{
                    const { self: self } = t7;
                    const closestEdge = (0, $aqP4n.extractClosestEdge)(self.data);
                    setDraggableState({
                        type: "is-dragging-over",
                        closestEdge: closestEdge
                    });
                    setIsDragHandleFocused(false);
                },
                onDrag: (t8)=>{
                    const { self: self_0 } = t8;
                    const closestEdge_0 = (0, $aqP4n.extractClosestEdge)(self_0.data);
                    setDraggableState((current)=>{
                        if (current.type === "is-dragging-over" && current.closestEdge === closestEdge_0) return current;
                        return {
                            type: "is-dragging-over",
                            closestEdge: closestEdge_0
                        };
                    });
                },
                onDragLeave: ()=>{
                    setDraggableState($d609eeb705f04c19$var$idle);
                },
                onDrop: ()=>{
                    setDraggableState($d609eeb705f04c19$var$idle);
                    setDraggedItem();
                }
            }));
        };
        t2 = [
            item,
            index,
            setDraggedItem,
            setIsDragHandleFocused
        ];
        $[0] = index;
        $[1] = item;
        $[2] = setDraggedItem;
        $[3] = setIsDragHandleFocused;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const isDragging = draggableState.type === "is-dragging";
    let t3;
    if ($[6] !== setDraggedItem || $[7] !== setIsDragHandleFocused || $[8] !== swapItems) {
        t3 = (sourceIndex, targetIndex)=>{
            setDraggedItem();
            setIsDragHandleFocused(false);
            swapItems(sourceIndex, targetIndex);
        };
        $[6] = setDraggedItem;
        $[7] = setIsDragHandleFocused;
        $[8] = swapItems;
        $[9] = t3;
    } else t3 = $[9];
    const handleMove = t3;
    const t4 = shouldUseCardV2UI ? $d609eeb705f04c19$var$itemContainerV2 : $d609eeb705f04c19$var$itemContainer;
    let t5;
    if ($[10] !== t4) {
        t5 = [
            t4
        ];
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    let t7;
    if ($[12] !== handleMove || $[13] !== index) {
        t6 = ()=>{
            handleMove(index, index + 1);
        };
        t7 = ()=>{
            handleMove(index, index - 1);
        };
        $[12] = handleMove;
        $[13] = index;
        $[14] = t6;
        $[15] = t7;
    } else {
        t6 = $[14];
        t7 = $[15];
    }
    let t8;
    if ($[16] !== isDragHandleFocused || $[17] !== isDragging || $[18] !== isFirstItem || $[19] !== isLastItem || $[20] !== onBlur || $[21] !== onFocus || $[22] !== setIsDragHandleFocused || $[23] !== t6 || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $caec464509f9ce59$export$d87bd93dda5de125), {
            isDragging: isDragging,
            isDragHandleFocused: isDragHandleFocused,
            isFirst: isFirstItem,
            isLast: isLastItem,
            onMoveDown: t6,
            onMoveUp: t7,
            setIsDragHandleFocused: setIsDragHandleFocused,
            onBlur: onBlur,
            onFocus: onFocus
        });
        $[16] = isDragHandleFocused;
        $[17] = isDragging;
        $[18] = isFirstItem;
        $[19] = isLastItem;
        $[20] = onBlur;
        $[21] = onFocus;
        $[22] = setIsDragHandleFocused;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    const t9 = isDragging && $d609eeb705f04c19$var$itemDisabled;
    let t10;
    if ($[26] !== t9) {
        t10 = [
            t9,
            $d609eeb705f04c19$var$draggableContent
        ];
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== children || $[29] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t10
        }, children);
        $[28] = children;
        $[29] = t10;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== draggableState.closestEdge || $[32] !== draggableState.type || $[33] !== shouldUseCardV2UI) {
        t12 = draggableState.type === "is-dragging-over" && draggableState.closestEdge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vZEJe.DropIndicator), {
            edge: draggableState.closestEdge,
            ...!shouldUseCardV2UI && {
                gap: "var(--ds-space-200, 16px)"
            }
        }) : null;
        $[31] = draggableState.closestEdge;
        $[32] = draggableState.type;
        $[33] = shouldUseCardV2UI;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== t11 || $[36] !== t12 || $[37] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            ref: ref,
            alignInline: "start",
            alignBlock: "center",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            alignBlock: "center",
            alignInline: "stretch",
            xcss: $d609eeb705f04c19$var$draggableContent
        }, t8, t11, t12));
        $[35] = t11;
        $[36] = t12;
        $[37] = t8;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== t13 || $[40] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            grow: "fill",
            alignBlock: "stretch",
            xcss: t5
        }, t13);
        $[39] = t13;
        $[40] = t5;
        $[41] = t14;
    } else t14 = $[41];
    let t15;
    if ($[42] !== draggableState.container || $[43] !== draggableState.type || $[44] !== headerTitle) {
        t15 = draggableState.type === "preview" && /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $d609eeb705f04c19$var$itemPreview
        }, headerTitle), draggableState.container);
        $[42] = draggableState.container;
        $[43] = draggableState.type;
        $[44] = headerTitle;
        $[45] = t15;
    } else t15 = $[45];
    let t16;
    if ($[46] !== t14 || $[47] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t14, t15);
        $[46] = t14;
        $[47] = t15;
        $[48] = t16;
    } else t16 = $[48];
    return t16;
} : ({ item: item, children: children, headerTitle: headerTitle, index: index, isDragHandleFocused: isDragHandleFocused, isFirstItem: isFirstItem, isLastItem: isLastItem, setDraggedItem: setDraggedItem, setIsDragHandleFocused: setIsDragHandleFocused, swapItems: swapItems, shouldUseCardV2UI: shouldUseCardV2UI, onBlur: onBlur, onFocus: onFocus })=>{
    const ref = (0, $cozmU.useRef)(null);
    const [draggableState, setDraggableState] = (0, $cozmU.useState)($d609eeb705f04c19$var$idle);
    (0, $cozmU.useEffect)(()=>{
        const element = ref.current;
        (0, $bB0i2.default)(element);
        const data = (0, $93Axx.getItemData)({
            item: item,
            index: index
        });
        return (0, $aDtKq.combine)((0, $iSrRp.draggable)({
            element: element,
            getInitialData: ()=>data,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $cDMxg.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $fYWmN.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render: ({ container: container })=>{
                        setDraggableState({
                            type: 'preview',
                            container: container
                        });
                    }
                });
            },
            onDragStart: ()=>{
                setDraggableState($d609eeb705f04c19$var$dragging);
                setIsDragHandleFocused(false);
            },
            onDrop: ()=>{
                setDraggableState($d609eeb705f04c19$var$idle);
                setDraggedItem();
            }
        }), (0, $iSrRp.dropTargetForElements)({
            element: element,
            canDrop: ({ source: source })=>{
                if (source.element === element) return false;
                return (0, $93Axx.isItemData)(source.data);
            },
            getData: ({ input: input })=>{
                return (0, $aqP4n.attachClosestEdge)(data, {
                    element: element,
                    input: input,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            getIsSticky: ()=>{
                return true;
            },
            onDragEnter: ({ self: self })=>{
                const closestEdge = (0, $aqP4n.extractClosestEdge)(self.data);
                setDraggableState({
                    type: 'is-dragging-over',
                    closestEdge: closestEdge
                });
                setIsDragHandleFocused(false);
            },
            onDrag: ({ self: self_0 })=>{
                const closestEdge_0 = (0, $aqP4n.extractClosestEdge)(self_0.data);
                setDraggableState((current)=>{
                    if (current.type === 'is-dragging-over' && current.closestEdge === closestEdge_0) return current;
                    return {
                        type: 'is-dragging-over',
                        closestEdge: closestEdge_0
                    };
                });
            },
            onDragLeave: ()=>{
                setDraggableState($d609eeb705f04c19$var$idle);
            },
            onDrop: ()=>{
                setDraggableState($d609eeb705f04c19$var$idle);
                setDraggedItem();
            }
        }));
    }, [
        item,
        index,
        setDraggedItem,
        setIsDragHandleFocused
    ]);
    const isDragging = draggableState.type === 'is-dragging';
    const handleMove = (sourceIndex, targetIndex)=>{
        setDraggedItem();
        setIsDragHandleFocused(false);
        swapItems(sourceIndex, targetIndex);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        grow: "fill",
        alignBlock: "stretch",
        xcss: [
            shouldUseCardV2UI ? $d609eeb705f04c19$var$itemContainerV2 : $d609eeb705f04c19$var$itemContainer
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        ref: ref,
        alignInline: "start",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        alignInline: "stretch",
        xcss: $d609eeb705f04c19$var$draggableContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $caec464509f9ce59$export$d87bd93dda5de125), {
        isDragging: isDragging,
        isDragHandleFocused: isDragHandleFocused,
        isFirst: isFirstItem,
        isLast: isLastItem,
        onMoveDown: ()=>{
            handleMove(index, index + 1);
        },
        onMoveUp: ()=>{
            handleMove(index, index - 1);
        },
        setIsDragHandleFocused: setIsDragHandleFocused,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            isDragging && $d609eeb705f04c19$var$itemDisabled,
            $d609eeb705f04c19$var$draggableContent
        ]
    }, children), draggableState.type === 'is-dragging-over' && draggableState.closestEdge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vZEJe.DropIndicator), {
        edge: draggableState.closestEdge,
        ...!shouldUseCardV2UI && {
            gap: "var(--ds-space-200, 16px)"
        }
    }) : null))), draggableState.type === 'preview' && /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $d609eeb705f04c19$var$itemPreview
    }, headerTitle), draggableState.container));
};
function $d609eeb705f04c19$var$_temp() {
    return true;
}





const $d6c56dc21d4c3778$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    collapseCardLabel: {
        id: "company-hub.company-hub-common.link-cards.card.collapse.label",
        defaultMessage: "Collapse card"
    },
    expandCardLabel: {
        id: "company-hub.company-hub-common.link-cards.card.expand.label",
        defaultMessage: "Expand card"
    },
    removeCardLabel: {
        id: "company-hub.company-hub-common.link-cards.card.remove.card.label",
        defaultMessage: "Remove card"
    },
    cardTitle: {
        id: "company-hub.company-hub-common.link-cards.card.title",
        defaultMessage: "Card {order}"
    },
    // Items can be referred to as "cards" (link cards extension) or "frames" (carousel v2)
    collapseItemLabel: {
        id: "company-hub.company-hub-common.shared-components.item.collapse.label",
        defaultMessage: "{itemLabel, select, card {Collapse card} frame {Collapse frame} other {Collapse card}}"
    },
    expandItemLabel: {
        id: "company-hub.company-hub-common.shared-components.item.expand.label",
        defaultMessage: "{itemLabel, select, card {Expand card} frame {Expand frame} other {Expand card}}"
    },
    removeItemLabel: {
        id: "company-hub.company-hub-common.shared-components.item.remove.label",
        defaultMessage: "{itemLabel, select, card {Remove card} frame {Remove frame} other {Remove card}}"
    },
    itemTitle: {
        id: "company-hub.company-hub-common.shared-components.item.title",
        defaultMessage: "{itemLabel, select, card {Card {order}} frame {Frame {order}} other {Card {order}}}"
    }
});


var $f2176a45f0d6d27c$export$2bc99c3a07d4b9fd = /*#__PURE__*/ function(ITEM_LABEL) {
    ITEM_LABEL["CARD"] = "card";
    ITEM_LABEL["FRAME"] = "frame";
    return ITEM_LABEL;
}({});
const $f2176a45f0d6d27c$var$iconColors = {
    hoverActive: "var(--ds-icon-danger, #C9372C)",
    default: "var(--ds-icon-subtle, #505258)",
    disabled: "var(--ds-text-disabled, #080F214A)"
};
const $f2176a45f0d6d27c$var$removeActiveStyles = (0, $buxP3.xcss)({
    ':hover': {
        background: "var(--ds-background-danger, #FFECEB)",
        color: 'color.text.danger'
    },
    ':focus': {
        background: "var(--ds-background-danger, #FFECEB)",
        color: 'color.text.danger'
    }
});
const $f2176a45f0d6d27c$var$removeButtonStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    borderRadius: 'radius.small',
    display: 'flex',
    height: '32px',
    justifyContent: 'center'
});
const $f2176a45f0d6d27c$var$dragHandleFocusedWrapperStyles = (0, $buxP3.xcss)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
});
const $f2176a45f0d6d27c$var$removeHoveredWrapperStyles = (0, $buxP3.xcss)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-danger, #E2483D)"}`
});
const $f2176a45f0d6d27c$var$collapsibleStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    outline: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $f2176a45f0d6d27c$var$collapsibleStylesV2 = (0, $buxP3.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $f2176a45f0d6d27c$var$collapsibleTriggerStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.0',
    paddingRight: 'space.200',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    ':focus': {
        borderRadius: 'radius.small'
    },
    width: '100%'
});
const $f2176a45f0d6d27c$var$collapsibleTriggerStylesV2 = (0, $buxP3.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    width: '100%'
});
const $f2176a45f0d6d27c$var$collapsibleContentStyles = (0, $buxP3.xcss)({
    width: '100%',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    paddingTop: 'space.050',
    paddingBottom: 'space.150'
});
const $f2176a45f0d6d27c$var$collapsibleContentStylesV2 = (0, $buxP3.xcss)({
    width: '100%',
    paddingLeft: 'space.050',
    paddingRight: 'space.0',
    paddingTop: 'space.050',
    paddingBottom: 'space.150'
});
const $f2176a45f0d6d27c$export$6d08773d2e66f8f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(89);
    const { actionSubjectIdPostFix: actionSubjectIdPostFix, analyticsSource: analyticsSource, itemParameters: itemParameters, canDeleteItem: t1, isDeleteDisabled: isDeleteDisabled, isExpanded: isExpanded, isFirstItem: isFirstItem, isLastItem: isLastItem, onBlur: onBlur, onFocus: onFocus, order: order, removeItem: removeItem, setDraggedItem: setDraggedItem, setExpandedItem: setExpandedItem, swapItems: swapItems, shouldUseCardV2UI: t2, itemLabel: t3, renderItemContent: renderItemContent } = t0;
    const canDeleteItem = t1 === undefined ? true : t1;
    const shouldUseCardV2UI = t2 === undefined ? false : t2;
    const itemLabel = t3 === undefined ? "card" : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const itemRef = (0, $cozmU.useRef)(null);
    const [t4, t5] = (0, $bIp5p.useExtensionsState)();
    const { isInAutoFocusMode: isInAutoFocusMode, selectedToRemoveCardId: selectedToRemoveCardId } = t4;
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToRemoveCardId: setSelectedToRemoveCardId } = t5;
    const CollapsedCardIcon = shouldUseCardV2UI ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const { cardId: cardId, title: title } = itemParameters;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isItemDisabled = (0, $9vJye.useIsDisabledContext)();
    let t6;
    if ($[0] !== actionSubjectIdPostFix || $[1] !== analyticsSource || $[2] !== cardId || $[3] !== createAnalyticsEvent || $[4] !== removeItem) {
        t6 = ()=>{
            removeItem(cardId);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: `delete${actionSubjectIdPostFix}`,
                    source: analyticsSource
                }
            }).fire();
        };
        $[0] = actionSubjectIdPostFix;
        $[1] = analyticsSource;
        $[2] = cardId;
        $[3] = createAnalyticsEvent;
        $[4] = removeItem;
        $[5] = t6;
    } else t6 = $[5];
    const onRemove = t6;
    const isSelectedToRemove = selectedToRemoveCardId === cardId;
    let removeButtonColor;
    if (isDeleteDisabled || isItemDisabled) removeButtonColor = $f2176a45f0d6d27c$var$iconColors.disabled;
    else if (isSelectedToRemove) removeButtonColor = $f2176a45f0d6d27c$var$iconColors.hoverActive;
    else removeButtonColor = $f2176a45f0d6d27c$var$iconColors.default;
    const [isDragHandleFocused, setIsDragHandleFocused] = (0, $cozmU.useState)(false);
    const isRemoveDisabled = isDeleteDisabled || isItemDisabled;
    let t7;
    if ($[6] !== cardId || $[7] !== isRemoveDisabled || $[8] !== setSelectedToRemoveCardId) {
        t7 = ()=>{
            !isRemoveDisabled && setSelectedToRemoveCardId(cardId);
        };
        $[6] = cardId;
        $[7] = isRemoveDisabled;
        $[8] = setSelectedToRemoveCardId;
        $[9] = t7;
    } else t7 = $[9];
    const selectItemToRemove = t7;
    let t8;
    if ($[10] !== setSelectedToRemoveCardId) {
        t8 = ()=>{
            setSelectedToRemoveCardId(null);
        };
        $[10] = setSelectedToRemoveCardId;
        $[11] = t8;
    } else t8 = $[11];
    const unselectItemToRemove = t8;
    let t9;
    if ($[12] !== isRemoveDisabled || $[13] !== onRemove || $[14] !== selectItemToRemove || $[15] !== unselectItemToRemove) {
        t9 = {
            isDisabled: isRemoveDisabled,
            onClick: onRemove,
            onMouseOver: selectItemToRemove,
            onFocus: selectItemToRemove,
            onMouseOut: unselectItemToRemove,
            onBlur: unselectItemToRemove
        };
        $[12] = isRemoveDisabled;
        $[13] = onRemove;
        $[14] = selectItemToRemove;
        $[15] = unselectItemToRemove;
        $[16] = t9;
    } else t9 = $[16];
    const removeItemProps = t9;
    let t10;
    if ($[17] !== analyticsSource || $[18] !== cardId || $[19] !== createAnalyticsEvent || $[20] !== isExpanded || $[21] !== setExpandedItem || $[22] !== setIsInAutoFocusMode) {
        t10 = ()=>{
            setIsInAutoFocusMode(true);
            setExpandedItem(isExpanded ? "" : cardId);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: isExpanded ? "collapsed" : "expanded",
                    actionSubject: "card",
                    actionSubjectId: "cardCollapsible",
                    source: analyticsSource
                }
            }).fire();
        };
        $[17] = analyticsSource;
        $[18] = cardId;
        $[19] = createAnalyticsEvent;
        $[20] = isExpanded;
        $[21] = setExpandedItem;
        $[22] = setIsInAutoFocusMode;
        $[23] = t10;
    } else t10 = $[23];
    const onCollapsibleTriggerClick = t10;
    let t11;
    let t12;
    if ($[24] !== isExpanded || $[25] !== isInAutoFocusMode) {
        t11 = ()=>{
            if (isExpanded && itemRef.current && isInAutoFocusMode) itemRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        };
        t12 = [
            isExpanded,
            itemRef,
            isInAutoFocusMode
        ];
        $[24] = isExpanded;
        $[25] = isInAutoFocusMode;
        $[26] = t11;
        $[27] = t12;
    } else {
        t11 = $[26];
        t12 = $[27];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let collapseLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).collapseCardLabel;
    let expandLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).expandCardLabel;
    let removeLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).removeCardLabel;
    let t13;
    if ($[28] !== formatMessage || $[29] !== order) {
        t13 = formatMessage((0, $d6c56dc21d4c3778$export$defe85febe8b728c).cardTitle, {
            order: order
        });
        $[28] = formatMessage;
        $[29] = order;
        $[30] = t13;
    } else t13 = $[30];
    let headerTitle = t13;
    if (itemLabel === "frame") {
        collapseLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).collapseItemLabel;
        expandLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).expandItemLabel;
        removeLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).removeItemLabel;
        let t14;
        if ($[31] !== formatMessage || $[32] !== itemLabel || $[33] !== order) {
            t14 = formatMessage((0, $d6c56dc21d4c3778$export$defe85febe8b728c).itemTitle, {
                itemLabel: itemLabel,
                order: order
            });
            $[31] = formatMessage;
            $[32] = itemLabel;
            $[33] = order;
            $[34] = t14;
        } else t14 = $[34];
        headerTitle = t14;
    }
    headerTitle = title || headerTitle;
    const t14 = shouldUseCardV2UI ? $f2176a45f0d6d27c$var$collapsibleStylesV2 : $f2176a45f0d6d27c$var$collapsibleStyles;
    const t15 = isSelectedToRemove && !isRemoveDisabled && !shouldUseCardV2UI ? $f2176a45f0d6d27c$var$removeHoveredWrapperStyles : isDragHandleFocused && $f2176a45f0d6d27c$var$dragHandleFocusedWrapperStyles;
    let t16;
    if ($[35] !== t14 || $[36] !== t15) {
        t16 = [
            t14,
            t15
        ];
        $[35] = t14;
        $[36] = t15;
        $[37] = t16;
    } else t16 = $[37];
    const t17 = order - 1;
    const t18 = shouldUseCardV2UI ? $f2176a45f0d6d27c$var$collapsibleTriggerStylesV2 : $f2176a45f0d6d27c$var$collapsibleTriggerStyles;
    let t19;
    if ($[38] !== t18) {
        t19 = [
            t18
        ];
        $[38] = t18;
        $[39] = t19;
    } else t19 = $[39];
    const t20 = shouldUseCardV2UI ? "medium" : undefined;
    const t21 = shouldUseCardV2UI ? "semibold" : undefined;
    let t22;
    if ($[40] !== headerTitle || $[41] !== t20 || $[42] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            color: "color.text",
            size: t20,
            weight: t21,
            maxLines: 1
        }, headerTitle);
        $[40] = headerTitle;
        $[41] = t20;
        $[42] = t21;
        $[43] = t22;
    } else t22 = $[43];
    let t23;
    if ($[44] !== CollapsedCardIcon || $[45] !== collapseLabel || $[46] !== expandLabel || $[47] !== formatMessage || $[48] !== isExpanded) {
        t23 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            color: "var(--ds-text-subtle, #505258)",
            label: formatMessage(collapseLabel),
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CollapsedCardIcon, {
            color: "var(--ds-text-subtle, #505258)",
            label: formatMessage(expandLabel),
            size: "small"
        });
        $[44] = CollapsedCardIcon;
        $[45] = collapseLabel;
        $[46] = expandLabel;
        $[47] = formatMessage;
        $[48] = isExpanded;
        $[49] = t23;
    } else t23 = $[49];
    let t24;
    if ($[50] !== t22 || $[51] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            alignBlock: "center",
            spread: "space-between",
            space: "space.050"
        }, t22, t23);
        $[50] = t22;
        $[51] = t23;
        $[52] = t24;
    } else t24 = $[52];
    let t25;
    if ($[53] !== onBlur || $[54] !== onCollapsibleTriggerClick || $[55] !== onFocus || $[56] !== t19 || $[57] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            onClick: onCollapsibleTriggerClick,
            onBlur: onBlur,
            onFocus: onFocus,
            backgroundColor: "color.background.neutral.subtle",
            xcss: t19
        }, t24);
        $[53] = onBlur;
        $[54] = onCollapsibleTriggerClick;
        $[55] = onFocus;
        $[56] = t19;
        $[57] = t24;
        $[58] = t25;
    } else t25 = $[58];
    let t26;
    if ($[59] !== headerTitle || $[60] !== isDragHandleFocused || $[61] !== isFirstItem || $[62] !== isLastItem || $[63] !== itemParameters || $[64] !== onBlur || $[65] !== onFocus || $[66] !== setDraggedItem || $[67] !== shouldUseCardV2UI || $[68] !== swapItems || $[69] !== t17 || $[70] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d609eeb705f04c19$export$f115a0a419405ac5), {
            index: t17,
            item: itemParameters,
            headerTitle: headerTitle,
            isDragHandleFocused: isDragHandleFocused,
            isFirstItem: isFirstItem,
            isLastItem: isLastItem,
            setDraggedItem: setDraggedItem,
            setIsDragHandleFocused: setIsDragHandleFocused,
            swapItems: swapItems,
            shouldUseCardV2UI: shouldUseCardV2UI,
            onFocus: onFocus,
            onBlur: onBlur
        }, t25);
        $[59] = headerTitle;
        $[60] = isDragHandleFocused;
        $[61] = isFirstItem;
        $[62] = isLastItem;
        $[63] = itemParameters;
        $[64] = onBlur;
        $[65] = onFocus;
        $[66] = setDraggedItem;
        $[67] = shouldUseCardV2UI;
        $[68] = swapItems;
        $[69] = t17;
        $[70] = t25;
        $[71] = t26;
    } else t26 = $[71];
    let t27;
    if ($[72] !== canDeleteItem || $[73] !== formatMessage || $[74] !== isExpanded || $[75] !== isItemDisabled || $[76] !== isRemoveDisabled || $[77] !== itemLabel || $[78] !== itemParameters || $[79] !== removeButtonColor || $[80] !== removeItemProps || $[81] !== removeLabel || $[82] !== renderItemContent || $[83] !== shouldUseCardV2UI) {
        t27 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            direction: "column",
            xcss: [
                shouldUseCardV2UI ? $f2176a45f0d6d27c$var$collapsibleContentStylesV2 : $f2176a45f0d6d27c$var$collapsibleContentStyles
            ],
            testId: "item-content"
        }, renderItemContent(itemParameters, isItemDisabled), canDeleteItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            ...removeItemProps,
            xcss: [
                $f2176a45f0d6d27c$var$removeButtonStyles,
                !isRemoveDisabled && $f2176a45f0d6d27c$var$removeActiveStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            columnGap: "space.050",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            color: removeButtonColor,
            label: formatMessage(removeLabel, {
                itemLabel: itemLabel
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...removeLabel,
            values: {
                itemLabel: itemLabel
            }
        }))));
        $[72] = canDeleteItem;
        $[73] = formatMessage;
        $[74] = isExpanded;
        $[75] = isItemDisabled;
        $[76] = isRemoveDisabled;
        $[77] = itemLabel;
        $[78] = itemParameters;
        $[79] = removeButtonColor;
        $[80] = removeItemProps;
        $[81] = removeLabel;
        $[82] = renderItemContent;
        $[83] = shouldUseCardV2UI;
        $[84] = t27;
    } else t27 = $[84];
    let t28;
    if ($[85] !== t16 || $[86] !== t26 || $[87] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            xcss: t16,
            testId: "item-wrapper",
            ref: itemRef,
            grow: "fill",
            alignBlock: "center",
            alignInline: "start"
        }, t26, t27);
        $[85] = t16;
        $[86] = t26;
        $[87] = t27;
        $[88] = t28;
    } else t28 = $[88];
    return t28;
} : ({ actionSubjectIdPostFix: actionSubjectIdPostFix, analyticsSource: analyticsSource, itemParameters: itemParameters, canDeleteItem: canDeleteItem = true, isDeleteDisabled: isDeleteDisabled, isExpanded: isExpanded, isFirstItem: isFirstItem, isLastItem: isLastItem, onBlur: onBlur, onFocus: onFocus, order: order, removeItem: removeItem, setDraggedItem: setDraggedItem, setExpandedItem: setExpandedItem, swapItems: swapItems, shouldUseCardV2UI: shouldUseCardV2UI = false, itemLabel: itemLabel = "card", renderItemContent: renderItemContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const itemRef = (0, $cozmU.useRef)(null);
    const [{ isInAutoFocusMode: isInAutoFocusMode, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToRemoveCardId: setSelectedToRemoveCardId }] = (0, $bIp5p.useExtensionsState)();
    const CollapsedCardIcon = shouldUseCardV2UI ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const { cardId: cardId, title: title } = itemParameters;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isItemDisabled = (0, $9vJye.useIsDisabledContext)();
    const onRemove = (0, $cozmU.useCallback)(()=>{
        removeItem(cardId);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `delete${actionSubjectIdPostFix}`,
                source: analyticsSource
            }
        }).fire();
    }, [
        cardId,
        removeItem,
        createAnalyticsEvent,
        analyticsSource,
        actionSubjectIdPostFix
    ]);
    const isSelectedToRemove = selectedToRemoveCardId === cardId;
    let removeButtonColor;
    if (isDeleteDisabled || isItemDisabled) removeButtonColor = $f2176a45f0d6d27c$var$iconColors.disabled;
    else if (isSelectedToRemove) removeButtonColor = $f2176a45f0d6d27c$var$iconColors.hoverActive;
    else removeButtonColor = $f2176a45f0d6d27c$var$iconColors.default;
    const [isDragHandleFocused, setIsDragHandleFocused] = (0, $cozmU.useState)(false);
    const isRemoveDisabled = isDeleteDisabled || isItemDisabled;
    const selectItemToRemove = (0, $cozmU.useCallback)(()=>{
        !isRemoveDisabled && setSelectedToRemoveCardId(cardId);
    }, [
        isRemoveDisabled,
        cardId,
        setSelectedToRemoveCardId
    ]);
    const unselectItemToRemove = (0, $cozmU.useCallback)(()=>{
        setSelectedToRemoveCardId(null);
    }, [
        setSelectedToRemoveCardId
    ]);
    const removeItemProps = {
        isDisabled: isRemoveDisabled,
        onClick: onRemove,
        onMouseOver: selectItemToRemove,
        onFocus: selectItemToRemove,
        onMouseOut: unselectItemToRemove,
        onBlur: unselectItemToRemove
    };
    const onCollapsibleTriggerClick = ()=>{
        setIsInAutoFocusMode(true);
        setExpandedItem(isExpanded ? '' : cardId);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: isExpanded ? 'collapsed' : 'expanded',
                actionSubject: 'card',
                actionSubjectId: 'cardCollapsible',
                source: analyticsSource
            }
        }).fire();
    };
    (0, $cozmU.useEffect)(()=>{
        if (isExpanded && itemRef.current && isInAutoFocusMode) itemRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, [
        isExpanded,
        itemRef,
        isInAutoFocusMode
    ]);
    let collapseLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).collapseCardLabel, expandLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).expandCardLabel, removeLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).removeCardLabel, headerTitle = formatMessage((0, $d6c56dc21d4c3778$export$defe85febe8b728c).cardTitle, {
        order: order
    });
    if (itemLabel === "frame") {
        // @TODO, switch over to these messages unconditionally once
        // translations are available. The itemLabel context
        // is provided for correct string selection.
        collapseLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).collapseItemLabel;
        expandLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).expandItemLabel;
        removeLabel = (0, $d6c56dc21d4c3778$export$defe85febe8b728c).removeItemLabel;
        headerTitle = formatMessage((0, $d6c56dc21d4c3778$export$defe85febe8b728c).itemTitle, {
            itemLabel: itemLabel,
            order: order
        });
    }
    headerTitle = title || headerTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: [
            shouldUseCardV2UI ? $f2176a45f0d6d27c$var$collapsibleStylesV2 : $f2176a45f0d6d27c$var$collapsibleStyles,
            isSelectedToRemove && !isRemoveDisabled && !shouldUseCardV2UI ? $f2176a45f0d6d27c$var$removeHoveredWrapperStyles : isDragHandleFocused && $f2176a45f0d6d27c$var$dragHandleFocusedWrapperStyles
        ],
        testId: "item-wrapper",
        ref: itemRef,
        grow: "fill",
        alignBlock: "center",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d609eeb705f04c19$export$f115a0a419405ac5), {
        index: order - 1,
        item: itemParameters,
        headerTitle: headerTitle,
        isDragHandleFocused: isDragHandleFocused,
        isFirstItem: isFirstItem,
        isLastItem: isLastItem,
        setDraggedItem: setDraggedItem,
        setIsDragHandleFocused: setIsDragHandleFocused,
        swapItems: swapItems,
        shouldUseCardV2UI: shouldUseCardV2UI,
        onFocus: onFocus,
        onBlur: onBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        onClick: onCollapsibleTriggerClick,
        onBlur: onBlur,
        onFocus: onFocus,
        backgroundColor: "color.background.neutral.subtle",
        xcss: [
            shouldUseCardV2UI ? $f2176a45f0d6d27c$var$collapsibleTriggerStylesV2 : $f2176a45f0d6d27c$var$collapsibleTriggerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text",
        size: shouldUseCardV2UI ? 'medium' : undefined,
        weight: shouldUseCardV2UI ? 'semibold' : undefined,
        maxLines: 1
    }, headerTitle), isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
        color: "var(--ds-text-subtle, #505258)",
        label: formatMessage(collapseLabel),
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CollapsedCardIcon, {
        color: "var(--ds-text-subtle, #505258)",
        label: formatMessage(expandLabel),
        size: "small"
    })))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        xcss: [
            shouldUseCardV2UI ? $f2176a45f0d6d27c$var$collapsibleContentStylesV2 : $f2176a45f0d6d27c$var$collapsibleContentStyles
        ],
        testId: "item-content"
    }, renderItemContent(itemParameters, isItemDisabled), canDeleteItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        ...removeItemProps,
        xcss: [
            $f2176a45f0d6d27c$var$removeButtonStyles,
            !isRemoveDisabled && $f2176a45f0d6d27c$var$removeActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        columnGap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
        color: removeButtonColor,
        label: formatMessage(removeLabel, {
            itemLabel: itemLabel
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...removeLabel,
        values: {
            itemLabel: itemLabel
        }
    })))));
};
module.exports["ITEM_LABEL"] = $f2176a45f0d6d27c$export$2bc99c3a07d4b9fd;
module.exports["Item"] = $f2176a45f0d6d27c$export$6d08773d2e66f8f2;

});

parcelRegister("5eKkh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cfM7x = parcelRequire("cfM7x");


var $iaYF8 = parcelRequire("iaYF8");


var $3vLBh = parcelRequire("3vLBh");

const $1417113c4b4f9bae$export$549037637b109d47 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (items)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [initialUnsplashResults, setInitialUnsplashResults] = (0, $cozmU.useState)(t0);
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[1] !== initialUnsplashResults?.length || $[2] !== submitError) {
        t1 = ()=>{
            if (initialUnsplashResults?.length === 0) (0, $3vLBh.getUnsplashPhotos)((0, $iaYF8.DEFAULT_UNSPLASH_QUERY_WORD), 1, submitError).then((result)=>{
                setInitialUnsplashResults(result);
            }).catch((_error)=>{
                setInitialUnsplashResults(undefined);
            });
        };
        $[1] = initialUnsplashResults?.length;
        $[2] = submitError;
        $[3] = t1;
    } else t1 = $[3];
    const loadInitialUnsplashResults = t1;
    let t2;
    if ($[4] !== items?.length || $[5] !== loadInitialUnsplashResults) {
        t2 = ()=>{
            if (items?.length > 0) loadInitialUnsplashResults();
        };
        $[4] = items?.length;
        $[5] = loadInitialUnsplashResults;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== items || $[8] !== loadInitialUnsplashResults) {
        t3 = [
            loadInitialUnsplashResults,
            items
        ];
        $[7] = items;
        $[8] = loadInitialUnsplashResults;
        $[9] = t3;
    } else t3 = $[9];
    (0, $cozmU.useEffect)(t2, t3);
    return initialUnsplashResults;
} : (items)=>{
    const [initialUnsplashResults, setInitialUnsplashResults] = (0, $cozmU.useState)([]);
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const loadInitialUnsplashResults = (0, $cozmU.useCallback)(()=>{
        if (initialUnsplashResults?.length === 0) (0, $3vLBh.getUnsplashPhotos)((0, $iaYF8.DEFAULT_UNSPLASH_QUERY_WORD), 1, submitError).then((result)=>{
            setInitialUnsplashResults(result);
        }).catch((_error)=>{
            setInitialUnsplashResults(undefined);
        });
    }, [
        initialUnsplashResults,
        setInitialUnsplashResults,
        submitError
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (items?.length > 0) loadInitialUnsplashResults();
    }, [
        loadInitialUnsplashResults,
        items
    ]);
    return initialUnsplashResults;
};
module.exports["useInitialUnsplashResults"] = $1417113c4b4f9bae$export$549037637b109d47;

});

parcelRegister("4ZnIz", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $3ricL = parcelRequire("3ricL");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $w6R6I = parcelRequire("w6R6I");


var $2ot3O = parcelRequire("2ot3O");


var $24dy7 = parcelRequire("24dy7");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $ieeJu = parcelRequire("ieeJu");


var $6QFPB = parcelRequire("6QFPB");


var $hjUDQ = parcelRequire("hjUDQ");


var $jT39w = parcelRequire("jT39w");




const $5b73f32fd61870f1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    imageLabel: {
        id: "company-hub.company-hub-common.link-cards.card.image.section.label",
        defaultMessage: "Image"
    },
    aiGenerationErrorFlagTitle: {
        id: "company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.title",
        defaultMessage: "We couldn't generate your image"
    },
    aiGenerationErrorFlagDescription: {
        id: "company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.description",
        defaultMessage: "Try again or choose a different image."
    },
    aiGenerationErrorFlagDescriptionWithReason: {
        id: "company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.description-with-reason",
        defaultMessage: "{errorReason}. Try again or choose a different image."
    }
});


const $8343ab33332a5366$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION = 'cc_page_experiences_premium_macros_img_generation';
const $8343ab33332a5366$var$styles = {
    fieldWrapper: "_19pkpxbi"
};
const $8343ab33332a5366$export$d8d17c714ce39824 = ({ analyticsSource: analyticsSource, itemId: itemId, contentId: contentId, imageSrc: imageSrc, imageAltText: imageAltText, updateItemFormField: updateItemFormField, shouldAllowLinkFromUrl: shouldAllowLinkFromUrl = false })=>{
    // Gate the Premium Extensions image generation experiment behind the
    // `confluence-ai` feature so that AI-related UI is suppressed for IC
    // (Isolated Cloud) tenants where Confluence AI is not available.
    const isAiImgGenEnabled = (0, $ieeJu.expValEquals)($8343ab33332a5366$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, 'isEnabled', true) && (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    const { generateImage: generateImage, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, error: aiHeaderImageError } = (0, $6QFPB.useCompanyHubImageGeneration)({
        contentId: contentId
    });
    const { showFlag: showFlag } = (0, $2ot3O.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isAiHeaderImageLoading = (aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW') && !aiHeaderImageFileId; // Fire an analytics event when an AI-generated header image has been
    // produced successfully. We fire once per generation by tracking when
    // `aiHeaderImageFileId` transitions from falsy to truthy. Mirrors the
    // `headerImageAdded` analytics fired by Confluence's
    // EditorPageCoverPicture.handleAIGeneratedUpload, but adapted for the
    // company hub config panel.
    const prevAIHeaderImageFileIdRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!isAiImgGenEnabled) {
            prevAIHeaderImageFileIdRef.current = aiHeaderImageFileId;
            return;
        }
        const prevFileId = prevAIHeaderImageFileIdRef.current;
        const isNewFileId = !prevFileId && !!aiHeaderImageFileId;
        prevAIHeaderImageFileIdRef.current = aiHeaderImageFileId;
        if (!isNewFileId) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'added',
                actionSubject: 'image',
                actionSubjectId: 'companyHubImageAdded',
                source: analyticsSource,
                attributes: {
                    imageSource: 'aiGenerated',
                    imageId: aiHeaderImageFileId,
                    inputMethod: 'configPanel',
                    aiHeaderImageStatus: aiHeaderImageStatus,
                    isAIImgGenEnabled: isAiImgGenEnabled
                }
            }
        }).fire();
    }, [
        aiHeaderImageFileId,
        aiHeaderImageStatus,
        isAiImgGenEnabled,
        createAnalyticsEvent,
        analyticsSource
    ]);
    // Surface a flag to the user when AI image generation fails. We only fire
    // when the status transitions INTO `ERROR` (mirroring the Confluence header
    // image behaviour in EditorPageCoverPicture) so re-renders while already in
    // the error state don't produce duplicate flags.
    //
    // Each fire uses a unique flag `id` so that consecutive failures STACK in
    // the flag tray (matching the Confluence header image behaviour) rather
    // than replacing the previous flag — ADS `useFlags` dedupes by `id`.
    const prevAIHeaderImageStatusRef = (0, $cozmU.useRef)(null);
    const aiGenerationErrorFlagCounterRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        if (!isAiImgGenEnabled) {
            prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
            return;
        }
        const prevStatus = prevAIHeaderImageStatusRef.current;
        const isTransitioningToError = prevStatus !== 'ERROR' && aiHeaderImageStatus === 'ERROR';
        prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
        if (!isTransitioningToError) return;
        const description = aiHeaderImageError ? formatMessage((0, $5b73f32fd61870f1$export$defe85febe8b728c).aiGenerationErrorFlagDescriptionWithReason, {
            errorReason: aiHeaderImageError
        }) : formatMessage((0, $5b73f32fd61870f1$export$defe85febe8b728c).aiGenerationErrorFlagDescription);
        aiGenerationErrorFlagCounterRef.current += 1;
        showFlag({
            id: `company-hub-image-field-ai-generation-error-flag-${aiGenerationErrorFlagCounterRef.current}`,
            title: formatMessage((0, $5b73f32fd61870f1$export$defe85febe8b728c).aiGenerationErrorFlagTitle),
            description: description,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        });
    }, [
        aiHeaderImageStatus,
        aiHeaderImageError,
        isAiImgGenEnabled,
        showFlag,
        formatMessage
    ]);
    const generateImageRef = (0, $cozmU.useRef)(generateImage);
    generateImageRef.current = generateImage;
    const generateAndApplyImage = (0, $cozmU.useCallback)(async (props)=>{
        const mediaFileId = await generateImageRef.current(props);
        if (mediaFileId) updateItemFormField(itemId, {
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_SRC]: mediaFileId,
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_ALT_TEXT]: ''
        });
        return mediaFileId;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        itemId,
        updateItemFormField
    ]);
    const handleChangeImage = (0, $cozmU.useCallback)((props)=>{
        const newImageSrc = 'fullSizeImageUrl' in props ? props.fullSizeImageUrl : props.uploadedImageId;
        const newAltText = props.altDescription;
        updateItemFormField(itemId, {
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_SRC]: newImageSrc,
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_ALT_TEXT]: newAltText
        });
    }, [
        itemId,
        updateItemFormField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($8343ab33332a5366$var$styles.fieldWrapper),
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center",
        testId: "image-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5b73f32fd61870f1$export$defe85febe8b728c).imageLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jT39w.MediaPickerSection), {
        shouldAllowLinkFromUrl: shouldAllowLinkFromUrl,
        contentId: contentId,
        image: imageSrc ? {
            imageSrc: imageSrc,
            altText: imageAltText
        } : undefined,
        onChangeImage: handleChangeImage,
        analyticsSource: analyticsSource,
        shouldShowDeleteButton: true,
        generateAIHeaderImage: isAiImgGenEnabled ? generateAndApplyImage : undefined,
        isAiHeaderImageLoading: isAiImgGenEnabled ? isAiHeaderImageLoading : false
    })));
};
module.exports["ImageField"] = $8343ab33332a5366$export$d8d17c714ce39824;

});

parcelRegister("6QFPB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $iDrrr = parcelRequire("iDrrr");


var $6SMAs = parcelRequire("6SMAs");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $ieeJu = parcelRequire("ieeJu");


var $aYC8J = parcelRequire("aYC8J");


var $iF7Yl = parcelRequire("iF7Yl");


var $lJ6db = parcelRequire("lJ6db");


var $lSM29 = parcelRequire("lSM29");

const $d4322024ea497cb0$var$PRODUCT = 'confluence';
const $d4322024ea497cb0$var$unwrapStreamMessage = (value)=>{
    if (typeof value === 'object' && value !== null && '__isSSEWrapper' in value && value.__isSSEWrapper === true && 'data' in value) return value.data;
    return value;
};
const $d4322024ea497cb0$var$getGeneratedMediaFileId = async (generator)=>{
    for await (const value of generator){
        const streamMessage = $d4322024ea497cb0$var$unwrapStreamMessage(value);
        if (streamMessage.type === 'ERROR') throw new Error(streamMessage.message?.content ?? 'Remix image generation failed');
        if (streamMessage.type === 'FINAL_RESPONSE') {
            const imageAction = streamMessage.message?.message?.actions?.find((action)=>action.key === (0, $aYC8J.IMAGE_CREATE_KEY));
            if (!(0, $aYC8J.isImageCreateData)(imageAction?.data)) throw new Error('Remix did not return a generated image');
            return imageAction.data.mediaFileId;
        }
    }
    throw new Error('Remix image generation ended without a response');
};
const $d4322024ea497cb0$var$useRemixImageGenerationWithAssistanceService = ({ contentId: contentId, createEditorMediaProvider: createEditorMediaProvider, userId: userId, assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const [aiHeaderImageStatus, setAIHeaderImageStatus] = (0, $cozmU.useState)('NOT_LOADING');
    const [aiHeaderImageFileId, setAIHeaderImageFileId] = (0, $cozmU.useState)();
    const [error, setError] = (0, $cozmU.useState)(null);
    const activeAbortControllerRef = (0, $cozmU.useRef)();
    const generationSequenceRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>()=>{
            activeAbortControllerRef.current?.abort();
        }, []);
    const uploadGeneratedImage = (0, $cozmU.useCallback)(async (mediaFileId)=>{
        if (!userId) throw new Error('Cannot upload a Remix image without a user ID');
        if (!createEditorMediaProvider) throw new Error('Cannot upload a Remix image without an editor media provider');
        const mediaProvider = await createEditorMediaProvider({
            contentId: contentId,
            contentType: 'page',
            isExternalShare: false
        });
        const targetCollection = mediaProvider.uploadParams?.collection;
        if (!mediaProvider.uploadMediaClientConfig || !targetCollection) throw new Error('Editor media provider is missing upload configuration');
        const { token: token, collection: collection } = await (0, $iF7Yl.fetchMauiPersonalReadToken)($d4322024ea497cb0$var$PRODUCT);
        const sourceUrl = (0, $aYC8J.buildImageUrl)({
            fileId: mediaFileId,
            token: token.split('Bearer ')[1],
            collection: collection,
            clientId: userId,
            isStaging: (0, $lSM29.isStaging)()
        });
        const mediaClient = (0, $g9ZnD.getMediaClient)(mediaProvider.uploadMediaClientConfig);
        const result = await mediaClient.file.uploadExternal(sourceUrl, targetCollection, undefined, true);
        return result.uploadableFileUpfrontIds.id;
    }, [
        contentId,
        createEditorMediaProvider,
        userId
    ]);
    const generateImage = (0, $cozmU.useCallback)(async ({ adfContent: adfContent, aspectRatio: aspectRatio, showAcceptanceFlow: showAcceptanceFlow = false, theme: theme })=>{
        activeAbortControllerRef.current?.abort();
        const generationSequence = ++generationSequenceRef.current;
        const conversationId = crypto.randomUUID();
        const abortController = new AbortController();
        activeAbortControllerRef.current = abortController;
        setAIHeaderImageFileId(undefined);
        setError(null);
        setAIHeaderImageStatus(showAcceptanceFlow ? 'LOADING_WITH_ACCEPTANCE_FLOW' : 'LOADING');
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: adfContent
                        }
                    ]
                }
            ]
        };
        const dynamicUiSource = {
            contentType: 'page',
            startLocalId: '',
            endLocalId: '',
            startIndex: 0,
            endIndex: -1,
            fragmentAdf: prompt.content,
            fullAdf: prompt
        };
        try {
            const creationContext = {
                dynamicUiType: 'image',
                dynamicUiSubtype: theme ?? 'image',
                dynamicUiSource: dynamicUiSource,
                source: 'remix',
                isStagingArea: true,
                productKey: $d4322024ea497cb0$var$PRODUCT,
                isViewMode: false,
                ...(0, $ieeJu.expValEquals)('rovo_remix_experience_context', 'isEnabled', true) ? {
                    experience: 'remix',
                    blocks: [
                        'image'
                    ]
                } : {},
                ...aspectRatio ? {
                    additionalContext: {
                        aspectRatio: aspectRatio
                    }
                } : {}
            };
            const { generator: generator } = await assistanceService.sendMessageStream({
                message: prompt,
                conversationId: conversationId,
                controller: abortController,
                storeMessage: false,
                citationsEnabled: true,
                optInSSEStream: true,
                additionalContext: {
                    creationContext: creationContext,
                    userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
                }
            });
            const temporaryMediaFileId = await $d4322024ea497cb0$var$getGeneratedMediaFileId(generator);
            const generatedImageId = await uploadGeneratedImage(temporaryMediaFileId);
            if (generationSequence === generationSequenceRef.current) {
                setAIHeaderImageFileId(generatedImageId);
                setAIHeaderImageStatus('SUCCESSFULLY_SET');
            }
            return generatedImageId;
        } catch (generationError) {
            if (generationSequence === generationSequenceRef.current) {
                const message = generationError instanceof Error ? generationError.message : 'Unknown error occurred';
                setError(message);
                setAIHeaderImageStatus('ERROR');
            }
            return undefined;
        } finally{
            if (activeAbortControllerRef.current === abortController) activeAbortControllerRef.current = undefined;
        }
    }, [
        assistanceService,
        uploadGeneratedImage
    ]);
    return {
        generateImage: generateImage,
        loading: aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW',
        error: error,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: aiHeaderImageFileId
    };
};
const $d4322024ea497cb0$var$useRemixImageGenerationWithService = (0, $lJ6db.createHookWithAssistanceService)($d4322024ea497cb0$var$useRemixImageGenerationWithAssistanceService);
const $d4322024ea497cb0$export$1b9537157fec4b30 = (props)=>$d4322024ea497cb0$var$useRemixImageGenerationWithService({
        ...props,
        assistanceServiceParams: {
            product: $d4322024ea497cb0$var$PRODUCT,
            experienceId: 'ai-mate',
            siteId: props.cloudId,
            touchpointSource: 'company-hub-image-generation'
        }
    });



var $cfM7x = parcelRequire("cfM7x");

const $0466b22b78088fb5$export$630d7d50d9331d91 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { contentId: contentId } = t0;
    const { cloudId: cloudId, createEditorMediaProvider: createEditorMediaProvider, userId: userId } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const legacyImageGeneration = (0, $6SMAs.useAIGeneratedCoverImage)(t1);
    let t2;
    if ($[2] !== cloudId || $[3] !== contentId || $[4] !== createEditorMediaProvider || $[5] !== userId) {
        t2 = {
            cloudId: cloudId,
            contentId: contentId,
            createEditorMediaProvider: createEditorMediaProvider,
            userId: userId
        };
        $[2] = cloudId;
        $[3] = contentId;
        $[4] = createEditorMediaProvider;
        $[5] = userId;
        $[6] = t2;
    } else t2 = $[6];
    const remixImageGeneration = (0, $d4322024ea497cb0$export$1b9537157fec4b30)(t2);
    if ((0, $iDrrr.fg)("company_hub_migrate_image_gen_to_remix")) return remixImageGeneration;
    let t3;
    if ($[7] !== legacyImageGeneration.aiHeaderImageFileId || $[8] !== legacyImageGeneration.aiHeaderImageStatus || $[9] !== legacyImageGeneration.error || $[10] !== legacyImageGeneration.generateImage) {
        t3 = {
            generateImage: legacyImageGeneration.generateImage,
            aiHeaderImageStatus: legacyImageGeneration.aiHeaderImageStatus,
            aiHeaderImageFileId: legacyImageGeneration.aiHeaderImageFileId,
            error: legacyImageGeneration.error
        };
        $[7] = legacyImageGeneration.aiHeaderImageFileId;
        $[8] = legacyImageGeneration.aiHeaderImageStatus;
        $[9] = legacyImageGeneration.error;
        $[10] = legacyImageGeneration.generateImage;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ contentId: contentId })=>{
    const { cloudId: cloudId, createEditorMediaProvider: createEditorMediaProvider, userId: userId } = (0, $cfM7x.useProductDependencies)();
    const legacyImageGeneration = (0, $6SMAs.useAIGeneratedCoverImage)({
        contentId: contentId
    });
    const remixImageGeneration = (0, $d4322024ea497cb0$export$1b9537157fec4b30)({
        cloudId: cloudId,
        contentId: contentId,
        createEditorMediaProvider: createEditorMediaProvider,
        userId: userId
    });
    if ((0, $iDrrr.fg)('company_hub_migrate_image_gen_to_remix')) return remixImageGeneration;
    return {
        generateImage: legacyImageGeneration.generateImage,
        aiHeaderImageStatus: legacyImageGeneration.aiHeaderImageStatus,
        aiHeaderImageFileId: legacyImageGeneration.aiHeaderImageFileId,
        error: legacyImageGeneration.error
    };
};
module.exports["useCompanyHubImageGeneration"] = $0466b22b78088fb5$export$630d7d50d9331d91;

});

parcelRegister("jT39w", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ricL = parcelRequire("3ricL");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $7sJoX = parcelRequire("7sJoX");


var $6NvYG = parcelRequire("6NvYG");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");











var $9DHhW = parcelRequire("9DHhW");




var $1sCHt = parcelRequire("1sCHt");


var $kB5K2 = parcelRequire("kB5K2");


var $iDfTs = parcelRequire("iDfTs");


var $bh4C9 = parcelRequire("bh4C9");


var $cJ0FD = parcelRequire("cJ0FD");


var $5ZJRm = parcelRequire("5ZJRm");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");





var $e70Gu = parcelRequire("e70Gu");

var $1411d1fa72b4739a$exports = {};
$1411d1fa72b4739a$exports = new URL("DefaultUploadImageBackground.144fddae.jpg", import.meta.url).toString();



var $5KFAG = parcelRequire("5KFAG");


var $hgxhy = parcelRequire("hgxhy");


var $4ZwXK = parcelRequire("4ZwXK");











var $55fM8 = parcelRequire("55fM8");








var $eKMV3 = parcelRequire("eKMV3");


var $7BfeF = parcelRequire("7BfeF");


var $4bg4c = parcelRequire("4bg4c");


var $kTb7m = parcelRequire("kTb7m");


var $chu6R = parcelRequire("chu6R");




var $4ez2K = parcelRequire("4ez2K");


var $4yg9g = parcelRequire("4yg9g");


var $eI3GM = parcelRequire("eI3GM");


var $iMYjN = parcelRequire("iMYjN");




const $3dccbff7d591b974$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    buttonText: {
        id: "company-hub.common.media-components.unsplash.unsplash-browser.button.text",
        defaultMessage: "Browse unsplash"
    },
    errorText: {
        id: "company-hub.common.media-components.unsplash.unsplash-browser.error.text",
        defaultMessage: "We had trouble accessing this link. Try again."
    },
    inspirationText: {
        id: "company-hub.common.media-components.media-picker.ui.content.inspiration.text",
        defaultMessage: "Need inspiration?"
    },
    placeholderText: {
        id: "company-hub.common.media-components.media-picker.ui.content.placeholder.text",
        defaultMessage: "Add link from URL"
    }
});


const $f0e2e292d87d08c5$var$styles = {
    elemBeforeInput: "_19bvu2gc",
    elemAfterInput: "_u5f3u2gc"
};
const $f0e2e292d87d08c5$export$31a366db97ea3a6a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { currentUrl: currentUrl, analyticsSource: analyticsSource, handleImageSelection: handleImageSelection, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isFileId = Boolean(currentUrl?.match(/([0-9a-fA-F-]{36})/));
    const showCustomUploadedImage = !!currentUrl && isFileId;
    const [url, setUrl] = (0, $cozmU.useState)(showCustomUploadedImage ? "" : currentUrl);
    const [isValidImage, setIsValidImage] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(false);
    let t2;
    if ($[0] !== analyticsSource || $[1] !== createAnalyticsEvent || $[2] !== handleImageSelection) {
        const validateUrl = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(async (urlToValidate)=>{
            const trimmedUrl = urlToValidate.trim();
            if (!trimmedUrl) {
                setError(false);
                setIsValidImage(false);
                return;
            }
            if (!(0, $iMYjN.isValidUrl)(trimmedUrl)) {
                setError(true);
                setIsValidImage(false);
                return;
            }
            const normalizedUrl = (0, $iMYjN.normalizeUrl)(trimmedUrl);
            const isImage = await (0, $iMYjN.isImageURL)(normalizedUrl);
            if (!isImage) {
                setError(true);
                setIsValidImage(false);
                return;
            }
            handleImageSelection({
                fullSizeImageUrl: normalizedUrl,
                altDescription: ""
            });
            setError(false);
            setIsValidImage(true);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "entered",
                    actionSubject: "url",
                    source: analyticsSource,
                    attributes: {
                        imageSource: "BrowseButtonAndLinkInput"
                    }
                }
            }).fire();
        }, 300);
        t2 = (e)=>{
            const newUrl = e.currentTarget.value;
            setUrl(newUrl);
            validateUrl(newUrl);
        };
        $[0] = analyticsSource;
        $[1] = createAnalyticsEvent;
        $[2] = handleImageSelection;
        $[3] = t2;
    } else t2 = $[3];
    const handleUrlInput = t2;
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage((0, $3dccbff7d591b974$export$defe85febe8b728c).placeholderText);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f0e2e292d87d08c5$var$styles.elemBeforeInput
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }));
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isValidImage) {
        t5 = isValidImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f0e2e292d87d08c5$var$styles.elemAfterInput
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            spacing: "spacious",
            label: "valid",
            color: "var(--ds-icon-success, #6A9A23)"
        })) : undefined;
        $[7] = isValidImage;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== handleUrlInput || $[10] !== isDisabled || $[11] !== t3 || $[12] !== t5 || $[13] !== url) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            isDisabled: isDisabled,
            onChange: handleUrlInput,
            placeholder: t3,
            elemBeforeInput: t4,
            elemAfterInput: t5,
            value: url
        });
        $[9] = handleUrlInput;
        $[10] = isDisabled;
        $[11] = t3;
        $[12] = t5;
        $[13] = url;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== error) {
        t7 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3dccbff7d591b974$export$defe85febe8b728c).errorText));
        $[15] = error;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3dccbff7d591b974$export$defe85febe8b728c).inspirationText);
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== isDisabled) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eI3GM.MediaContentHelperMessage), {
            isDisabled: isDisabled,
            helperMessage: t8
        });
        $[18] = isDisabled;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.100",
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3dccbff7d591b974$export$defe85febe8b728c).buttonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4bg4c))), {
            label: "",
            size: "small"
        }));
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== isDisabled) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "default",
            href: "https://unsplash.com",
            isDisabled: isDisabled,
            rel: "noopener noreferrer",
            shouldFitContainer: true,
            target: "_blank"
        }, t10);
        $[21] = isDisabled;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t11 || $[24] !== t6 || $[25] !== t7 || $[26] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t6, t7, t9, t11);
        $[23] = t11;
        $[24] = t6;
        $[25] = t7;
        $[26] = t9;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
} : ({ currentUrl: currentUrl, analyticsSource: analyticsSource, handleImageSelection: handleImageSelection, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isFileId = Boolean(currentUrl?.match(/([0-9a-fA-F-]{36})/));
    const showCustomUploadedImage = !!currentUrl && isFileId;
    const [url, setUrl] = (0, $cozmU.useState)(showCustomUploadedImage ? '' : currentUrl);
    const [isValidImage, setIsValidImage] = (0, $cozmU.useState)(false); // TODO: submit to error monitoring service once we find CSM use for this
    const [error, setError] = (0, $cozmU.useState)(false);
    const validateUrl = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(async (urlToValidate)=>{
        const trimmedUrl = urlToValidate.trim();
        if (!trimmedUrl) {
            setError(false);
            setIsValidImage(false);
            return;
        }
        if (!(0, $iMYjN.isValidUrl)(trimmedUrl)) {
            setError(true);
            setIsValidImage(false);
            return;
        }
        const normalizedUrl = (0, $iMYjN.normalizeUrl)(trimmedUrl);
        const isImage = await (0, $iMYjN.isImageURL)(normalizedUrl);
        if (!isImage) {
            setError(true);
            setIsValidImage(false);
            return;
        }
        handleImageSelection({
            fullSizeImageUrl: normalizedUrl,
            altDescription: ''
        });
        setError(false);
        setIsValidImage(true);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'entered',
                actionSubject: 'url',
                source: analyticsSource,
                attributes: {
                    imageSource: 'BrowseButtonAndLinkInput'
                }
            }
        }).fire();
    }, 300);
    const handleUrlInput = (e)=>{
        const newUrl = e.currentTarget.value;
        setUrl(newUrl);
        validateUrl(newUrl);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        isDisabled: isDisabled,
        onChange: handleUrlInput,
        placeholder: formatMessage((0, $3dccbff7d591b974$export$defe85febe8b728c).placeholderText),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f0e2e292d87d08c5$var$styles.elemBeforeInput
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            color: "var(--ds-icon, #292A2E)",
            label: ""
        })),
        elemAfterInput: isValidImage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f0e2e292d87d08c5$var$styles.elemAfterInput
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            spacing: "spacious",
            label: "valid",
            color: "var(--ds-icon-success, #6A9A23)"
        })) : undefined,
        value: url
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3dccbff7d591b974$export$defe85febe8b728c).errorText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eI3GM.MediaContentHelperMessage), {
        isDisabled: isDisabled,
        helperMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3dccbff7d591b974$export$defe85febe8b728c).inspirationText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "default",
        href: "https://unsplash.com",
        isDisabled: isDisabled,
        rel: "noopener noreferrer",
        shouldFitContainer: true,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3dccbff7d591b974$export$defe85febe8b728c).buttonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4bg4c))), {
        label: "",
        size: "small"
    }))));
};



var $3qXic = parcelRequire("3qXic");


var $k8b3h = parcelRequire("k8b3h");


var $619Qo = parcelRequire("619Qo");

var $iBGZJ = parcelRequire("iBGZJ");


var $9YAKX = parcelRequire("9YAKX");










const $5c631d219f74f053$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    fileUploadButtonText: {
        id: "company-hub.company-hub-common.unsplash.upload.text",
        defaultMessage: "Upload"
    },
    deleteImageButtonText: {
        id: "company-hub.company-hub-common.unsplash.delete.image.text",
        defaultMessage: "Remove image"
    },
    defaultBackgroundImageAltText: {
        id: "company-hub.company-hub-common.unsplash.background-img.default.label",
        defaultMessage: "Default background image for upload previewer"
    }
});


const $b0899eb66af91ad6$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION = 'cc_page_experiences_premium_macros_img_generation';
const $b0899eb66af91ad6$var$bottomSpacing = (0, $buxP3.xcss)({
    marginBottom: 'space.100'
});
const $b0899eb66af91ad6$var$removeBottomSpacing = (0, $buxP3.xcss)({
    marginBottom: 'space.0'
});
const $b0899eb66af91ad6$var$uploadFileContainer = (0, $buxP3.xcss)({
    position: 'relative',
    borderRadius: 'radius.large',
    height: '124px',
    width: '100%',
    marginBottom: 'space.100',
    overflow: 'hidden'
});
const $b0899eb66af91ad6$var$uploadFileButton = (0, $buxP3.xcss)({
    position: 'absolute',
    left: '30%',
    right: '30%',
    bottom: '30%',
    top: '30%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $b0899eb66af91ad6$export$d96ef1145be738e0 = ({ itemId: itemId, elementIdPrefix: elementIdPrefix, sectionLabel: sectionLabel, imageAltText: imageAltText, selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults, handleImageSelection: handleImageSelection, contentId: contentId, confluencePageId: confluencePageId, analyticsSource: analyticsSource, isPageTitleComponent: isPageTitleComponent = false, isNoImageAllowed: isNoImageAllowed = false, enableBottomSpacing: enableBottomSpacing = true, placement: placement, dropdownPopupComponentRef: dropdownPopupComponentRef, isDisabled: isDisabled = false, isAiHeaderImageLoading: isAiHeaderImageLoading, helperMessage: helperMessage, shouldShowDeleteButton: shouldShowDeleteButton = false, customMediaConfig: customMediaConfig, shouldAllowLinkFromUrl: shouldAllowLinkFromUrl = false, generateAIHeaderImage: generateAIHeaderImage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { selectedDefaultImageUrl: selectedDefaultImageUrl, setDefaultUnsplashResults: setDefaultUnsplashResults, defaultUnsplashResults: defaultUnsplashResults, unSplashSearchResults: unSplashSearchResults, setUnsplashSearchResults: setUnsplashSearchResults, setError: setError, handleError: handleError, errorMessage: errorMessage } = (0, $iBGZJ.useUnsplash)(isPageTitleComponent, selectedImageUrl, initialUnsplashResults);
    const [newUploadedImage, setNewUploadedImage] = (0, $cozmU.useState)();
    const handleUploadedImage = (0, $cozmU.useCallback)((props)=>{
        setNewUploadedImage(()=>props);
        handleImageSelection(props);
    }, [
        handleImageSelection
    ]);
    const handleAIGenerate = (0, $cozmU.useCallback)(async (props_0)=>{
        if (!generateAIHeaderImage) return undefined;
        const mediaFileId = await generateAIHeaderImage(props_0);
        if (mediaFileId) // Mirror the manual upload path so the picker's local state
        // (newUploadedImage) reflects each new AI-generated image,
        // preventing stale renders on re-generation.
        handleUploadedImage({
            uploadedImageId: mediaFileId,
            altDescription: ''
        });
        return mediaFileId;
    }, [
        generateAIHeaderImage,
        handleUploadedImage
    ]);
    const handleDelete = ()=>{
        setNewUploadedImage(undefined);
        handleImageSelection({
            fullSizeImageUrl: '',
            altDescription: ''
        });
    };
    const { showCustomUploadedImage: showCustomUploadedImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: newUploadedImage ? newUploadedImage?.uploadedImageId : selectedDefaultImageUrl || undefined
    });
    const selectedDefaultUploadedImage = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (!selectedDefaultUploadedImage.current && !newUploadedImage && showCustomUploadedImage) selectedDefaultUploadedImage.current = selectedDefaultImageUrl;
    }, [
        newUploadedImage,
        showCustomUploadedImage,
        selectedDefaultImageUrl
    ]);
    const customMediaAuthProvider = (0, $cozmU.useMemo)(()=>{
        if (!customMediaConfig) return undefined;
        return ()=>Promise.resolve({
                token: customMediaConfig.mediaToken,
                baseUrl: customMediaConfig.mediaUrl,
                asapIssuer: customMediaConfig.asapIssuer
            });
    }, [
        customMediaConfig
    ]);
    const { mediaConfig: mediaConfig, handleUploadEnd: handleUploadEnd, handleUploadStart: handleUploadStart, handleOnError: handleOnError, isMediaBrowserOpen: isMediaBrowserOpen, openMediaBrowser: openMediaBrowser, closeMediaBrowser: closeMediaBrowser, isUploadingImage: isUploadingImage } = (0, $9YAKX.useUploadMediaConfig)({
        contentId: contentId,
        handleUploadedImageSelection: handleUploadedImage,
        analyticsSource: analyticsSource
    });
    const resolvedCollectionName = (0, $cozmU.useMemo)(()=>{
        if (customMediaConfig) return customMediaConfig.mediaCollectionName;
        return mediaConfig?.collection;
    }, [
        customMediaConfig,
        mediaConfig
    ]);
    const resolvedAuthProvider = (0, $cozmU.useMemo)(()=>{
        return customMediaConfig ? customMediaAuthProvider : mediaConfig?.authProvider;
    }, [
        customMediaConfig,
        customMediaAuthProvider,
        mediaConfig
    ]);
    const canOpenBrowser = Boolean(resolvedCollectionName && resolvedAuthProvider && openMediaBrowser);
    const handleUploadButtonClick = (0, $cozmU.useCallback)(()=>{
        if (!canOpenBrowser) return;
        openMediaBrowser();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'customerImageUploadButton',
                source: analyticsSource
            }
        }).fire();
    }, [
        canOpenBrowser,
        openMediaBrowser,
        createAnalyticsEvent,
        analyticsSource
    ]);
    const unsplashSearchFieldId = itemId ? `${elementIdPrefix}-search-unsplash-${itemId}` : `${elementIdPrefix}-search-unsplash`;
    const initialUnsplashFive = (0, $cozmU.useMemo)(()=>defaultUnsplashResults?.slice(0, 5), [
        defaultUnsplashResults
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: unsplashSearchFieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), null, sectionLabel)), shouldShowDeleteButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $5c631d219f74f053$export$defe85febe8b728c).deleteImageButtonText),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        onClick: handleDelete,
        isDisabled: isDisabled,
        testId: "remove-image-button"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eI3GM.MediaContentHelperMessage), {
        isDisabled: isDisabled,
        helperMessage: helperMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b0899eb66af91ad6$var$uploadFileContainer
    }, showCustomUploadedImage && !(0, $619Qo.isUnsplashImage)(selectedImageUrl) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        testId: "custom-image-upload"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ZwXK.CustomImageUploadRenderer), {
        contentId: contentId,
        imageAltText: imageAltText,
        imageSrc: newUploadedImage?.uploadedImageId || selectedDefaultUploadedImage.current,
        mediaConfigOverride: {
            authProvider: customMediaAuthProvider,
            collection: customMediaConfig?.mediaCollectionName
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        height: "124px",
        width: "100%",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1411d1fa72b4739a$exports))),
        alt: formatMessage((0, $5c631d219f74f053$export$defe85febe8b728c).defaultBackgroundImageAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b0899eb66af91ad6$var$uploadFileButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleUploadButtonClick,
        isDisabled: isUploadingImage || isDisabled || !canOpenBrowser,
        testId: "open-media-browser",
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bh4C9)))
    }, formatMessage((0, $5c631d219f74f053$export$defe85febe8b728c).fileUploadButtonText)))), resolvedCollectionName && resolvedAuthProvider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZJRm.BrowserLoader), {
        mediaClientConfig: {
            authProvider: resolvedAuthProvider,
            useSha256ForUploads: true
        },
        config: {
            multiple: false,
            fileExtensions: [
                '.jpg',
                '.jpeg',
                '.png',
                '.gif'
            ],
            uploadParams: {
                collection: resolvedCollectionName,
                onUploadRejection: mediaConfig?.onUploadRejection
            }
        },
        isOpen: isMediaBrowserOpen,
        onClose: closeMediaBrowser,
        onUploadsStart: handleUploadStart,
        onError: handleOnError,
        onEnd: handleUploadEnd
    }), shouldAllowLinkFromUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0e2e292d87d08c5$export$31a366db97ea3a6a), {
        analyticsSource: analyticsSource,
        currentUrl: selectedDefaultImageUrl,
        handleImageSelection: handleImageSelection,
        isDisabled: isDisabled
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k8b3h.UnsplashSearchBar), {
        elementIdPrefix: elementIdPrefix,
        unsplashSearchFieldId: unsplashSearchFieldId,
        handleImageSelection: handleImageSelection,
        analyticsSource: analyticsSource,
        setDefaultUnsplashResults: setDefaultUnsplashResults,
        defaultUnsplashResults: defaultUnsplashResults,
        unSplashSearchResults: unSplashSearchResults,
        setUnsplashSearchResults: setUnsplashSearchResults,
        setError: setError,
        handleError: handleError,
        placement: placement,
        dropdownPopupComponentRef: dropdownPopupComponentRef,
        isUploadingImage: isUploadingImage || isDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: enableBottomSpacing ? $b0899eb66af91ad6$var$bottomSpacing : $b0899eb66af91ad6$var$removeBottomSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qXic.DefaultImagePicker), {
        contentId: contentId,
        confluencePageId: confluencePageId,
        initialUnsplashResults: initialUnsplashFive,
        handleImageSelection: handleImageSelection,
        imageAltText: imageAltText,
        previewUploadedImageId: newUploadedImage?.uploadedImageId,
        initialUploadedImageId: selectedDefaultUploadedImage.current,
        selectedImageUrl: selectedDefaultImageUrl,
        analyticsSource: analyticsSource,
        isUploadingImage: isUploadingImage || isDisabled,
        isNoImageAllowed: isNoImageAllowed && !isPageTitleComponent,
        mediaConfigOverride: {
            authProvider: customMediaAuthProvider,
            collection: customMediaConfig?.mediaCollectionName
        }
    }), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5KFAG.FormFieldErrorMessage), null, errorMessage))), (0, $ieeJu.expValEquals)($b0899eb66af91ad6$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, 'isEnabled', true) && (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e70Gu.RovoHeaderImageGenerator), {
        generateAIHeaderImage: generateAIHeaderImage ? handleAIGenerate : undefined,
        isAiHeaderImageLoading: isAiHeaderImageLoading,
        onSubmit: ({ selectedTheme: selectedTheme })=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'companyHubImageGenerationSubmitted',
                    source: analyticsSource,
                    attributes: {
                        selectedTheme: selectedTheme
                    }
                }
            }).fire();
        }
    }));
};





const $a8840b4154db3b69$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    mediaPickerContentTitle: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.media-picker-content-title",
        defaultMessage: "Media"
    },
    mediaPickerButtonLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.media-picker-button-label",
        defaultMessage: "Choose media"
    },
    mediaPickerContentHelperMessage: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.mdia-picker-helper-message",
        defaultMessage: "Choose high resolution images 1200px or wider for best results."
    }
});


const $ab4764849846dbec$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION = 'cc_page_experiences_premium_macros_img_generation';
const $ab4764849846dbec$var$styles = {
    mediaPickerPopupContainer: "_1bsbncxg _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
const $ab4764849846dbec$export$b119da8ecc7e9645 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { onChangeImage: onChangeImage, image: image, contentId: contentId, analyticsSource: analyticsSource, shouldShowDeleteButton: t1, onOpenUpdate: onOpenUpdate, isDisabled: t2, isAiHeaderImageLoading: isAiHeaderImageLoading, customMediaConfig: customMediaConfig, shouldAllowLinkFromUrl: t3, generateAIHeaderImage: generateAIHeaderImage } = t0;
    const shouldShowDeleteButton = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const shouldAllowLinkFromUrl = t3 === undefined ? false : t3;
    const [openPopup, setOpenPopup] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t4;
    if ($[0] !== onOpenUpdate) {
        t4 = (open)=>{
            setOpenPopup(open);
            onOpenUpdate?.(open);
        };
        $[0] = onOpenUpdate;
        $[1] = t4;
    } else t4 = $[1];
    const handleSetOpenPopup = t4;
    const isPremiumImgGenerationEnabled = (0, $ieeJu.expValEquals)($ab4764849846dbec$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, "isEnabled", true) && (0, $3ricL.isFeatureEnabled)("confluence", "confluence-ai");
    const popupPlacement = isPremiumImgGenerationEnabled ? "top-end" : "bottom-end";
    let t5;
    if ($[2] !== handleSetOpenPopup) {
        t5 = ()=>handleSetOpenPopup(false);
        $[2] = handleSetOpenPopup;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== analyticsSource || $[5] !== contentId || $[6] !== customMediaConfig || $[7] !== generateAIHeaderImage || $[8] !== image?.altText || $[9] !== image?.imageSrc || $[10] !== isAiHeaderImageLoading || $[11] !== isDisabled || $[12] !== onChangeImage || $[13] !== shouldAllowLinkFromUrl || $[14] !== shouldShowDeleteButton) {
        t6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $ab4764849846dbec$var$styles.mediaPickerPopupContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0899eb66af91ad6$export$d96ef1145be738e0), {
                elementIdPrefix: `${analyticsSource}-media-picker`,
                sectionLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a8840b4154db3b69$export$defe85febe8b728c).mediaPickerContentTitle),
                imageAltText: image?.altText,
                selectedImageUrl: image?.imageSrc,
                initialUnsplashResults: undefined,
                handleImageSelection: onChangeImage,
                contentId: contentId,
                analyticsSource: analyticsSource,
                helperMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a8840b4154db3b69$export$defe85febe8b728c).mediaPickerContentHelperMessage),
                shouldShowDeleteButton: shouldShowDeleteButton,
                isDisabled: isDisabled,
                customMediaConfig: customMediaConfig,
                shouldAllowLinkFromUrl: shouldAllowLinkFromUrl,
                generateAIHeaderImage: generateAIHeaderImage,
                isAiHeaderImageLoading: isAiHeaderImageLoading
            }));
        $[4] = analyticsSource;
        $[5] = contentId;
        $[6] = customMediaConfig;
        $[7] = generateAIHeaderImage;
        $[8] = image?.altText;
        $[9] = image?.imageSrc;
        $[10] = isAiHeaderImageLoading;
        $[11] = isDisabled;
        $[12] = onChangeImage;
        $[13] = shouldAllowLinkFromUrl;
        $[14] = shouldShowDeleteButton;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== analyticsSource || $[17] !== formatMessage || $[18] !== handleSetOpenPopup || $[19] !== openPopup) {
        t7 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                analyticsContext: {
                    source: `${analyticsSource}MediaPickerButton`
                },
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6NvYG))),
                iconAfter: $ab4764849846dbec$var$_temp,
                onClick: ()=>handleSetOpenPopup(!openPopup),
                "aria-label": formatMessage((0, $a8840b4154db3b69$export$defe85febe8b728c).mediaPickerButtonLabel),
                isSelected: openPopup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null));
        $[16] = analyticsSource;
        $[17] = formatMessage;
        $[18] = handleSetOpenPopup;
        $[19] = openPopup;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== openPopup || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
            isOpen: openPopup,
            onClose: t5,
            content: t6,
            placement: popupPlacement,
            trigger: t7
        });
        $[21] = openPopup;
        $[22] = t5;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : ({ onChangeImage: onChangeImage, image: image, contentId: contentId, analyticsSource: analyticsSource, shouldShowDeleteButton: shouldShowDeleteButton = false, onOpenUpdate: onOpenUpdate, isDisabled: isDisabled = false, isAiHeaderImageLoading: isAiHeaderImageLoading, customMediaConfig: customMediaConfig, shouldAllowLinkFromUrl: shouldAllowLinkFromUrl = false, generateAIHeaderImage: generateAIHeaderImage })=>{
    const [openPopup, setOpenPopup] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleSetOpenPopup = (open)=>{
        setOpenPopup(open);
        onOpenUpdate?.(open);
    }; // When the Premium Extensions image generation experiment is enabled, the
    // media picker popup should always render above the trigger button. This
    // prevents the panel from being clipped by, or obscuring, content rendered
    // below the trigger in the Company Hub configuration UI.
    // Also gated behind the `confluence-ai` feature so that AI-related UI is
    // suppressed for IC (Isolated Cloud) tenants where Confluence AI is not
    // available.
    const isPremiumImgGenerationEnabled = (0, $ieeJu.expValEquals)($ab4764849846dbec$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, 'isEnabled', true) && (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    const popupPlacement = isPremiumImgGenerationEnabled ? 'top-end' : 'bottom-end';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        isOpen: openPopup,
        onClose: ()=>handleSetOpenPopup(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $ab4764849846dbec$var$styles.mediaPickerPopupContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b0899eb66af91ad6$export$d96ef1145be738e0), {
                elementIdPrefix: `${analyticsSource}-media-picker`,
                sectionLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a8840b4154db3b69$export$defe85febe8b728c).mediaPickerContentTitle),
                imageAltText: image?.altText,
                selectedImageUrl: image?.imageSrc,
                initialUnsplashResults: undefined,
                handleImageSelection: onChangeImage,
                contentId: contentId,
                analyticsSource: analyticsSource,
                helperMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a8840b4154db3b69$export$defe85febe8b728c).mediaPickerContentHelperMessage),
                shouldShowDeleteButton: shouldShowDeleteButton,
                isDisabled: isDisabled,
                customMediaConfig: customMediaConfig,
                shouldAllowLinkFromUrl: shouldAllowLinkFromUrl,
                generateAIHeaderImage: generateAIHeaderImage,
                isAiHeaderImageLoading: isAiHeaderImageLoading
            })),
        placement: popupPlacement,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                analyticsContext: {
                    source: `${analyticsSource}MediaPickerButton`
                },
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6NvYG))),
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: ()=>handleSetOpenPopup(!openPopup),
                "aria-label": formatMessage((0, $a8840b4154db3b69$export$defe85febe8b728c).mediaPickerButtonLabel),
                isSelected: openPopup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null))
    });
};
function $ab4764849846dbec$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["MediaPickerSection"] = $ab4764849846dbec$export$b119da8ecc7e9645;

});

parcelRegister("cImA8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $5ZJRm = parcelRequire("5ZJRm");


var $4ez2K = parcelRequire("4ez2K");


var $hjUDQ = parcelRequire("hjUDQ");


var $eLJUB = parcelRequire("eLJUB");

var $9YAKX = parcelRequire("9YAKX");




const $f9eeb347a2561a2a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    sectionLabel: {
        id: "company-hub.company-hub-common.link-cards.card.image.section.label",
        defaultMessage: "Image"
    }
});


const $4ffd702626f44752$var$styles = {
    fieldWrapper: "_19pkpxbi"
};
const $4ffd702626f44752$export$47c17c5f362608ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { analyticsSource: analyticsSource, idPrefix: idPrefix, itemId: itemId, confluencePageId: confluencePageId, contentId: contentId, imageSrc: imageSrc, imageAltText: imageAltText, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, updateItemFormField: updateItemFormField } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== itemId || $[1] !== updateItemFormField) {
        t1 = (t2)=>{
            const { fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription } = t2;
            updateItemFormField(itemId, {
                [(0, $hjUDQ.ITEM_FIELDS).IMAGE_SRC]: fullSizeImageUrl,
                [(0, $hjUDQ.ITEM_FIELDS).IMAGE_ALT_TEXT]: altDescription
            });
        };
        $[0] = itemId;
        $[1] = updateItemFormField;
        $[2] = t1;
    } else t1 = $[2];
    const handleUnsplashImageSelection = t1;
    let t2;
    if ($[3] !== itemId || $[4] !== updateItemFormField) {
        t2 = (t3)=>{
            const { uploadedImageId: uploadedImageId, altDescription: altDescription_0 } = t3;
            updateItemFormField(itemId, {
                [(0, $hjUDQ.ITEM_FIELDS).IMAGE_SRC]: uploadedImageId,
                [(0, $hjUDQ.ITEM_FIELDS).IMAGE_ALT_TEXT]: altDescription_0
            });
        };
        $[3] = itemId;
        $[4] = updateItemFormField;
        $[5] = t2;
    } else t2 = $[5];
    const handleUploadedImageSelection = t2;
    let t3;
    if ($[6] !== analyticsSource || $[7] !== contentId || $[8] !== handleUploadedImageSelection) {
        t3 = {
            contentId: contentId,
            handleUploadedImageSelection: handleUploadedImageSelection,
            analyticsSource: analyticsSource
        };
        $[6] = analyticsSource;
        $[7] = contentId;
        $[8] = handleUploadedImageSelection;
        $[9] = t3;
    } else t3 = $[9];
    const { mediaConfig: mediaConfig, handleUploadEnd: handleUploadEnd, handleUploadStart: handleUploadStart, handleOnError: handleOnError, isMediaBrowserOpen: isMediaBrowserOpen, openMediaBrowser: openMediaBrowser, closeMediaBrowser: closeMediaBrowser, isUploadingImage: isUploadingImage } = (0, $9YAKX.useUploadMediaConfig)(t3);
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $w6R6I.cx)($4ffd702626f44752$var$styles.fieldWrapper);
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== intl) {
        t5 = intl.formatMessage((0, $f9eeb347a2561a2a$export$defe85febe8b728c).sectionLabel);
        $[11] = intl;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== analyticsSource || $[14] !== confluencePageId || $[15] !== contentId || $[16] !== handleUnsplashImageSelection || $[17] !== idPrefix || $[18] !== imageAltText || $[19] !== imageSrc || $[20] !== initialUnsplashResults || $[21] !== isNoImageAllowed || $[22] !== isUploadingImage || $[23] !== itemId || $[24] !== openMediaBrowser || $[25] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eLJUB.UnsplashSearch), {
            id: itemId,
            selectedImageUrl: imageSrc,
            imageAltText: imageAltText,
            sectionLabel: t5,
            initialUnsplashResults: initialUnsplashResults,
            idPrefix: idPrefix,
            handleImageSelection: handleUnsplashImageSelection,
            analyticsSource: analyticsSource,
            analyticsActionSubject: "button",
            analyticsActionSubjectId: "customerImageUpload",
            openMediaBrowser: openMediaBrowser,
            contentId: contentId,
            confluencePageId: confluencePageId,
            isUploadingImage: isUploadingImage,
            isNoImageAllowed: isNoImageAllowed
        });
        $[13] = analyticsSource;
        $[14] = confluencePageId;
        $[15] = contentId;
        $[16] = handleUnsplashImageSelection;
        $[17] = idPrefix;
        $[18] = imageAltText;
        $[19] = imageSrc;
        $[20] = initialUnsplashResults;
        $[21] = isNoImageAllowed;
        $[22] = isUploadingImage;
        $[23] = itemId;
        $[24] = openMediaBrowser;
        $[25] = t5;
        $[26] = t6;
    } else t6 = $[26];
    let t7;
    if ($[27] !== closeMediaBrowser || $[28] !== handleOnError || $[29] !== handleUploadEnd || $[30] !== handleUploadStart || $[31] !== isMediaBrowserOpen || $[32] !== mediaConfig) {
        t7 = mediaConfig?.collection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZJRm.BrowserLoader), {
            mediaClientConfig: {
                authProvider: mediaConfig?.authProvider,
                useSha256ForUploads: true
            },
            config: {
                multiple: false,
                fileExtensions: [
                    ".jpg",
                    ".jpeg",
                    ".png",
                    ".gif"
                ],
                uploadParams: {
                    collection: mediaConfig.collection,
                    onUploadRejection: mediaConfig?.onUploadRejection
                }
            },
            isOpen: isMediaBrowserOpen,
            onClose: closeMediaBrowser,
            onUploadsStart: handleUploadStart,
            onError: handleOnError,
            onEnd: handleUploadEnd
        }) : null;
        $[27] = closeMediaBrowser;
        $[28] = handleOnError;
        $[29] = handleUploadEnd;
        $[30] = handleUploadStart;
        $[31] = isMediaBrowserOpen;
        $[32] = mediaConfig;
        $[33] = t7;
    } else t7 = $[33];
    let t8;
    if ($[34] !== t6 || $[35] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: t4,
            direction: "column"
        }, t6, t7));
        $[34] = t6;
        $[35] = t7;
        $[36] = t8;
    } else t8 = $[36];
    return t8;
} : ({ analyticsSource: analyticsSource, idPrefix: idPrefix, itemId: itemId, confluencePageId: confluencePageId, contentId: contentId, imageSrc: imageSrc, imageAltText: imageAltText, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, updateItemFormField: updateItemFormField })=>{
    const intl = (0, $kSwu1.useIntl)();
    const handleUnsplashImageSelection = (0, $cozmU.useCallback)(({ fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription })=>{
        updateItemFormField(itemId, {
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_SRC]: fullSizeImageUrl,
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_ALT_TEXT]: altDescription
        });
    }, [
        itemId,
        updateItemFormField
    ]);
    const handleUploadedImageSelection = (0, $cozmU.useCallback)(({ uploadedImageId: uploadedImageId, altDescription: altDescription_0 })=>{
        updateItemFormField(itemId, {
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_SRC]: uploadedImageId,
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_ALT_TEXT]: altDescription_0
        });
    }, [
        itemId,
        updateItemFormField
    ]);
    const { mediaConfig: mediaConfig, handleUploadEnd: handleUploadEnd, handleUploadStart: handleUploadStart, handleOnError: handleOnError, isMediaBrowserOpen: isMediaBrowserOpen, openMediaBrowser: openMediaBrowser, closeMediaBrowser: closeMediaBrowser, isUploadingImage: isUploadingImage } = (0, $9YAKX.useUploadMediaConfig)({
        contentId: contentId,
        handleUploadedImageSelection: handleUploadedImageSelection,
        analyticsSource: analyticsSource
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($4ffd702626f44752$var$styles.fieldWrapper),
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eLJUB.UnsplashSearch), {
        id: itemId,
        selectedImageUrl: imageSrc,
        imageAltText: imageAltText,
        sectionLabel: intl.formatMessage((0, $f9eeb347a2561a2a$export$defe85febe8b728c).sectionLabel),
        initialUnsplashResults: initialUnsplashResults,
        idPrefix: idPrefix,
        handleImageSelection: handleUnsplashImageSelection,
        analyticsSource: analyticsSource,
        analyticsActionSubject: "button",
        analyticsActionSubjectId: "customerImageUpload",
        openMediaBrowser: openMediaBrowser,
        contentId: contentId,
        confluencePageId: confluencePageId,
        isUploadingImage: isUploadingImage,
        isNoImageAllowed: isNoImageAllowed
    }), mediaConfig?.collection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZJRm.BrowserLoader), {
        mediaClientConfig: {
            authProvider: mediaConfig?.authProvider,
            useSha256ForUploads: true
        },
        config: {
            multiple: false,
            fileExtensions: [
                '.jpg',
                '.jpeg',
                '.png',
                '.gif'
            ],
            uploadParams: {
                collection: mediaConfig.collection,
                onUploadRejection: mediaConfig?.onUploadRejection
            }
        },
        isOpen: isMediaBrowserOpen,
        onClose: closeMediaBrowser,
        onUploadsStart: handleUploadStart,
        onError: handleOnError,
        onEnd: handleUploadEnd
    }) : null));
};
module.exports["UnsplashSearchField"] = $4ffd702626f44752$export$47c17c5f362608ab;

});

parcelRegister("l2vMT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $l3wuH = parcelRequire("l3wuH");


var $kTb7m = parcelRequire("kTb7m");


var $5HApy = parcelRequire("5HApy");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");


var $FCr1g = parcelRequire("FCr1g");


var $QXwxo = parcelRequire("QXwxo");











var $fuSOM = parcelRequire("fuSOM");


var $8pCvZ = parcelRequire("8pCvZ");


var $cfM7x = parcelRequire("cfM7x");

const $f7863c26f649df93$var$supportedPluginKeys = [
    'confluence',
    'jira',
    'atlas',
    'loom'
];
const $f7863c26f649df93$export$8f5a036ec4993fc5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { cloudId: cloudId, link: link, setIsOpen: setIsOpen, onLinkSelect: onLinkSelect } = t0;
    const { linkPickerConfig: linkPickerConfig } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== onLinkSelect || $[1] !== setIsOpen) {
        t1 = (payload)=>{
            onLinkSelect(payload);
            setIsOpen(false);
        };
        $[0] = onLinkSelect;
        $[1] = setIsOpen;
        $[2] = t1;
    } else t1 = $[2];
    const handleSubmit = t1;
    let t2;
    if ($[3] !== setIsOpen) {
        t2 = ()=>{
            setIsOpen(false);
        };
        $[3] = setIsOpen;
        $[4] = t2;
    } else t2 = $[4];
    const handleCancel = t2;
    let t3;
    if ($[5] !== cloudId) {
        t3 = {
            cloudId: cloudId,
            product: "confluence"
        };
        $[5] = cloudId;
        $[6] = t3;
    } else t3 = $[6];
    const { isLoading: isLoading, plugins: plugins } = (0, $8pCvZ.useLinkPickerPlugins)(t3);
    let t4;
    if ($[7] !== plugins) {
        t4 = plugins.filter($f7863c26f649df93$var$_temp);
        $[7] = plugins;
        $[8] = t4;
    } else t4 = $[8];
    const filteredPlugins = t4;
    const pluginsToUse = linkPickerConfig?.linkPickerPlugins || filteredPlugins;
    const isLoadingPlugins = linkPickerConfig?.linkPickerPlugins ? false : isLoading;
    let t5;
    if ($[9] !== handleCancel || $[10] !== handleSubmit || $[11] !== isLoadingPlugins || $[12] !== link.url || $[13] !== pluginsToUse) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuSOM.default), {
            plugins: pluginsToUse,
            isLoadingPlugins: isLoadingPlugins,
            url: link.url,
            onSubmit: handleSubmit,
            onCancel: handleCancel,
            hideDisplayText: true
        });
        $[9] = handleCancel;
        $[10] = handleSubmit;
        $[11] = isLoadingPlugins;
        $[12] = link.url;
        $[13] = pluginsToUse;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ cloudId: cloudId, link: link, setIsOpen: setIsOpen, onLinkSelect: onLinkSelect })=>{
    const { linkPickerConfig: linkPickerConfig } = (0, $cfM7x.useProductDependencies)();
    const handleSubmit = (payload)=>{
        onLinkSelect(payload);
        setIsOpen(false);
    };
    const handleCancel = ()=>{
        setIsOpen(false);
    };
    const { isLoading: isLoading, plugins: plugins } = (0, $8pCvZ.useLinkPickerPlugins)({
        cloudId: cloudId,
        product: 'confluence'
    });
    const filteredPlugins = (0, $cozmU.useMemo)(()=>{
        return plugins.filter((plugin)=>{
            return plugin.tabKey && $f7863c26f649df93$var$supportedPluginKeys.includes(plugin.tabKey);
        });
    }, [
        plugins
    ]);
    // Use custom plugins if provided, otherwise use default filtered plugins
    const pluginsToUse = linkPickerConfig?.linkPickerPlugins || filteredPlugins;
    const isLoadingPlugins = linkPickerConfig?.linkPickerPlugins ? false : isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuSOM.default), {
        plugins: pluginsToUse,
        isLoadingPlugins: isLoadingPlugins,
        url: link.url,
        onSubmit: handleSubmit,
        onCancel: handleCancel,
        hideDisplayText: true
    });
};
function $f7863c26f649df93$var$_temp(plugin) {
    return plugin.tabKey && $f7863c26f649df93$var$supportedPluginKeys.includes(plugin.tabKey);
}





const $89a15745d33487f9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    clearIconLabel: {
        id: "company-hub.company-hub-common.link-picker.clear-icon-label",
        defaultMessage: "Clear link selection"
    },
    popupPlaceholderText: {
        id: "company-hub.company-hub-common.link-picker.popup-placeholder-text",
        defaultMessage: "Add any link"
    }
});


const $d18e17380a145a46$var$styles = {
    disabled: "_syaz1gmx",
    link: "_p12fmgvx",
    placeholder: "_zulp12x7 _16jlkb7n _1o9zidpf _i0dlf1ug _4cvr1h6o _syazazsu",
    selection: "_18zr1b66 _4cvr1h6o _1bah1yb4 _ca0qze3t _n3tdze3t",
    trigger: "_2rko12b0 _18zrpxbi _bfhksm61 _4t3i1ylp _ca0qze3t _n3tdze3t",
    triggerPressed: "_bfhkfcek",
    unresolvedLink: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
};
const $d18e17380a145a46$var$getDefaultPayload = (link, title)=>({
        url: link || '',
        displayText: null,
        title: title || null,
        meta: {
            inputMethod: 'manual'
        }
    });
const $d18e17380a145a46$var$Placeholder = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $d18e17380a145a46$var$styles.placeholder
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $89a15745d33487f9$export$defe85febe8b728c).popupPlaceholderText));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $d18e17380a145a46$var$styles.placeholder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $89a15745d33487f9$export$defe85febe8b728c).popupPlaceholderText));
const $d18e17380a145a46$export$901b688e8da62820 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { id: id, cloudId: cloudId, link: link, title: title, handleSelectLink: handleSelectLink, handleClearLink: handleClearLink, isDisabled: isDisabled } = t0;
    let t1;
    if ($[0] !== link || $[1] !== title) {
        t1 = $d18e17380a145a46$var$getDefaultPayload(link, title);
        $[0] = link;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    const selectedLinkPayload = t1;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isLinkFallbackError, setIsLinkFallbackError] = (0, $cozmU.useState)(false);
    let t2;
    if ($[3] !== selectedLinkPayload.url) {
        t2 = ()=>window.open(selectedLinkPayload.url, "_blank");
        $[3] = selectedLinkPayload.url;
        $[4] = t2;
    } else t2 = $[4];
    const onLinkClick = t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsLinkFallbackError(false);
        $[5] = t3;
    } else t3 = $[5];
    const onResolve = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (t5)=>{
            const { status: status } = t5;
            return setIsLinkFallbackError(status !== "forbidden" && status !== "unauthorized");
        };
        $[6] = t4;
    } else t4 = $[6];
    const onError = t4;
    let t5;
    if ($[7] !== isDisabled || $[8] !== isLinkFallbackError || $[9] !== onLinkClick || $[10] !== selectedLinkPayload.url) {
        t5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $d18e17380a145a46$var$styles.link
            }, !isLinkFallbackError && !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QXwxo.CardSSR), {
                appearance: "inline",
                onClick: onLinkClick,
                onError: onError,
                onResolve: onResolve,
                truncateInline: true,
                url: selectedLinkPayload.url
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FCr1g.default), {
                ...!isDisabled && {
                    href: selectedLinkPayload.url
                },
                onClick: $d18e17380a145a46$var$_temp,
                target: "_blank"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($d18e17380a145a46$var$styles.unresolvedLink, isDisabled && $d18e17380a145a46$var$styles.disabled)
            }, selectedLinkPayload.url)));
        $[7] = isDisabled;
        $[8] = isLinkFallbackError;
        $[9] = onLinkClick;
        $[10] = selectedLinkPayload.url;
        $[11] = t5;
    } else t5 = $[11];
    const ResolvedLink = t5;
    let t6;
    if ($[12] !== handleClearLink) {
        t6 = (e_0)=>{
            e_0.stopPropagation();
            setIsLinkFallbackError(false);
            handleClearLink();
        };
        $[12] = handleClearLink;
        $[13] = t6;
    } else t6 = $[13];
    const onLinkClear = t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsOpen(false);
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== cloudId || $[16] !== handleSelectLink || $[17] !== selectedLinkPayload) {
        t8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7863c26f649df93$export$8f5a036ec4993fc5), {
                cloudId: cloudId,
                link: selectedLinkPayload,
                onLinkSelect: handleSelectLink,
                setIsOpen: setIsOpen
            });
        $[15] = cloudId;
        $[16] = handleSelectLink;
        $[17] = selectedLinkPayload;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== ResolvedLink || $[20] !== isDisabled || $[21] !== isOpen || $[22] !== onLinkClear || $[23] !== selectedLinkPayload.url) {
        t9 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                isDisabled: isDisabled,
                onClick: ()=>setIsOpen(!isOpen),
                testId: "link-picker-popup-button",
                style: {
                    border: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)"
                },
                xcss: (0, $w6R6I.cx)($d18e17380a145a46$var$styles.trigger, isOpen && $d18e17380a145a46$var$styles.triggerPressed)
            }, !!selectedLinkPayload.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                xcss: $d18e17380a145a46$var$styles.selection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResolvedLink, null), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                onClick: onLinkClear,
                appearance: "subtle",
                spacing: "compact",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $89a15745d33487f9$export$defe85febe8b728c).clearIconLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH)))
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d18e17380a145a46$var$Placeholder, null));
        $[19] = ResolvedLink;
        $[20] = isDisabled;
        $[21] = isOpen;
        $[22] = onLinkClear;
        $[23] = selectedLinkPayload.url;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== id || $[26] !== isOpen || $[27] !== t8 || $[28] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            id: id,
            isOpen: isOpen,
            onClose: t7,
            placement: "left",
            content: t8,
            trigger: t9,
            shouldRenderToParent: true
        }));
        $[25] = id;
        $[26] = isOpen;
        $[27] = t8;
        $[28] = t9;
        $[29] = t10;
    } else t10 = $[29];
    return t10;
} : ({ id: id, cloudId: cloudId, link: link, title: title, handleSelectLink: handleSelectLink, handleClearLink: handleClearLink, isDisabled: isDisabled })=>{
    const selectedLinkPayload = $d18e17380a145a46$var$getDefaultPayload(link, title);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isLinkFallbackError, setIsLinkFallbackError] = (0, $cozmU.useState)(false);
    const onLinkClick = ()=>window.open(selectedLinkPayload.url, '_blank');
    const onResolve = ()=>setIsLinkFallbackError(false);
    const onError = ({ status: status })=>setIsLinkFallbackError(status !== 'forbidden' && status !== 'unauthorized');
    const ResolvedLink = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d18e17380a145a46$var$styles.link
        }, !isLinkFallbackError && !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QXwxo.CardSSR), {
            appearance: "inline",
            onClick: onLinkClick,
            onError: onError,
            onResolve: onResolve,
            truncateInline: true,
            url: selectedLinkPayload.url
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FCr1g.default), {
            ...!isDisabled && {
                href: selectedLinkPayload.url
            },
            onClick: (e)=>e.stopPropagation(),
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($d18e17380a145a46$var$styles.unresolvedLink, isDisabled && $d18e17380a145a46$var$styles.disabled)
        }, selectedLinkPayload.url)));
    };
    const onLinkClear = (e_0)=>{
        e_0.stopPropagation();
        setIsLinkFallbackError(false);
        handleClearLink();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        id: id,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "left",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7863c26f649df93$export$8f5a036ec4993fc5), {
                cloudId: cloudId,
                link: selectedLinkPayload,
                onLinkSelect: handleSelectLink,
                setIsOpen: setIsOpen
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                isDisabled: isDisabled,
                onClick: ()=>setIsOpen(!isOpen),
                testId: "link-picker-popup-button",
                style: {
                    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
                },
                xcss: (0, $w6R6I.cx)($d18e17380a145a46$var$styles.trigger, isOpen && $d18e17380a145a46$var$styles.triggerPressed)
            }, !!selectedLinkPayload.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                xcss: $d18e17380a145a46$var$styles.selection
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResolvedLink, null), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                onClick: onLinkClear,
                appearance: "subtle",
                spacing: "compact",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $89a15745d33487f9$export$defe85febe8b728c).clearIconLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH)))
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d18e17380a145a46$var$Placeholder, null)),
        shouldRenderToParent: true
    }));
};
function $d18e17380a145a46$var$_temp(e) {
    return e.stopPropagation();
}
module.exports["LinkPicker"] = $d18e17380a145a46$export$901b688e8da62820;

});

parcelRegister("g6P9J", function(module, exports) {
/**
 * @generated SignedSource<<0907a28d57b9d1524d8d13cf4e618c83>>
 * @relayHash b02d8f8b31305d13be27cef9e8b950ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0edbf1f8d53711cef0a2bc558686119f8ba6622bfe9a75dc0d54f98aa2d1c1f8
const $8d5d9c2b64665a44$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-published",
                                        "cover-picture-id-draft"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-published\",\"cover-picture-id-draft\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchPageCoverImageQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchPageCoverImageQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "0edbf1f8d53711cef0a2bc558686119f8ba6622bfe9a75dc0d54f98aa2d1c1f8",
            "metadata": {},
            "name": "useFetchPageCoverImageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8d5d9c2b64665a44$var$node.hash = "0855dab8d0960c23520163cfbddf5236";
var $8d5d9c2b64665a44$export$2e2bcd8739ae039 = $8d5d9c2b64665a44$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $2ot3O = parcelRequire("2ot3O");


var $24dy7 = parcelRequire("24dy7");


var $h9r4d = parcelRequire("h9r4d");


var $d5gEx = parcelRequire("d5gEx");


var $8qkba = parcelRequire("8qkba");




const $50043acc9026a46c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    fetchErrorTitle: {
        id: "company-hub.company-hub-common.link-cards.fetch-cover-image.fetch.error.title",
        defaultMessage: "We can\u2019t upload your image"
    },
    fetchErrorDescription: {
        id: "company-hub.company-hub-common.link-cards.fetch-cover-image.fetch.error.description",
        defaultMessage: "Refresh the page and try again"
    }
});


const $bc7537742adf5371$var$extractId = (data)=>{
    const isLivePage = data?.content?.nodes?.[0]?.subType === 'live';
    let imageProperty;
    if (isLivePage) imageProperty = data?.content?.nodes?.[0]?.properties?.nodes?.find((image)=>image?.key === (0, $8qkba.CoverPictureIdPropertyKey).DRAFT);
    else {
        imageProperty = data?.content?.nodes?.[0]?.properties?.nodes?.find((image)=>image?.key === (0, $8qkba.CoverPictureIdPropertyKey).PUBLISHED);
        if (!imageProperty) imageProperty = data?.content?.nodes?.[0]?.properties?.nodes?.find((image)=>image?.key === (0, $8qkba.CoverPictureIdPropertyKey).DRAFT);
    }
    return (0, $8qkba.propertyToId)(imageProperty)?.value.id;
};
function $bc7537742adf5371$export$d09c7708bbcc7c1a(analyticsSource) {
    const { showFlag: showFlag } = (0, $2ot3O.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const environment = (0, $d5gEx.useRelayEnvironmentProvider)().getEnvironment({});
    return (0, $cozmU.useCallback)(async (confluencePageId, image)=>{
        if (!confluencePageId) return image?.url;
        let coverImageUrl;
        try {
            const data = await (0, $6SsN4.fetchQuery)(environment, (0, $8d5d9c2b64665a44$export$2e2bcd8739ae039), {
                id: confluencePageId ?? ''
            }).toPromise();
            coverImageUrl = $bc7537742adf5371$var$extractId(data);
            if (coverImageUrl) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'image',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'imageFoundOnPage'
                    }
                }
            }).fire();
        } catch (error) {
            showFlag({
                id: 'fetch-cover-image-error',
                title: formatMessage((0, $50043acc9026a46c$export$defe85febe8b728c).fetchErrorTitle),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    label: "",
                    size: "medium",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                description: formatMessage((0, $50043acc9026a46c$export$defe85febe8b728c).fetchErrorDescription)
            });
            (0, $h9r4d.fireErrorAnalytics)({
                error: error instanceof Error ? error : new Error('Failed to fetch page cover image'),
                meta: {
                    id: 'useFetchPageCoverImage',
                    packageName: '@atlassian/company-hub-common'
                }
            });
        }
        return coverImageUrl || image?.url;
    }, [
        analyticsSource,
        createAnalyticsEvent,
        showFlag,
        formatMessage,
        environment
    ]);
}
module.exports["useFetchCoverImage"] = $bc7537742adf5371$export$d09c7708bbcc7c1a;

});

parcelRegister("b7jDA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kA6Zo = parcelRequire("kA6Zo");

var $buxP3 = parcelRequire("buxP3");


var $c0A7H = parcelRequire("c0A7H");


var $9vJye = parcelRequire("9vJye");

const $8f7160b430969796$var$toggleFieldContainerDisabledStyles = (0, $buxP3.xcss)({
    color: 'color.text.disabled'
});
const $8f7160b430969796$var$labelWrapperStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    flexGrow: 1,
    gap: 'space.100'
});
const $8f7160b430969796$export$f91e8bfeb5571984 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    let Icon;
    let id;
    let isDisabled;
    let label;
    let toggleProps;
    if ($[0] !== t0) {
        ({ Icon: Icon, id: id, label: label, isDisabled: isDisabled, ...toggleProps } = t0);
        $[0] = t0;
        $[1] = Icon;
        $[2] = id;
        $[3] = isDisabled;
        $[4] = label;
        $[5] = toggleProps;
    } else {
        Icon = $[1];
        id = $[2];
        isDisabled = $[3];
        label = $[4];
        toggleProps = $[5];
    }
    const isDisabledContext = (0, $9vJye.useIsDisabledContext)();
    const isToggleDisabled = isDisabled ?? isDisabledContext;
    if (!id) {
        let t1;
        if ($[6] !== label) {
            t1 = label.replace(/\s+/g, "-").toLowerCase();
            $[6] = label;
            $[7] = t1;
        } else t1 = $[7];
        id = `toggle-${t1}-property`;
    }
    const t1 = isToggleDisabled && $8f7160b430969796$var$toggleFieldContainerDisabledStyles;
    let t2;
    if ($[8] !== id || $[9] !== label) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
            htmlFor: id
        }, label);
        $[8] = id;
        $[9] = label;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] !== Icon || $[12] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $8f7160b430969796$var$labelWrapperStyles
        }, t2, Icon);
        $[11] = Icon;
        $[12] = t2;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== id || $[15] !== isToggleDisabled || $[16] !== toggleProps) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
            ...toggleProps,
            isDisabled: isToggleDisabled,
            id: id
        });
        $[14] = id;
        $[15] = isToggleDisabled;
        $[16] = toggleProps;
        $[17] = t4;
    } else t4 = $[17];
    let t5;
    if ($[18] !== t1 || $[19] !== t3 || $[20] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            xcss: t1
        }, t3, t4);
        $[18] = t1;
        $[19] = t3;
        $[20] = t4;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
} : ({ Icon: Icon, id: id, label: label, isDisabled: isDisabled, ...toggleProps })=>{
    const isDisabledContext = (0, $9vJye.useIsDisabledContext)();
    const isToggleDisabled = isDisabled ?? isDisabledContext;
    if (!id) id = `toggle-${label.replace(/\s+/g, '-').toLowerCase()}-property`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "center",
        xcss: isToggleDisabled && $8f7160b430969796$var$toggleFieldContainerDisabledStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $8f7160b430969796$var$labelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        htmlFor: id
    }, label), Icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
        ...toggleProps,
        isDisabled: isToggleDisabled,
        id: id
    }));
};
module.exports["ToggleField"] = $8f7160b430969796$export$f91e8bfeb5571984;

});

parcelRegister("8mmUh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $iDfTs = parcelRequire("iDfTs");


var $5wHqn = parcelRequire("5wHqn");


var $3izAL = parcelRequire("3izAL");

var $kA6Zo = parcelRequire("kA6Zo");

var $2wCqQ = parcelRequire("2wCqQ");

var $buxP3 = parcelRequire("buxP3");


var $4ikjJ = parcelRequire("4ikjJ");


var $4yg9g = parcelRequire("4yg9g");


var $hjUDQ = parcelRequire("hjUDQ");


var $l2vMT = parcelRequire("l2vMT");




const $aefa2735a295a1a5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    buttonHeading: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.button-heading",
        defaultMessage: "Button"
    },
    textPlaceholder: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.button-text-placeholder",
        defaultMessage: "View"
    },
    deleteIconLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.delete-icon-label",
        defaultMessage: "Delete"
    },
    defaultButtonStyleLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.light-button-style-label",
        defaultMessage: "Default"
    },
    alternativeButtonStyleLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.dark-button-style-label",
        defaultMessage: "Alternative"
    }
});


const $1efeadd9de6fee2c$var$popupWrapper = (0, $buxP3.xcss)({
    width: '262px'
});
const $1efeadd9de6fee2c$var$defaultRadioOptionStyles = (0, $buxP3.xcss)({
    paddingInline: 'space.250',
    paddingBlock: 'space.050',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    color: 'color.text'
});
const $1efeadd9de6fee2c$var$alternativeRadioOptionStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    color: 'color.text.inverse'
});
const $1efeadd9de6fee2c$export$322c06619d3c1a57 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>setIsOpen(false);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1efeadd9de6fee2c$var$PopupContent, props);
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== isOpen) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                iconAfter: $1efeadd9de6fee2c$var$_temp
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aefa2735a295a1a5$export$defe85febe8b728c).buttonHeading)));
        $[3] = isOpen;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isOpen || $[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            shouldRenderToParent: true,
            isOpen: isOpen,
            onClose: t0,
            placement: "bottom-start",
            content: t1,
            trigger: t2
        });
        $[5] = isOpen;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1efeadd9de6fee2c$var$PopupContent, props),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        ...iconProps,
                        size: "small"
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aefa2735a295a1a5$export$defe85febe8b728c).buttonHeading)))
    });
};
const $1efeadd9de6fee2c$var$PopupContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(53);
    const { text: text, link: link, style: style, source: source, buttonStyles: buttonStyles, handleSelectLink: handleSelectLink, handleClearLink: handleClearLink, handleClearButton: handleClearButton, updateButtonText: updateButtonText, updateButtonStyle: updateButtonStyle, cloudId: cloudId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== buttonStyles || $[1] !== intl) {
        t1 = buttonStyles || [
            {
                label: intl.formatMessage((0, $aefa2735a295a1a5$export$defe85febe8b728c).defaultButtonStyleLabel),
                value: (0, $hjUDQ.ButtonStyle).DEFAULT,
                styles: $1efeadd9de6fee2c$var$defaultRadioOptionStyles
            },
            {
                label: intl.formatMessage((0, $aefa2735a295a1a5$export$defe85febe8b728c).alternativeButtonStyleLabel),
                value: (0, $hjUDQ.ButtonStyle).ALTERNATIVE_1,
                styles: [
                    $1efeadd9de6fee2c$var$defaultRadioOptionStyles,
                    $1efeadd9de6fee2c$var$alternativeRadioOptionStyles
                ]
            }
        ];
        $[0] = buttonStyles;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    const buttonStyleOptions = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent || $[4] !== source) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "focused",
                    actionSubject: "textField",
                    actionSubjectId: "configPanelButtonField",
                    source: `${source}ButtonLabel`
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = source;
        $[5] = t2;
    } else t2 = $[5];
    const fireTextFieldAnalytics = t2;
    let t3;
    if ($[6] !== createAnalyticsEvent || $[7] !== source) {
        t3 = (isAddingLink)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: isAddingLink ? "added" : "removed",
                    actionSubject: "buttonLink",
                    actionSubjectId: "configPanelButtonLink",
                    source: `${source}ButtonLink`
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = source;
        $[8] = t3;
    } else t3 = $[8];
    const fireButtonLinkAnalytics = t3;
    let t4;
    if ($[9] !== fireButtonLinkAnalytics || $[10] !== handleSelectLink) {
        t4 = (selectedLink)=>{
            handleSelectLink(selectedLink);
            fireButtonLinkAnalytics(true);
        };
        $[9] = fireButtonLinkAnalytics;
        $[10] = handleSelectLink;
        $[11] = t4;
    } else t4 = $[11];
    const selectLink = t4;
    let t5;
    if ($[12] !== fireButtonLinkAnalytics || $[13] !== handleClearButton) {
        t5 = ()=>{
            fireButtonLinkAnalytics(false);
            handleClearButton();
        };
        $[12] = fireButtonLinkAnalytics;
        $[13] = handleClearButton;
        $[14] = t5;
    } else t5 = $[14];
    const handleDeleteButton = t5;
    let t6;
    if ($[15] !== buttonStyleOptions || $[16] !== updateButtonStyle) {
        t6 = (event)=>{
            const selectedOption = buttonStyleOptions.find((option)=>option.value === event.currentTarget.value);
            if (selectedOption) updateButtonStyle(selectedOption.value);
        };
        $[15] = buttonStyleOptions;
        $[16] = updateButtonStyle;
        $[17] = t6;
    } else t6 = $[17];
    const handleChange = t6;
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            paddingBlock: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aefa2735a295a1a5$export$defe85febe8b728c).buttonHeading)));
        $[18] = t7;
    } else t7 = $[18];
    const t8 = !(text || link);
    let t9;
    if ($[19] !== intl) {
        t9 = intl.formatMessage((0, $aefa2735a295a1a5$export$defe85febe8b728c).deleteIconLabel);
        $[19] = intl;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== handleDeleteButton || $[22] !== t8 || $[23] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            justifyContent: "space-between",
            alignItems: "center"
        }, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            isDisabled: t8,
            spacing: "compact",
            appearance: "subtle",
            onClick: handleDeleteButton,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            label: t9,
            testId: "delete-button"
        }));
        $[21] = handleDeleteButton;
        $[22] = t8;
        $[23] = t9;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== cloudId || $[26] !== handleClearLink || $[27] !== link || $[28] !== selectLink) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            testId: "link-picker-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l2vMT.LinkPicker), {
            cloudId: cloudId,
            link: link,
            id: "button-link",
            handleSelectLink: selectLink,
            handleClearLink: handleClearLink
        }));
        $[25] = cloudId;
        $[26] = handleClearLink;
        $[27] = link;
        $[28] = selectLink;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== updateButtonText) {
        t12 = (event_0)=>{
            updateButtonText(event_0.currentTarget.value);
        };
        $[30] = updateButtonText;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== intl) {
        t13 = intl.formatMessage((0, $aefa2735a295a1a5$export$defe85febe8b728c).textPlaceholder);
        $[32] = intl;
        $[33] = t13;
    } else t13 = $[33];
    let t14;
    if ($[34] !== fireTextFieldAnalytics || $[35] !== t12 || $[36] !== t13 || $[37] !== text) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            maxLength: 40,
            value: text,
            onChange: t12,
            onFocus: fireTextFieldAnalytics,
            placeholder: t13,
            testId: "button-name"
        }));
        $[34] = fireTextFieldAnalytics;
        $[35] = t12;
        $[36] = t13;
        $[37] = text;
        $[38] = t14;
    } else t14 = $[38];
    let t15;
    if ($[39] !== buttonStyleOptions || $[40] !== handleChange || $[41] !== style) {
        let t16;
        if ($[43] !== handleChange || $[44] !== style) {
            t16 = (option_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                    key: index,
                    value: option_0.value,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                        alignItems: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                        xcss: option_0.styles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aefa2735a295a1a5$export$defe85febe8b728c).buttonHeading))),
                    name: option_0.label,
                    isChecked: option_0.value === style,
                    onChange: handleChange,
                    style: {
                        margin: "auto"
                    },
                    testId: `button-style-${option_0.value}`
                });
            $[43] = handleChange;
            $[44] = style;
            $[45] = t16;
        } else t16 = $[45];
        t15 = buttonStyleOptions.map(t16);
        $[39] = buttonStyleOptions;
        $[40] = handleChange;
        $[41] = style;
        $[42] = t15;
    } else t15 = $[42];
    let t16;
    if ($[46] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            justifyContent: "space-between"
        }, t15);
        $[46] = t15;
        $[47] = t16;
    } else t16 = $[47];
    let t17;
    if ($[48] !== t10 || $[49] !== t11 || $[50] !== t14 || $[51] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            padding: "space.150",
            xcss: $1efeadd9de6fee2c$var$popupWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.200",
            grow: "fill"
        }, t10, t11, t14, t16));
        $[48] = t10;
        $[49] = t11;
        $[50] = t14;
        $[51] = t16;
        $[52] = t17;
    } else t17 = $[52];
    return t17;
} : ({ text: text, link: link, style: style, source: source, buttonStyles: buttonStyles, handleSelectLink: handleSelectLink, handleClearLink: handleClearLink, handleClearButton: handleClearButton, updateButtonText: updateButtonText, updateButtonStyle: updateButtonStyle, cloudId: cloudId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const buttonStyleOptions = buttonStyles || [
        {
            label: intl.formatMessage((0, $aefa2735a295a1a5$export$defe85febe8b728c).defaultButtonStyleLabel),
            value: (0, $hjUDQ.ButtonStyle).DEFAULT,
            styles: $1efeadd9de6fee2c$var$defaultRadioOptionStyles
        },
        {
            label: intl.formatMessage((0, $aefa2735a295a1a5$export$defe85febe8b728c).alternativeButtonStyleLabel),
            value: (0, $hjUDQ.ButtonStyle).ALTERNATIVE_1,
            styles: [
                $1efeadd9de6fee2c$var$defaultRadioOptionStyles,
                $1efeadd9de6fee2c$var$alternativeRadioOptionStyles
            ]
        }
    ];
    const fireTextFieldAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'focused',
                actionSubject: 'textField',
                actionSubjectId: 'configPanelButtonField',
                source: `${source}ButtonLabel`
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const fireButtonLinkAnalytics = (0, $cozmU.useCallback)((isAddingLink)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: isAddingLink ? 'added' : 'removed',
                actionSubject: 'buttonLink',
                actionSubjectId: 'configPanelButtonLink',
                source: `${source}ButtonLink`
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const selectLink = (0, $cozmU.useCallback)((selectedLink)=>{
        handleSelectLink(selectedLink);
        fireButtonLinkAnalytics(true);
    }, [
        fireButtonLinkAnalytics,
        handleSelectLink
    ]);
    const handleDeleteButton = ()=>{
        fireButtonLinkAnalytics(false);
        handleClearButton();
    };
    const handleChange = (event)=>{
        const selectedOption = buttonStyleOptions.find((option)=>option.value === event.currentTarget.value);
        if (selectedOption) updateButtonStyle(selectedOption.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        padding: "space.150",
        xcss: $1efeadd9de6fee2c$var$popupWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.200",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        paddingBlock: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aefa2735a295a1a5$export$defe85febe8b728c).buttonHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isDisabled: !(text || link),
        spacing: "compact",
        appearance: "subtle",
        onClick: handleDeleteButton,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        label: intl.formatMessage((0, $aefa2735a295a1a5$export$defe85febe8b728c).deleteIconLabel),
        testId: "delete-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        testId: "link-picker-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l2vMT.LinkPicker), {
        cloudId: cloudId,
        link: link,
        id: "button-link",
        handleSelectLink: selectLink,
        handleClearLink: handleClearLink
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        maxLength: 40,
        value: text,
        onChange: (event_0)=>{
            updateButtonText(event_0.currentTarget.value);
        },
        onFocus: fireTextFieldAnalytics,
        placeholder: intl.formatMessage((0, $aefa2735a295a1a5$export$defe85febe8b728c).textPlaceholder),
        testId: "button-name"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, buttonStyleOptions.map((option_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
            key: index,
            value: option_0.value,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                xcss: option_0.styles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aefa2735a295a1a5$export$defe85febe8b728c).buttonHeading))),
            name: option_0.label,
            isChecked: option_0.value === style,
            onChange: handleChange,
            // Static styling is necessary here to ensure the radio button is centered
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: {
                margin: 'auto'
            },
            testId: `button-style-${option_0.value}`
        })))));
};
function $1efeadd9de6fee2c$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["ButtonConfig"] = $1efeadd9de6fee2c$export$322c06619d3c1a57;

});

parcelRegister("eoSsA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");


var $chOte = parcelRequire("chOte");

var $5dDC4 = parcelRequire("5dDC4");

var $4zyjT = parcelRequire("4zyjT");

var $a96iv = parcelRequire("a96iv");

var $hjUDQ = parcelRequire("hjUDQ");

var $5KFAG = parcelRequire("5KFAG");

var $d6u4w = parcelRequire("d6u4w");

var $4cGll = parcelRequire("4cGll");

var $bIp5p = parcelRequire("bIp5p");

var $9vJye = parcelRequire("9vJye");

var $cfM7x = parcelRequire("cfM7x");


var $gXR7h = parcelRequire("gXR7h");


var $cT2iI = parcelRequire("cT2iI");











var $gcu7p = parcelRequire("gcu7p");

var $jmFR8 = parcelRequire("jmFR8");


var $5eKkh = parcelRequire("5eKkh");



















var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $cXCJB = parcelRequire("cXCJB");

var $4yUlE = parcelRequire("4yUlE");

var $5ddnJ = parcelRequire("5ddnJ");

var $4sYZY = parcelRequire("4sYZY");




var $4ZnIz = parcelRequire("4ZnIz");

var $cImA8 = parcelRequire("cImA8");




var $e9Sxn = parcelRequire("e9Sxn");

var $gKJso = parcelRequire("gKJso");


var $4pBmf = parcelRequire("4pBmf");

















var $hekY6 = parcelRequire("hekY6");








var $ad7Ou = parcelRequire("ad7Ou");


var $w6R6I = parcelRequire("w6R6I");


var $7sJoX = parcelRequire("7sJoX");


var $5wHqn = parcelRequire("5wHqn");





var $2VNQP = parcelRequire("2VNQP");








var $5Sbqg = parcelRequire("5Sbqg");




const $b2b1e94d13fc0627$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    buttonTitle: {
        id: "company-hub.carousel-extension.config-panel.layout.title",
        defaultMessage: "Choose a layout"
    },
    frameAboveImageLabel: {
        id: "company-hub.carousel-extension.config-panel.layouts.frame-above-image.label",
        defaultMessage: "Text with frame above image"
    },
    splitDesignLabel: {
        id: "company-hub.carousel-extension.config-panel.layouts.split-design-content.label",
        defaultMessage: "Split design"
    },
    solidColorBackgroundLabel: {
        id: "company-hub.carousel-extension.config-panel.layouts.solid-color-background.label",
        defaultMessage: "Solid color background"
    }
});


const $07a279c36086d60f$var$DROPDOWN_WIDTH = 241;
const $07a279c36086d60f$var$DROPDOWN_MAX_HEIGHT = 500;
const $07a279c36086d60f$var$BUTTON_CONTAINER_WIDTH = 152;
const $07a279c36086d60f$export$af1b061943ec63f0 = [
    {
        label: (0, $b2b1e94d13fc0627$export$defe85febe8b728c).frameAboveImageLabel,
        value: (0, $hjUDQ.CommonLayout).FRAME_ABOVE_IMAGE
    },
    {
        label: (0, $b2b1e94d13fc0627$export$defe85febe8b728c).splitDesignLabel,
        value: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_RIGHT
    },
    {
        label: (0, $b2b1e94d13fc0627$export$defe85febe8b728c).splitDesignLabel,
        value: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        label: (0, $b2b1e94d13fc0627$export$defe85febe8b728c).solidColorBackgroundLabel,
        value: (0, $hjUDQ.CommonLayout).NO_IMAGE_BACKGROUND
    }
];
const $07a279c36086d60f$var$styles = {
    dropdownMenuStyles: "_1bsbn8ye _c71ldgin _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _18m91wug",
    buttonContainer: "_1bsb1llu _otyrpxbi"
};
const $07a279c36086d60f$export$23adc972c5b7cdfa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { updateFrameFormField: updateFrameFormField, frameParameters: frameParameters, contentId: contentId } = t0;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== frameParameters.cardId || $[1] !== updateFrameFormField) {
        t1 = (newLayout)=>updateFrameFormField(frameParameters.cardId, {
                layout: newLayout
            });
        $[0] = frameParameters.cardId;
        $[1] = updateFrameFormField;
        $[2] = t1;
    } else t1 = $[2];
    const handleUpdateLayout = t1;
    let t2;
    if ($[3] !== contentId || $[4] !== frameParameters.backgroundColor || $[5] !== frameParameters.description || $[6] !== frameParameters.imageSrc || $[7] !== frameParameters.link || $[8] !== frameParameters.textColor || $[9] !== frameParameters.title) {
        t2 = (t3)=>{
            const { height: height, layout: layout } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Sbqg.CarouselLayoutRenderer), {
                testId: "carousel-spotlight-preview",
                backgroundColor: frameParameters.backgroundColor,
                height: height,
                layout: layout,
                imageData: frameParameters.imageSrc,
                title: frameParameters?.title,
                description: frameParameters?.description,
                textColor: frameParameters?.textColor,
                link: frameParameters.link,
                contentId: contentId,
                source: "carousel-spotlight-preview"
            }));
        };
        $[3] = contentId;
        $[4] = frameParameters.backgroundColor;
        $[5] = frameParameters.description;
        $[6] = frameParameters.imageSrc;
        $[7] = frameParameters.link;
        $[8] = frameParameters.textColor;
        $[9] = frameParameters.title;
        $[10] = t2;
    } else t2 = $[10];
    const PreviewContentComponent = t2;
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsOpen(false);
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== PreviewContentComponent || $[13] !== frameParameters.layout || $[14] !== handleUpdateLayout) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                direction: "column",
                gap: "space.150",
                xcss: (0, $w6R6I.cx)($07a279c36086d60f$var$styles.dropdownMenuStyles)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VNQP.LayoutOptions), {
                updateLayout: handleUpdateLayout,
                source: (0, $gXR7h.carouselConfigAnalyticSource),
                layoutOptions: $07a279c36086d60f$export$af1b061943ec63f0,
                variant: "compact",
                currentLayoutSelection: frameParameters.layout,
                PreviewComponent: PreviewContentComponent
            }));
        $[12] = PreviewContentComponent;
        $[13] = frameParameters.layout;
        $[14] = handleUpdateLayout;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== isOpen) {
        t5 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $07a279c36086d60f$var$styles.buttonContainer
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                iconAfter: $07a279c36086d60f$var$_temp
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b2b1e94d13fc0627$export$defe85febe8b728c).buttonTitle)));
        $[16] = isOpen;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== isOpen || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            shouldRenderToParent: true,
            isOpen: isOpen,
            onClose: t3,
            placement: "bottom-start",
            zIndex: 600,
            content: t4,
            trigger: t5
        });
        $[18] = isOpen;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
} : ({ updateFrameFormField: updateFrameFormField, frameParameters: frameParameters, contentId: contentId })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const handleUpdateLayout = (0, $cozmU.useCallback)((newLayout)=>updateFrameFormField(frameParameters.cardId, {
            layout: newLayout
        }), [
        frameParameters.cardId,
        updateFrameFormField
    ]);
    const PreviewContentComponent = (0, $cozmU.useCallback)(({ height: height, layout: layout })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Sbqg.CarouselLayoutRenderer), {
            testId: "carousel-spotlight-preview",
            backgroundColor: frameParameters.backgroundColor,
            height: height,
            layout: layout,
            imageData: frameParameters.imageSrc,
            title: frameParameters?.title,
            description: frameParameters?.description,
            textColor: frameParameters?.textColor,
            link: frameParameters.link,
            contentId: contentId,
            source: "carousel-spotlight-preview"
        }));
    }, [
        frameParameters,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        zIndex: 600,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                direction: "column",
                gap: "space.150",
                xcss: (0, $w6R6I.cx)($07a279c36086d60f$var$styles.dropdownMenuStyles)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VNQP.LayoutOptions), {
                updateLayout: handleUpdateLayout,
                source: (0, $gXR7h.carouselConfigAnalyticSource),
                layoutOptions: $07a279c36086d60f$export$af1b061943ec63f0,
                variant: "compact",
                currentLayoutSelection: frameParameters.layout,
                PreviewComponent: PreviewContentComponent
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    $07a279c36086d60f$var$styles.buttonContainer
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        ...iconProps,
                        size: "small"
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b2b1e94d13fc0627$export$defe85febe8b728c).buttonTitle)))
    });
};
function $07a279c36086d60f$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        ...iconProps,
        size: "small"
    });
}















var $55fM8 = parcelRequire("55fM8");





var $9DHhW = parcelRequire("9DHhW");


var $kB5K2 = parcelRequire("kB5K2");


var $4yccB = parcelRequire("4yccB");





var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $8mmUh = parcelRequire("8mmUh");



var $jlbje = parcelRequire("jlbje");

var $hgxhy = parcelRequire("hgxhy");

var $g6P9J = parcelRequire("g6P9J");




var $619Qo = parcelRequire("619Qo");













const $c518b2619c1f63dc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    linkFieldLabel: {
        id: "company-hub.carousel-extension.config-panel.link.field.label",
        defaultMessage: "Link"
    },
    titleFieldLabel: {
        id: "company-hub.carousel-extension.title.field.label",
        defaultMessage: "Title"
    },
    recommendedFieldLabel: {
        id: "company-hub.carousel-extension.recommended.field.label",
        defaultMessage: "(Recommended)"
    },
    descriptionFieldLabel: {
        id: "company-hub.carousel-extension.description.field.label",
        defaultMessage: "Description"
    },
    titlePlaceholder: {
        id: "company-hub.carousel-extension.title.placeholder",
        defaultMessage: "Give your frame a title"
    },
    descriptionPlaceholder: {
        id: "company-hub.carousel-extension.description.placeholder",
        defaultMessage: "Customize this frame to create a rotating carousel."
    }
});


const $c6238f2e36e698c1$var$debouncedParametersUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((updateFrameFormField, inputPropertyToUpdate, inputIsUserEditedPropertyToUpdate, cardId, value, createAnalyticsEvent, shouldUpdateUserEdited = true)=>{
    updateFrameFormField(cardId, {
        [inputPropertyToUpdate]: value,
        [inputIsUserEditedPropertyToUpdate]: shouldUpdateUserEdited
    });
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'edited',
            actionSubject: inputPropertyToUpdate,
            source: (0, $gXR7h.carouselConfigAnalyticSource)
        }
    }).fire();
}, 400); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c6238f2e36e698c1$var$RecommendedWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1p1dglyw _k48pi7a9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1p1dglyw _k48pi7a9",
            __cmplp.className
        ])
    });
});
const $c6238f2e36e698c1$var$fieldWrapperStyles = {
    fieldWrapper: "_19pkpxbi"
};
const $c6238f2e36e698c1$var$externalSiteMatcher = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
const $c6238f2e36e698c1$var$getFieldsToUpdateOnLinkSelect = async (selectedLink, fetchCoverImageUrl, cardImage, cardTitle, cardDescription, isTitleUserEdited, isDescriptionUserEdited, submitError)=>{
    let fieldsToUpdate = (0, $cT2iI.updateLinkAndConfluencePageId)(selectedLink.url, '', true);
    try {
        const client = new (0, $4yccB.default)();
        const queriedMetadata = await client.fetchData(selectedLink.url);
        const { name: name, image: image, summary: summary } = queriedMetadata?.data || {};
        const { objectId: objectId } = queriedMetadata?.meta || {};
        fieldsToUpdate = {
            ...fieldsToUpdate,
            ...(0, $cT2iI.updateLinkAndConfluencePageId)(selectedLink.url, objectId, true)
        };
        if (!cardTitle || isTitleUserEdited === false) {
            fieldsToUpdate[(0, $hjUDQ.ITEM_FIELDS).TITLE] = name;
            fieldsToUpdate[(0, $hjUDQ.ITEM_FIELDS).IS_TITLE_USER_EDITED] = false;
        }
        if (!cardDescription || isDescriptionUserEdited === false) {
            fieldsToUpdate[(0, $hjUDQ.ITEM_FIELDS).DESCRIPTION] = summary;
            fieldsToUpdate[(0, $hjUDQ.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = false;
        } // Updating imageSrc and imageAltText
        let newImageSrc = cardImage || '';
        const newImageAltText = '';
        const coverImage = await fetchCoverImageUrl(objectId, image);
        if (coverImage) {
            const isExternalSiteImage = $c6238f2e36e698c1$var$externalSiteMatcher.test(coverImage);
            if (!(0, $619Qo.isUnsplashImage)(coverImage) && !isExternalSiteImage) // For custom uploaded image save it in format `contentId/imageId`
            newImageSrc = `${objectId}/${coverImage}`;
            else newImageSrc = coverImage;
        } // Do not store private Loom CDN thumbnails (they expire via Policy)
        if ((0, $jlbje.isPrivateLoomImageUrl)(newImageSrc)) newImageSrc = '';
        fieldsToUpdate = {
            ...fieldsToUpdate,
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_SRC]: newImageSrc,
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_ALT_TEXT]: newImageAltText
        };
    } catch (error) {
        submitError?.(error);
    }
    return fieldsToUpdate;
};
const $c6238f2e36e698c1$export$48fc9d47b1ec72d4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(84);
    const { frameParameters: frameParameters, updateFrameFormField: updateFrameFormField, isDisabled: isDisabled } = t0;
    const { cardId: cardId, link: link, title: title, description: description, isTitleUserEdited: isTitleUserEdited, isDescriptionUserEdited: isDescriptionUserEdited, imageSrc: imageSrc, buttonStyle: buttonStyle, buttonText: buttonText } = frameParameters;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { submitError: submitError, cloudId: cloudId } = (0, $cfM7x.useProductDependencies)();
    const [titleValue, setTitleValue] = (0, $cozmU.useState)(title);
    const [descriptionValue, setDescriptionValue] = (0, $cozmU.useState)(description);
    const titleId = `title-field-${cardId}`;
    const descriptionId = `description-field-${cardId}`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== title) {
        t1 = ()=>{
            setTitleValue(title);
        };
        t2 = [
            title
        ];
        $[0] = title;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] !== description) {
        t3 = ()=>{
            setDescriptionValue(description);
        };
        t4 = [
            description
        ];
        $[3] = description;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[6] !== cardId || $[7] !== createAnalyticsEvent || $[8] !== updateFrameFormField) {
        t5 = (event)=>{
            const { value: value } = event.currentTarget;
            setDescriptionValue(value);
            $c6238f2e36e698c1$var$debouncedParametersUpdate(updateFrameFormField, (0, $hjUDQ.ITEM_FIELDS).DESCRIPTION, (0, $hjUDQ.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED, cardId, value, createAnalyticsEvent, (0, $gXR7h.carouselConfigAnalyticSource));
        };
        $[6] = cardId;
        $[7] = createAnalyticsEvent;
        $[8] = updateFrameFormField;
        $[9] = t5;
    } else t5 = $[9];
    const handleDescriptionChange = t5;
    let t6;
    if ($[10] !== cardId || $[11] !== createAnalyticsEvent || $[12] !== updateFrameFormField) {
        t6 = (event_0)=>{
            const { value: value_0 } = event_0.currentTarget;
            setTitleValue(value_0.trimStart());
            $c6238f2e36e698c1$var$debouncedParametersUpdate(updateFrameFormField, (0, $hjUDQ.ITEM_FIELDS).TITLE, (0, $hjUDQ.ITEM_FIELDS).IS_TITLE_USER_EDITED, cardId, value_0.trimStart(), createAnalyticsEvent, (0, $gXR7h.carouselConfigAnalyticSource));
        };
        $[10] = cardId;
        $[11] = createAnalyticsEvent;
        $[12] = updateFrameFormField;
        $[13] = t6;
    } else t6 = $[13];
    const handleTitleOnChange = t6;
    const fetchCoverImageUrl = (0, $g6P9J.useFetchCoverImage)((0, $gXR7h.carouselConfigAnalyticSource));
    let t7;
    if ($[14] !== cardId || $[15] !== description || $[16] !== fetchCoverImageUrl || $[17] !== imageSrc || $[18] !== isDescriptionUserEdited || $[19] !== isTitleUserEdited || $[20] !== submitError || $[21] !== title || $[22] !== updateFrameFormField) {
        t7 = async (selectedLink)=>{
            const fieldsToUpdate = await $c6238f2e36e698c1$var$getFieldsToUpdateOnLinkSelect(selectedLink, fetchCoverImageUrl, imageSrc, title, description, isTitleUserEdited || false, isDescriptionUserEdited || false, submitError);
            updateFrameFormField(cardId, fieldsToUpdate);
        };
        $[14] = cardId;
        $[15] = description;
        $[16] = fetchCoverImageUrl;
        $[17] = imageSrc;
        $[18] = isDescriptionUserEdited;
        $[19] = isTitleUserEdited;
        $[20] = submitError;
        $[21] = title;
        $[22] = updateFrameFormField;
        $[23] = t7;
    } else t7 = $[23];
    const handleSelectLink = t7;
    let t8;
    if ($[24] !== cardId || $[25] !== isDescriptionUserEdited || $[26] !== isTitleUserEdited || $[27] !== updateFrameFormField) {
        t8 = (t9)=>{
            const clearAllFields = t9 === undefined ? false : t9;
            const fieldsToClear = {
                ...(0, $cT2iI.updateLinkAndConfluencePageId)("", ""),
                ...clearAllFields ? {
                    buttonText: "",
                    buttonStyle: (0, $hjUDQ.ButtonStyle).DEFAULT
                } : {}
            };
            if (isTitleUserEdited === false) {
                fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).TITLE] = "";
                fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).IS_TITLE_USER_EDITED] = undefined;
            }
            if (isDescriptionUserEdited === false) {
                fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).DESCRIPTION] = "";
                fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = undefined;
            }
            updateFrameFormField(cardId, fieldsToClear);
        };
        $[24] = cardId;
        $[25] = isDescriptionUserEdited;
        $[26] = isTitleUserEdited;
        $[27] = updateFrameFormField;
        $[28] = t8;
    } else t8 = $[28];
    const handleClearLink = t8;
    let t9;
    if ($[29] !== handleClearLink) {
        t9 = ()=>{
            handleClearLink(true);
        };
        $[29] = handleClearLink;
        $[30] = t9;
    } else t9 = $[30];
    const handleClearButton = t9;
    let t10;
    if ($[31] !== cardId || $[32] !== updateFrameFormField) {
        t10 = (buttonTextPayload)=>{
            updateFrameFormField(cardId, {
                buttonText: buttonTextPayload
            });
        };
        $[31] = cardId;
        $[32] = updateFrameFormField;
        $[33] = t10;
    } else t10 = $[33];
    const updateButtonText = t10;
    let t11;
    if ($[34] !== cardId || $[35] !== updateFrameFormField) {
        t11 = (buttonStylePayload)=>{
            updateFrameFormField(cardId, {
                buttonStyle: buttonStylePayload
            });
        };
        $[34] = cardId;
        $[35] = updateFrameFormField;
        $[36] = t11;
    } else t11 = $[36];
    const updateButtonStyle = t11;
    let t12;
    if ($[37] !== buttonStyle || $[38] !== buttonText || $[39] !== cloudId || $[40] !== handleClearButton || $[41] !== handleClearLink || $[42] !== handleSelectLink || $[43] !== link || $[44] !== updateButtonStyle || $[45] !== updateButtonText) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8mmUh.ButtonConfig), {
            cloudId: cloudId,
            link: link,
            text: buttonText,
            style: buttonStyle,
            handleSelectLink: handleSelectLink,
            handleClearLink: handleClearLink,
            handleClearButton: handleClearButton,
            updateButtonText: updateButtonText,
            updateButtonStyle: updateButtonStyle,
            source: (0, $gXR7h.carouselContentAnalyticSource)
        });
        $[37] = buttonStyle;
        $[38] = buttonText;
        $[39] = cloudId;
        $[40] = handleClearButton;
        $[41] = handleClearLink;
        $[42] = handleSelectLink;
        $[43] = link;
        $[44] = updateButtonStyle;
        $[45] = updateButtonText;
        $[46] = t12;
    } else t12 = $[46];
    let t13;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c518b2619c1f63dc$export$defe85febe8b728c).titleFieldLabel);
        $[47] = t13;
    } else t13 = $[47];
    let t14;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
            showUpdatedStyles: true
        }, t13, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c6238f2e36e698c1$var$RecommendedWrapper, null, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c518b2619c1f63dc$export$defe85febe8b728c).recommendedFieldLabel)));
        $[48] = t14;
    } else t14 = $[48];
    let t15;
    if ($[49] !== titleId) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: titleId
        }, t14);
        $[49] = titleId;
        $[50] = t15;
    } else t15 = $[50];
    let t16;
    if ($[51] !== titleValue) {
        t16 = titleValue?.trimStart();
        $[51] = titleValue;
        $[52] = t16;
    } else t16 = $[52];
    let t17;
    if ($[53] !== formatMessage) {
        t17 = formatMessage((0, $c518b2619c1f63dc$export$defe85febe8b728c).titlePlaceholder);
        $[53] = formatMessage;
        $[54] = t17;
    } else t17 = $[54];
    let t18;
    if ($[55] !== handleTitleOnChange || $[56] !== isDisabled || $[57] !== t16 || $[58] !== t17 || $[59] !== titleId) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            id: titleId,
            value: t16,
            onChange: handleTitleOnChange,
            maxLength: 255,
            isDisabled: isDisabled,
            placeholder: t17
        });
        $[55] = handleTitleOnChange;
        $[56] = isDisabled;
        $[57] = t16;
        $[58] = t17;
        $[59] = titleId;
        $[60] = t18;
    } else t18 = $[60];
    let t19;
    if ($[61] !== t15 || $[62] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $c6238f2e36e698c1$var$fieldWrapperStyles.fieldWrapper,
            direction: "column"
        }, t15, t18);
        $[61] = t15;
        $[62] = t18;
        $[63] = t19;
    } else t19 = $[63];
    let t20;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
            showUpdatedStyles: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c518b2619c1f63dc$export$defe85febe8b728c).descriptionFieldLabel));
        $[64] = t20;
    } else t20 = $[64];
    let t21;
    if ($[65] !== descriptionId) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: descriptionId
        }, t20);
        $[65] = descriptionId;
        $[66] = t21;
    } else t21 = $[66];
    let t22;
    if ($[67] !== descriptionValue) {
        t22 = descriptionValue?.trimStart();
        $[67] = descriptionValue;
        $[68] = t22;
    } else t22 = $[68];
    let t23;
    if ($[69] !== formatMessage) {
        t23 = formatMessage((0, $c518b2619c1f63dc$export$defe85febe8b728c).descriptionPlaceholder);
        $[69] = formatMessage;
        $[70] = t23;
    } else t23 = $[70];
    let t24;
    if ($[71] !== descriptionId || $[72] !== handleDescriptionChange || $[73] !== isDisabled || $[74] !== t22 || $[75] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            id: descriptionId,
            rows: 3,
            value: t22,
            onChange: handleDescriptionChange,
            maxLength: 700,
            isDisabled: isDisabled,
            testId: "frame-description-field",
            placeholder: t23
        });
        $[71] = descriptionId;
        $[72] = handleDescriptionChange;
        $[73] = isDisabled;
        $[74] = t22;
        $[75] = t23;
        $[76] = t24;
    } else t24 = $[76];
    let t25;
    if ($[77] !== t21 || $[78] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $c6238f2e36e698c1$var$fieldWrapperStyles.fieldWrapper,
            direction: "column"
        }, t21, t24);
        $[77] = t21;
        $[78] = t24;
        $[79] = t25;
    } else t25 = $[79];
    let t26;
    if ($[80] !== t12 || $[81] !== t19 || $[82] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t12, t19, t25);
        $[80] = t12;
        $[81] = t19;
        $[82] = t25;
        $[83] = t26;
    } else t26 = $[83];
    return t26;
} : ({ frameParameters: frameParameters, updateFrameFormField: updateFrameFormField, isDisabled: isDisabled })=>{
    const { cardId: cardId, link: link, title: title, description: description, isTitleUserEdited: isTitleUserEdited, isDescriptionUserEdited: isDescriptionUserEdited, imageSrc: imageSrc, buttonStyle: // carousel v2
    buttonStyle, buttonText: buttonText } = frameParameters;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { submitError: submitError, cloudId: cloudId } = (0, $cfM7x.useProductDependencies)();
    const [titleValue, setTitleValue] = (0, $cozmU.useState)(title);
    const [descriptionValue, setDescriptionValue] = (0, $cozmU.useState)(description);
    const titleId = `title-field-${cardId}`;
    const descriptionId = `description-field-${cardId}`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        setTitleValue(title);
    }, [
        title
    ]);
    (0, $cozmU.useEffect)(()=>{
        setDescriptionValue(description);
    }, [
        description
    ]);
    const handleDescriptionChange = (0, $cozmU.useCallback)((event)=>{
        const { value: value } = event.currentTarget;
        setDescriptionValue(value);
        $c6238f2e36e698c1$var$debouncedParametersUpdate(updateFrameFormField, (0, $hjUDQ.ITEM_FIELDS).DESCRIPTION, (0, $hjUDQ.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED, cardId, value, createAnalyticsEvent, (0, $gXR7h.carouselConfigAnalyticSource));
    }, [
        updateFrameFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const handleTitleOnChange = (0, $cozmU.useCallback)((event_0)=>{
        const { value: value_0 } = event_0.currentTarget;
        setTitleValue(value_0.trimStart());
        $c6238f2e36e698c1$var$debouncedParametersUpdate(updateFrameFormField, (0, $hjUDQ.ITEM_FIELDS).TITLE, (0, $hjUDQ.ITEM_FIELDS).IS_TITLE_USER_EDITED, cardId, value_0.trimStart(), createAnalyticsEvent, (0, $gXR7h.carouselConfigAnalyticSource));
    }, [
        updateFrameFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const fetchCoverImageUrl = (0, $g6P9J.useFetchCoverImage)((0, $gXR7h.carouselConfigAnalyticSource));
    const handleSelectLink = (0, $cozmU.useCallback)(async (selectedLink)=>{
        const fieldsToUpdate = await $c6238f2e36e698c1$var$getFieldsToUpdateOnLinkSelect(selectedLink, fetchCoverImageUrl, imageSrc, title, description, isTitleUserEdited || false, isDescriptionUserEdited || false, submitError);
        updateFrameFormField(cardId, fieldsToUpdate);
    }, [
        cardId,
        imageSrc,
        title,
        description,
        isTitleUserEdited,
        isDescriptionUserEdited,
        fetchCoverImageUrl,
        updateFrameFormField,
        submitError
    ]);
    const handleClearLink = (0, $cozmU.useCallback)((clearAllFields = false)=>{
        const fieldsToClear = {
            ...(0, $cT2iI.updateLinkAndConfluencePageId)('', ''),
            ...clearAllFields ? {
                buttonText: '',
                buttonStyle: (0, $hjUDQ.ButtonStyle).DEFAULT
            } : {}
        };
        if (isTitleUserEdited === false) {
            fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).TITLE] = '';
            fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).IS_TITLE_USER_EDITED] = undefined;
        }
        if (isDescriptionUserEdited === false) {
            fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).DESCRIPTION] = '';
            fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = undefined;
        }
        updateFrameFormField(cardId, fieldsToClear);
    }, [
        updateFrameFormField,
        cardId,
        isTitleUserEdited,
        isDescriptionUserEdited
    ]);
    const handleClearButton = ()=>{
        handleClearLink(true);
    };
    const updateButtonText = (0, $cozmU.useCallback)((buttonTextPayload)=>{
        updateFrameFormField(cardId, {
            buttonText: buttonTextPayload
        });
    }, [
        updateFrameFormField,
        cardId
    ]);
    const updateButtonStyle = (0, $cozmU.useCallback)((buttonStylePayload)=>{
        updateFrameFormField(cardId, {
            buttonStyle: buttonStylePayload
        });
    }, [
        updateFrameFormField,
        cardId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8mmUh.ButtonConfig), {
        cloudId: cloudId,
        link: link,
        text: buttonText,
        style: buttonStyle,
        handleSelectLink: handleSelectLink,
        handleClearLink: handleClearLink,
        handleClearButton: handleClearButton,
        updateButtonText: updateButtonText,
        updateButtonStyle: updateButtonStyle,
        source: (0, $gXR7h.carouselContentAnalyticSource)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $c6238f2e36e698c1$var$fieldWrapperStyles.fieldWrapper,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: titleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
        showUpdatedStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c518b2619c1f63dc$export$defe85febe8b728c).titleFieldLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c6238f2e36e698c1$var$RecommendedWrapper, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c518b2619c1f63dc$export$defe85febe8b728c).recommendedFieldLabel)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        id: titleId,
        value: titleValue?.trimStart(),
        onChange: handleTitleOnChange,
        maxLength: 255,
        isDisabled: isDisabled,
        placeholder: formatMessage((0, $c518b2619c1f63dc$export$defe85febe8b728c).titlePlaceholder)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $c6238f2e36e698c1$var$fieldWrapperStyles.fieldWrapper,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: descriptionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
        showUpdatedStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c518b2619c1f63dc$export$defe85febe8b728c).descriptionFieldLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        id: descriptionId,
        rows: 3,
        value: descriptionValue?.trimStart(),
        onChange: handleDescriptionChange,
        maxLength: 700,
        isDisabled: isDisabled,
        testId: "frame-description-field",
        placeholder: formatMessage((0, $c518b2619c1f63dc$export$defe85febe8b728c).descriptionPlaceholder)
    })));
};





const $9681240776b4df13$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    backgroundColor: {
        id: "company-hub.carousel-extension.frame.background.color",
        defaultMessage: "Background color"
    },
    textColor: {
        id: "company-hub.carousel-extension.frame.text.color",
        defaultMessage: "Text color"
    },
    colorValidationSuccessMessage: {
        id: "company-hub.carousel-extension.frame.color-contrast.success",
        defaultMessage: "Your text and background colors work well for readability."
    },
    colorValidationFailMessage: {
        id: "company-hub.carousel-extension.frame.color-contrast.fail",
        defaultMessage: "Your text and background colors don\u2019t work well for readability."
    }
});


const $5fa8ea2ee4806419$var$styles = {
    wrapper: "_1wpz1fhb _2lx21bp4 _19pku2gc _otyru2gc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    bgAndTextColorOptionsWrapper: "_19pkpxbi"
};
const $5fa8ea2ee4806419$export$a2a14dc5e9bae153 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(67);
    const { contentId: contentId, frameParameters: frameParameters, initialUnsplashResults: initialUnsplashResults, isDisabled: isDisabled, showBgAndTextColorOptions: showBgAndTextColorOptions, updateFrameFormField: updateFrameFormField, showMediaPicker: showMediaPicker, showLayout: showLayout } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cardId: cardId, imageSrc: imageSrc, imageAltText: imageAltText, confluencePageId: confluencePageId, backgroundColor: t1, textColor: t2, layout: layout } = frameParameters;
    const backgroundColor = t1 === undefined ? (0, $cT2iI.frameNewParametersV2).backgroundColor : t1;
    const textColor = t2 === undefined ? (0, $cT2iI.frameNewParametersV2).textColor : t2;
    const { isCompanyHub: isCompanyHub, enableLinkInputInMediaPicker: enableLinkInputInMediaPicker, isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $cfM7x.useProductDependencies)();
    let t3;
    if ($[0] !== branding) {
        t3 = branding ?? {};
        $[0] = branding;
        $[1] = t3;
    } else t3 = $[1];
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = t3;
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $4pBmf.useHubTheming)();
    const isV2 = !!theming?.isAdvancedThemingEnabled;
    const palette = isV2 ? theming.palette : undefined;
    const primaryColor = isV2 ? theming.primaryColor : undefined;
    const v2BrandMap = isV2 ? theming.brandBackgroundColorMap : undefined;
    let t4;
    if ($[2] !== backgroundColor || $[3] !== isV2 || $[4] !== palette || $[5] !== primaryColor) {
        t4 = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(backgroundColor, palette, "primary.200", primaryColor) : backgroundColor;
        $[2] = backgroundColor;
        $[3] = isV2;
        $[4] = palette;
        $[5] = primaryColor;
        $[6] = t4;
    } else t4 = $[6];
    const resolvedBackgroundColor = t4;
    let t5;
    if ($[7] !== isV2 || $[8] !== palette || $[9] !== primaryColor || $[10] !== textColor) {
        t5 = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, palette, "primary.1000", (0, $4yUlE.isReadable)("#FFFFFF", primaryColor) ? "#FFFFFF" : "#000000") : textColor;
        $[7] = isV2;
        $[8] = palette;
        $[9] = primaryColor;
        $[10] = textColor;
        $[11] = t5;
    } else t5 = $[11];
    const resolvedTextColor = t5;
    let t6;
    if ($[12] !== resolvedTextColor) {
        t6 = (color)=>(0, $4yUlE.isReadable)(color, resolvedTextColor);
        $[12] = resolvedTextColor;
        $[13] = t6;
    } else t6 = $[13];
    const isReadableBackgroundColor = t6;
    let t7;
    if ($[14] !== resolvedBackgroundColor) {
        t7 = (color_0)=>(0, $4yUlE.isReadable)(color_0, resolvedBackgroundColor);
        $[14] = resolvedBackgroundColor;
        $[15] = t7;
    } else t7 = $[15];
    const isReadableTextColor = t7;
    let t8;
    if ($[16] !== cardId || $[17] !== isV2 || $[18] !== palette || $[19] !== updateFrameFormField) {
        t8 = (bgColor)=>{
            const next = isV2 && palette ? (0, $gKJso.toAdfColor)(bgColor, palette) : bgColor;
            updateFrameFormField(cardId, {
                [(0, $hjUDQ.ITEM_FIELDS).BACKGROUND_COLOR]: next
            });
        };
        $[16] = cardId;
        $[17] = isV2;
        $[18] = palette;
        $[19] = updateFrameFormField;
        $[20] = t8;
    } else t8 = $[20];
    const updateBackgroundColor = t8;
    let t9;
    if ($[21] !== cardId || $[22] !== isV2 || $[23] !== palette || $[24] !== updateFrameFormField) {
        t9 = (color_1)=>{
            const next_0 = isV2 && palette ? (0, $gKJso.toAdfColor)(color_1, palette) : color_1;
            updateFrameFormField(cardId, {
                [(0, $hjUDQ.ITEM_FIELDS).TEXT_COLOR]: next_0
            });
        };
        $[21] = cardId;
        $[22] = isV2;
        $[23] = palette;
        $[24] = updateFrameFormField;
        $[25] = t9;
    } else t9 = $[25];
    const updateTextColor = t9;
    const canShowImagePicker = layout !== (0, $hjUDQ.CommonLayout).NO_IMAGE_BACKGROUND;
    (0, $5ddnJ.useAutoTransitioningColors)(resolvedBackgroundColor, isReadableTextColor, resolvedTextColor, updateTextColor, branding?.defaultParameters);
    let t10;
    if ($[26] !== contentId || $[27] !== frameParameters || $[28] !== showLayout || $[29] !== updateFrameFormField) {
        t10 = showLayout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $07a279c36086d60f$export$23adc972c5b7cdfa), {
            frameParameters: frameParameters,
            updateFrameFormField: updateFrameFormField,
            contentId: contentId
        });
        $[26] = contentId;
        $[27] = frameParameters;
        $[28] = showLayout;
        $[29] = updateFrameFormField;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== frameParameters || $[32] !== isDisabled || $[33] !== updateFrameFormField) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6238f2e36e698c1$export$48fc9d47b1ec72d4), {
            frameParameters: frameParameters,
            isDisabled: isDisabled,
            updateFrameFormField: updateFrameFormField
        });
        $[31] = frameParameters;
        $[32] = isDisabled;
        $[33] = updateFrameFormField;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== canShowImagePicker || $[36] !== cardId || $[37] !== confluencePageId || $[38] !== contentId || $[39] !== enableLinkInputInMediaPicker || $[40] !== imageAltText || $[41] !== imageSrc || $[42] !== initialUnsplashResults || $[43] !== showMediaPicker || $[44] !== updateFrameFormField) {
        t12 = canShowImagePicker && (showMediaPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ZnIz.ImageField), {
            shouldAllowLinkFromUrl: enableLinkInputInMediaPicker,
            analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource),
            itemId: cardId,
            contentId: contentId,
            imageSrc: imageSrc,
            imageAltText: imageAltText,
            updateItemFormField: updateFrameFormField
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cImA8.UnsplashSearchField), {
            analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource),
            idPrefix: "frame",
            itemId: cardId,
            contentId: contentId,
            confluencePageId: confluencePageId,
            imageSrc: imageSrc,
            imageAltText: imageAltText,
            initialUnsplashResults: initialUnsplashResults,
            isNoImageAllowed: false,
            updateItemFormField: updateFrameFormField
        }));
        $[35] = canShowImagePicker;
        $[36] = cardId;
        $[37] = confluencePageId;
        $[38] = contentId;
        $[39] = enableLinkInputInMediaPicker;
        $[40] = imageAltText;
        $[41] = imageSrc;
        $[42] = initialUnsplashResults;
        $[43] = showMediaPicker;
        $[44] = updateFrameFormField;
        $[45] = t12;
    } else t12 = $[45];
    let t13;
    if ($[46] !== backgroundColorMap || $[47] !== brandBackgroundColorMap || $[48] !== emptyColorMap || $[49] !== formatMessage || $[50] !== hideDefaultColorPalette || $[51] !== isCompanyHub || $[52] !== isReadableBackgroundColor || $[53] !== isReadableTextColor || $[54] !== resolvedBackgroundColor || $[55] !== resolvedTextColor || $[56] !== showBgAndTextColorOptions || $[57] !== textColorMap || $[58] !== updateBackgroundColor || $[59] !== updateTextColor || $[60] !== v2BrandMap) {
        t13 = showBgAndTextColorOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200",
            xcss: $5fa8ea2ee4806419$var$styles.bgAndTextColorOptionsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9681240776b4df13$export$defe85febe8b728c).backgroundColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            builtInColorMap: v2BrandMap ? v2BrandMap : hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
            isReadableColor: isReadableBackgroundColor,
            onChange: updateBackgroundColor,
            value: resolvedBackgroundColor,
            pickerTitle: (0, $9681240776b4df13$export$defe85febe8b728c).backgroundColor,
            validationSuccessMessage: formatMessage((0, $9681240776b4df13$export$defe85febe8b728c).colorValidationSuccessMessage),
            validationFailMessage: formatMessage((0, $9681240776b4df13$export$defe85febe8b728c).colorValidationFailMessage),
            showCustomPalette: isCompanyHub,
            analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9681240776b4df13$export$defe85febe8b728c).textColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            builtInColorMap: v2BrandMap ? v2BrandMap : hideDefaultColorPalette ? emptyColorMap : textColorMap,
            isReadableColor: isReadableTextColor,
            onChange: updateTextColor,
            value: resolvedTextColor,
            pickerTitle: (0, $9681240776b4df13$export$defe85febe8b728c).textColor,
            validationSuccessMessage: formatMessage((0, $9681240776b4df13$export$defe85febe8b728c).colorValidationSuccessMessage),
            validationFailMessage: formatMessage((0, $9681240776b4df13$export$defe85febe8b728c).colorValidationFailMessage),
            showCustomPalette: isCompanyHub,
            analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource),
            showTextIcon: true
        })));
        $[46] = backgroundColorMap;
        $[47] = brandBackgroundColorMap;
        $[48] = emptyColorMap;
        $[49] = formatMessage;
        $[50] = hideDefaultColorPalette;
        $[51] = isCompanyHub;
        $[52] = isReadableBackgroundColor;
        $[53] = isReadableTextColor;
        $[54] = resolvedBackgroundColor;
        $[55] = resolvedTextColor;
        $[56] = showBgAndTextColorOptions;
        $[57] = textColorMap;
        $[58] = updateBackgroundColor;
        $[59] = updateTextColor;
        $[60] = v2BrandMap;
        $[61] = t13;
    } else t13 = $[61];
    let t14;
    if ($[62] !== t10 || $[63] !== t11 || $[64] !== t12 || $[65] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $5fa8ea2ee4806419$var$styles.wrapper
        }, t10, t11, t12, t13);
        $[62] = t10;
        $[63] = t11;
        $[64] = t12;
        $[65] = t13;
        $[66] = t14;
    } else t14 = $[66];
    return t14;
} : ({ contentId: contentId, frameParameters: frameParameters, initialUnsplashResults: initialUnsplashResults, isDisabled: isDisabled, showBgAndTextColorOptions: showBgAndTextColorOptions, updateFrameFormField: updateFrameFormField, showMediaPicker: showMediaPicker, showLayout: showLayout })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cardId: cardId, imageSrc: imageSrc, imageAltText: imageAltText, confluencePageId: confluencePageId, backgroundColor: backgroundColor = (0, $cT2iI.frameNewParametersV2).backgroundColor, textColor: textColor = (0, $cT2iI.frameNewParametersV2).textColor, layout: layout } = frameParameters;
    const { isCompanyHub: isCompanyHub, enableLinkInputInMediaPicker: enableLinkInputInMediaPicker, isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $4pBmf.useHubTheming)();
    const isV2 = !!theming?.isAdvancedThemingEnabled;
    const palette = isV2 ? theming.palette : undefined;
    const primaryColor = isV2 ? theming.primaryColor : undefined;
    const v2BrandMap = isV2 ? theming.brandBackgroundColorMap : undefined; // Resolve to literal hex so isReadable in useAutoTransitioningColors works
    // against the actual colour values, not against CSS var refs (which would
    // silently fail).
    const resolvedBackgroundColor = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(backgroundColor, palette, 'primary.200', primaryColor) : backgroundColor;
    const resolvedTextColor = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, palette, 'primary.1000', (0, $4yUlE.isReadable)('#FFFFFF', primaryColor) ? '#FFFFFF' : '#000000') : textColor;
    const isReadableBackgroundColor = (color)=>(0, $4yUlE.isReadable)(color, resolvedTextColor);
    const isReadableTextColor = (color_0)=>(0, $4yUlE.isReadable)(color_0, resolvedBackgroundColor);
    const updateBackgroundColor = (bgColor)=>{
        const next = isV2 && palette ? (0, $gKJso.toAdfColor)(bgColor, palette) : bgColor;
        updateFrameFormField(cardId, {
            [(0, $hjUDQ.ITEM_FIELDS).BACKGROUND_COLOR]: next
        });
    };
    const updateTextColor = (color_1)=>{
        const next_0 = isV2 && palette ? (0, $gKJso.toAdfColor)(color_1, palette) : color_1;
        updateFrameFormField(cardId, {
            [(0, $hjUDQ.ITEM_FIELDS).TEXT_COLOR]: next_0
        });
    };
    const canShowImagePicker = layout !== (0, $hjUDQ.CommonLayout).NO_IMAGE_BACKGROUND;
    (0, $5ddnJ.useAutoTransitioningColors)(resolvedBackgroundColor, isReadableTextColor, resolvedTextColor, updateTextColor, branding?.defaultParameters);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $5fa8ea2ee4806419$var$styles.wrapper
    }, showLayout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $07a279c36086d60f$export$23adc972c5b7cdfa), {
        frameParameters: frameParameters,
        updateFrameFormField: updateFrameFormField,
        contentId: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6238f2e36e698c1$export$48fc9d47b1ec72d4), {
        frameParameters: frameParameters,
        isDisabled: isDisabled,
        updateFrameFormField: updateFrameFormField
    }), canShowImagePicker && (showMediaPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ZnIz.ImageField), {
        shouldAllowLinkFromUrl: enableLinkInputInMediaPicker,
        analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource),
        itemId: cardId,
        contentId: contentId,
        imageSrc: imageSrc,
        imageAltText: imageAltText,
        updateItemFormField: updateFrameFormField
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cImA8.UnsplashSearchField), {
        analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource),
        idPrefix: "frame",
        itemId: cardId,
        contentId: contentId,
        confluencePageId: confluencePageId,
        imageSrc: imageSrc,
        imageAltText: imageAltText,
        initialUnsplashResults: initialUnsplashResults,
        isNoImageAllowed: false,
        updateItemFormField: updateFrameFormField
    })), showBgAndTextColorOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $5fa8ea2ee4806419$var$styles.bgAndTextColorOptionsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9681240776b4df13$export$defe85febe8b728c).backgroundColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        builtInColorMap: v2BrandMap ? v2BrandMap : hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
        isReadableColor: isReadableBackgroundColor,
        onChange: updateBackgroundColor,
        value: resolvedBackgroundColor,
        pickerTitle: (0, $9681240776b4df13$export$defe85febe8b728c).backgroundColor,
        validationSuccessMessage: formatMessage((0, $9681240776b4df13$export$defe85febe8b728c).colorValidationSuccessMessage),
        validationFailMessage: formatMessage((0, $9681240776b4df13$export$defe85febe8b728c).colorValidationFailMessage),
        showCustomPalette: isCompanyHub,
        analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9681240776b4df13$export$defe85febe8b728c).textColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        builtInColorMap: v2BrandMap ? v2BrandMap : hideDefaultColorPalette ? emptyColorMap : textColorMap,
        isReadableColor: isReadableTextColor,
        onChange: updateTextColor,
        value: resolvedTextColor,
        pickerTitle: (0, $9681240776b4df13$export$defe85febe8b728c).textColor,
        validationSuccessMessage: formatMessage((0, $9681240776b4df13$export$defe85febe8b728c).colorValidationSuccessMessage),
        validationFailMessage: formatMessage((0, $9681240776b4df13$export$defe85febe8b728c).colorValidationFailMessage),
        showCustomPalette: isCompanyHub,
        analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource),
        showTextIcon: true
    }))));
};


const $c12d706c7ab456d1$var$actionSubjectIdPostFix = 'Frame';
const $c12d706c7ab456d1$export$3067bcb36d887961 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let framesAreaContainerProps;
    if ($[0] !== t0) {
        ({ ...framesAreaContainerProps } = t0);
        $[0] = t0;
        $[1] = framesAreaContainerProps;
    } else framesAreaContainerProps = $[1];
    const { items: items, contentId: contentId, showBgAndTextColorOptions: showBgAndTextColorOptions, showMediaPicker: showMediaPicker, showLayout: showLayout, updateFrameFormField: updateFrameFormField } = framesAreaContainerProps;
    const initialUnsplashResults = (0, $5eKkh.useInitialUnsplashResults)(items);
    let t1;
    if ($[2] !== contentId || $[3] !== initialUnsplashResults || $[4] !== showBgAndTextColorOptions || $[5] !== showLayout || $[6] !== showMediaPicker || $[7] !== updateFrameFormField) {
        t1 = (frameParameters, isFrameDisabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5fa8ea2ee4806419$export$a2a14dc5e9bae153), {
                contentId: contentId,
                frameParameters: frameParameters,
                initialUnsplashResults: initialUnsplashResults,
                isDisabled: isFrameDisabled,
                showBgAndTextColorOptions: showBgAndTextColorOptions,
                showMediaPicker: showMediaPicker,
                showLayout: showLayout,
                updateFrameFormField: updateFrameFormField
            });
        $[2] = contentId;
        $[3] = initialUnsplashResults;
        $[4] = showBgAndTextColorOptions;
        $[5] = showLayout;
        $[6] = showMediaPicker;
        $[7] = updateFrameFormField;
        $[8] = t1;
    } else t1 = $[8];
    const renderFrameContent = t1;
    let t2;
    if ($[9] !== framesAreaContainerProps || $[10] !== renderFrameContent) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jmFR8.ItemsListBuilder), {
            analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource),
            actionSubjectIdPostFix: $c12d706c7ab456d1$var$actionSubjectIdPostFix,
            renderItemContent: renderFrameContent,
            itemLabel: (0, $gcu7p.ITEM_LABEL).FRAME,
            ...framesAreaContainerProps
        });
        $[9] = framesAreaContainerProps;
        $[10] = renderFrameContent;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
} : ({ ...framesAreaContainerProps })=>{
    const { items: items, contentId: contentId, showBgAndTextColorOptions: showBgAndTextColorOptions, showMediaPicker: showMediaPicker, showLayout: showLayout, updateFrameFormField: updateFrameFormField } = framesAreaContainerProps;
    const initialUnsplashResults = (0, $5eKkh.useInitialUnsplashResults)(items);
    const renderFrameContent = (frameParameters, isFrameDisabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5fa8ea2ee4806419$export$a2a14dc5e9bae153), {
            contentId: contentId,
            frameParameters: frameParameters,
            initialUnsplashResults: initialUnsplashResults,
            isDisabled: isFrameDisabled,
            showBgAndTextColorOptions: showBgAndTextColorOptions,
            showMediaPicker: showMediaPicker,
            showLayout: showLayout,
            updateFrameFormField: updateFrameFormField
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jmFR8.ItemsListBuilder), {
        analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource),
        actionSubjectIdPostFix: $c12d706c7ab456d1$var$actionSubjectIdPostFix,
        renderItemContent: renderFrameContent,
        itemLabel: (0, $gcu7p.ITEM_LABEL).FRAME,
        ...framesAreaContainerProps
    });
};





const $fc8fd7435e1c1593$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "company-hub.carousel-extension.config-panel.title",
        defaultMessage: "Carousel"
    },
    framesInvalidMessage: {
        id: "company-hub.carousel-extension.config-panel.field.frames.error.invalid-list",
        defaultMessage: "Add frames"
    },
    preambleV2: {
        id: "company-hub.carousel-extension.config-panel.preamble-v2",
        defaultMessage: "Design a set of up to {number} rotating frames. {supportLink}"
    },
    preambleV2WithoutSupportLink: {
        id: "company-hub.carousel-extension.config-panel.preamble-v2-without-support-link",
        defaultMessage: "Design a set of up to {number} rotating frames."
    },
    preambleSupportLinkLabelV2: {
        id: "company-hub.carousel-extension.config-panel.preamble-link.label-v2",
        defaultMessage: "Learn more about carousels"
    },
    stylesTabLabel: {
        id: "company-hub.carousel-extension.config-panel.tab.styles.label",
        defaultMessage: "Styles"
    },
    contentTabLabel: {
        id: "company-hub.carousel-extension.config-panel.tab.content.label",
        defaultMessage: "Content"
    },
    styleSectionGeneralTitle: {
        id: "company-hub.carousel-extension.config-panel.style.general.title",
        defaultMessage: "General"
    },
    styleSectionNavigationTitle: {
        id: "company-hub.carousel-extension.config-panel.style.navigation.title",
        defaultMessage: "Navigation"
    },
    addFrameText: {
        id: "company-hub.carousel-extension.config-panel.add-frame-cta",
        defaultMessage: "Add frame"
    }
});


















var $1ipaC = parcelRequire("1ipaC");


var $4WDWC = parcelRequire("4WDWC");





var $iJCWb = parcelRequire("iJCWb");


var $eafQX = parcelRequire("eafQX");




















var $fodiz = parcelRequire("fodiz");


var $lpNn5 = parcelRequire("lpNn5");


var $b7jDA = parcelRequire("b7jDA");







const $9cdff71fa13dcc2d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    autoplayLabel: {
        id: "company-hub.carousel-extension.config-panel.styles.autoplay-label",
        defaultMessage: "Autoplay"
    },
    autoplayTooltipContent: {
        id: "company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content",
        defaultMessage: "Set your carousel to scroll automatically every {number} seconds in view mode"
    }
});


const $2db2030020a0ba23$export$20a10abef505ee19 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { isAutoplayEnabled: isAutoplayEnabled, updateMainFormField: updateMainFormField } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isAutoplayEnabled || $[2] !== updateMainFormField) {
        t1 = ()=>{
            updateMainFormField({
                isAutoplayEnabled: !isAutoplayEnabled
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "toggle",
                    actionSubjectId: "autoplayToggle",
                    source: (0, $gXR7h.carouselConfigAnalyticSource)
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isAutoplayEnabled;
        $[2] = updateMainFormField;
        $[3] = t1;
    } else t1 = $[3];
    const handleChange = t1;
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $9cdff71fa13dcc2d$export$defe85febe8b728c).autoplayLabel);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== formatMessage) {
        t3 = formatMessage((0, $9cdff71fa13dcc2d$export$defe85febe8b728c).autoplayTooltipContent, {
            number: (0, $gXR7h.AUTOPLAY_SECONDS)
        });
        $[6] = formatMessage;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            testId: "autoplay-information-icon",
            label: "autoplay-information",
            color: "var(--ds-icon-discovery, #AF59E1)"
        });
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t3,
            position: "bottom"
        }, t4);
        $[9] = t3;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== handleChange || $[12] !== isAutoplayEnabled || $[13] !== t2 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
            label: t2,
            Icon: t5,
            isChecked: isAutoplayEnabled,
            onChange: handleChange
        });
        $[11] = handleChange;
        $[12] = isAutoplayEnabled;
        $[13] = t2;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ isAutoplayEnabled: isAutoplayEnabled, updateMainFormField: updateMainFormField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleChange = (0, $cozmU.useCallback)(()=>{
        updateMainFormField({
            isAutoplayEnabled: !isAutoplayEnabled
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'toggle',
                actionSubjectId: 'autoplayToggle',
                source: (0, $gXR7h.carouselConfigAnalyticSource)
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isAutoplayEnabled,
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
        label: formatMessage((0, $9cdff71fa13dcc2d$export$defe85febe8b728c).autoplayLabel),
        Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $9cdff71fa13dcc2d$export$defe85febe8b728c).autoplayTooltipContent, {
                number: (0, $gXR7h.AUTOPLAY_SECONDS)
            }),
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            testId: "autoplay-information-icon",
            label: "autoplay-information",
            color: "var(--ds-icon-discovery, #AF59E1)"
        })),
        isChecked: isAutoplayEnabled,
        onChange: handleChange
    });
};





const $6786a7eb9ec98a62$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cornerRadius: {
        id: "company-hub.carousel-extension.config.corner.radius.non-final",
        defaultMessage: "Corners"
    }
});


const $9ac0201e623af209$export$82b81ff3fcd805f0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { isCompanyHub: isCompanyHub, isAutoplayEnabled: isAutoplayEnabled, updateMainFormField: updateMainFormField, cornerStyle: cornerStyle, cornerRadius: cornerRadius, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const theming = (0, $4pBmf.useHubTheming)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== source || $[2] !== updateMainFormField) {
        t1 = (newCornerStyle)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "cornerStyling",
                    source: source,
                    attributes: {
                        cornerStyle: newCornerStyle
                    }
                }
            }).fire();
            updateMainFormField({
                cornerStyle: newCornerStyle
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = updateMainFormField;
        $[3] = t1;
    } else t1 = $[3];
    const handleCornerStyleChange = t1;
    let t2;
    if ($[4] !== updateMainFormField) {
        t2 = (newCornerRadius)=>{
            updateMainFormField({
                cornerRadius: newCornerRadius
            });
        };
        $[4] = updateMainFormField;
        $[5] = t2;
    } else t2 = $[5];
    const handleCornerRadiusChange = t2;
    let t3;
    if ($[6] !== isAutoplayEnabled || $[7] !== updateMainFormField) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2db2030020a0ba23$export$20a10abef505ee19), {
            isAutoplayEnabled: isAutoplayEnabled,
            updateMainFormField: updateMainFormField
        });
        $[6] = isAutoplayEnabled;
        $[7] = updateMainFormField;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== cornerRadius || $[10] !== cornerStyle || $[11] !== handleCornerRadiusChange || $[12] !== isCompanyHub || $[13] !== isCornerRadiusEnabled || $[14] !== theming?.cornerRadius) {
        t4 = isCompanyHub && isCornerRadiusEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
            label: (0, $6786a7eb9ec98a62$export$defe85febe8b728c).cornerRadius,
            minValue: (0, $4WDWC.HUB_CORNER_RADIUS_MIN),
            maxValue: (0, $4WDWC.HUB_CORNER_RADIUS_MAX),
            step: (0, $4WDWC.HUB_CORNER_RADIUS_STEP),
            value: (0, $4WDWC.resolveHubCornerRadius)((0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) ?? theming?.cornerRadius),
            updateRangeValue: handleCornerRadiusChange,
            analyticSource: "carouselExtensionConfigCornerRadius",
            prefix: "cornerRadius",
            unit: "px"
        });
        $[9] = cornerRadius;
        $[10] = cornerStyle;
        $[11] = handleCornerRadiusChange;
        $[12] = isCompanyHub;
        $[13] = isCornerRadiusEnabled;
        $[14] = theming?.cornerRadius;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== cornerStyle || $[17] !== handleCornerStyleChange || $[18] !== isCompanyHub || $[19] !== isCornerRadiusEnabled) {
        t5 = isCompanyHub && !isCornerRadiusEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ipaC.CornerStyleConfig), {
            cornerStyleValue: cornerStyle || (0, $cT2iI.carouselNewParametersV2).cornerStyle,
            updateCornerStyle: handleCornerStyleChange,
            roundCornerValue: (0, $hjUDQ.CornerStyle).ROUNDED,
            squareCornerValue: (0, $hjUDQ.CornerStyle).SQUARED
        });
        $[16] = cornerStyle;
        $[17] = handleCornerStyleChange;
        $[18] = isCompanyHub;
        $[19] = isCornerRadiusEnabled;
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== t3 || $[22] !== t4 || $[23] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4, t5);
        $[21] = t3;
        $[22] = t4;
        $[23] = t5;
        $[24] = t6;
    } else t6 = $[24];
    return t6;
} : ({ isCompanyHub: isCompanyHub, isAutoplayEnabled: isAutoplayEnabled, updateMainFormField: updateMainFormField, cornerStyle: cornerStyle, cornerRadius: cornerRadius, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const theming = (0, $4pBmf.useHubTheming)();
    const handleCornerStyleChange = (0, $cozmU.useCallback)((newCornerStyle)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'cornerStyling',
                source: source,
                attributes: {
                    cornerStyle: newCornerStyle
                }
            }
        }).fire();
        updateMainFormField({
            cornerStyle: newCornerStyle
        });
    }, [
        createAnalyticsEvent,
        source,
        updateMainFormField
    ]);
    const handleCornerRadiusChange = (0, $cozmU.useCallback)((newCornerRadius)=>{
        updateMainFormField({
            cornerRadius: newCornerRadius
        });
    }, [
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2db2030020a0ba23$export$20a10abef505ee19), {
        isAutoplayEnabled: isAutoplayEnabled,
        updateMainFormField: updateMainFormField
    }), isCompanyHub && isCornerRadiusEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
        label: (0, $6786a7eb9ec98a62$export$defe85febe8b728c).cornerRadius,
        minValue: (0, $4WDWC.HUB_CORNER_RADIUS_MIN),
        maxValue: (0, $4WDWC.HUB_CORNER_RADIUS_MAX),
        step: (0, $4WDWC.HUB_CORNER_RADIUS_STEP),
        value: (0, $4WDWC.resolveHubCornerRadius)((0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) ?? theming?.cornerRadius),
        updateRangeValue: handleCornerRadiusChange,
        analyticSource: "carouselExtensionConfigCornerRadius",
        prefix: "cornerRadius",
        unit: "px"
    }), isCompanyHub && !isCornerRadiusEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ipaC.CornerStyleConfig), {
        cornerStyleValue: cornerStyle || (0, $cT2iI.carouselNewParametersV2).cornerStyle,
        updateCornerStyle: handleCornerStyleChange,
        roundCornerValue: (0, $hjUDQ.CornerStyle).ROUNDED,
        squareCornerValue: (0, $hjUDQ.CornerStyle).SQUARED
    }));
};





















var $cJ0FD = parcelRequire("cJ0FD");









var $4ikjJ = parcelRequire("4ikjJ");

var $e416dd2eb3dd671e$exports = {};
$e416dd2eb3dd671e$exports = new URL("ProgressCirclesNavigation.e2e6ad70.svg", import.meta.url).toString();

var $6074889a2c908226$exports = {};
$6074889a2c908226$exports = new URL("ThumbnailNavigation.7523958e.svg", import.meta.url).toString();






var $4MaGu = parcelRequire("4MaGu");




const $9033da1f2c125246$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    progressCirclesNavigationStyleLabel: {
        id: "company-hub.carousel-extension.config-panel.navigation.progress-circles",
        defaultMessage: "Progress circles"
    },
    thumbnailsNavigationStyleLabel: {
        id: "company-hub.carousel-extension.config-panel.navigation.thumbnails",
        defaultMessage: "Thumbnails"
    }
});


const $e5fa7d5cfa674600$var$styles = {
    border: "_19itia51 _2rko12b0",
    borderSelected: "_1h6d1w55",
    optionContainer: "_bfhksm61 _n3tdu2gc",
    optionImage: "_18zru2gc _1bsb1osq _ca0qutpp _n3td1b66"
};
const $e5fa7d5cfa674600$var$navigationOptions = [
    {
        navigationOption: (0, $4MaGu.NavigationStyle).PROGRESS_CIRCLES,
        optionImage: (0, (/*@__PURE__*/$parcel$interopDefault($e416dd2eb3dd671e$exports))),
        label: (0, $9033da1f2c125246$export$defe85febe8b728c).progressCirclesNavigationStyleLabel
    },
    {
        navigationOption: (0, $4MaGu.NavigationStyle).THUMBNAILS,
        optionImage: (0, (/*@__PURE__*/$parcel$interopDefault($6074889a2c908226$exports))),
        label: (0, $9033da1f2c125246$export$defe85febe8b728c).thumbnailsNavigationStyleLabel
    }
];
const $e5fa7d5cfa674600$export$8be72cf8db455613 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { navigationType: t1, updateMainFormField: updateMainFormField } = t0;
    const navigationType = t1 === undefined ? (0, $4MaGu.NavigationStyle).PROGRESS_CIRCLES : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== updateMainFormField) {
        t2 = (selectedNavigationOption)=>{
            updateMainFormField({
                navigationStyle: selectedNavigationOption
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationStyle",
                    actionSubjectId: "configPanelNavigationStyle",
                    source: (0, $gXR7h.carouselConfigAnalyticSource),
                    attributes: {
                        selectedValue: selectedNavigationOption
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = updateMainFormField;
        $[2] = t2;
    } else t2 = $[2];
    const handleNavigationTypeUpdate = t2;
    let t3;
    if ($[3] !== handleNavigationTypeUpdate || $[4] !== navigationType) {
        t3 = $e5fa7d5cfa674600$var$navigationOptions.map((t4)=>{
            const { navigationOption: navigationOption, optionImage: optionImage, label: label } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($e5fa7d5cfa674600$var$styles.border, $e5fa7d5cfa674600$var$styles.optionContainer, navigationType === navigationOption && $e5fa7d5cfa674600$var$styles.borderSelected),
                key: navigationOption
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($e5fa7d5cfa674600$var$styles.optionImage)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                src: optionImage,
                alt: "",
                testId: `${navigationOption}--image`
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                onChange: ()=>handleNavigationTypeUpdate(navigationOption),
                value: navigationOption,
                testId: `${navigationOption}${navigationType === navigationOption ? "--selected" : ""}`,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    size: "small",
                    align: "center",
                    weight: "semibold"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)),
                isChecked: navigationType === navigationOption
            }));
        });
        $[3] = handleNavigationTypeUpdate;
        $[4] = navigationType;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, t3));
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ navigationType: navigationType = (0, $4MaGu.NavigationStyle).PROGRESS_CIRCLES, updateMainFormField: updateMainFormField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleNavigationTypeUpdate = (selectedNavigationOption)=>{
        updateMainFormField({
            navigationStyle: selectedNavigationOption
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationStyle',
                actionSubjectId: 'configPanelNavigationStyle',
                source: (0, $gXR7h.carouselConfigAnalyticSource),
                attributes: {
                    selectedValue: selectedNavigationOption
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, $e5fa7d5cfa674600$var$navigationOptions.map(({ navigationOption: navigationOption, optionImage: optionImage, label: label })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($e5fa7d5cfa674600$var$styles.border, $e5fa7d5cfa674600$var$styles.optionContainer, navigationType === navigationOption && $e5fa7d5cfa674600$var$styles.borderSelected),
            key: navigationOption
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($e5fa7d5cfa674600$var$styles.optionImage)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: optionImage,
            alt: "",
            testId: `${navigationOption}--image`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
            onChange: ()=>handleNavigationTypeUpdate(navigationOption),
            value: navigationOption,
            testId: `${navigationOption}${navigationType === navigationOption ? '--selected' : ''}`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                align: "center",
                weight: "semibold"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)),
            isChecked: navigationType === navigationOption
        }));
    })));
};


const $5b5e113a5fd60dc8$var$SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/add-a-trio-of-dynamic-frames-to-your-page-with-carousel/';
const $5b5e113a5fd60dc8$var$TRIGGER_BUTTON_KEYS = [
    'Enter',
    'Spacebar',
    ' '
];
var $5b5e113a5fd60dc8$var$TabValues = /*#__PURE__*/ function(TabValues) {
    TabValues["STYLES"] = "styles";
    TabValues["CONTENT"] = "content";
    return TabValues;
}($5b5e113a5fd60dc8$var$TabValues || {});
const $5b5e113a5fd60dc8$var$styles = {
    carouselListBuilderFooterWrapper: "_zulpu2gc _1rjc1ejb _1e0c1txw _2lx21bp4",
    stickyFooter: "_18zr1b66 _195gr5cr _kqsw1if8 _94n5ze3t _bfhkvuon",
    disabledContentWrapper: "_80om13gf",
    supportLinkWrapper: "_otyrx0bf"
};
const $5b5e113a5fd60dc8$export$97c0055a2666fa5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(74);
    const { contentId: contentId, closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== editorActions || $[1] !== localId) {
        t1 = {
            localId: localId,
            editorActions: editorActions
        };
        $[0] = editorActions;
        $[1] = localId;
        $[2] = t1;
    } else t1 = $[2];
    const { carouselActions: carouselActions, carouselParameters: carouselParameters } = (0, $cT2iI.useCarouselExtensionParametersAndActions)(t1);
    const framesListRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[3] !== carouselParameters) {
        t2 = carouselParameters || {};
        $[3] = carouselParameters;
        $[4] = t2;
    } else t2 = $[4];
    const { cards: frames, isAutoplayEnabled: isAutoplayEnabled, cornerStyle: cornerStyle, cornerRadius: cornerRadius, navigationStyle: navigationStyle } = t2;
    const { addFrame: addFrame, removeFrame: removeFrame, updateFrameFormField: updateFrameFormField, updateMainFormField: updateMainFormField } = carouselActions;
    const { isCompanyHub: isCompanyHub, showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $cfM7x.useProductDependencies)();
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const hasReachedFrameLimit = frames?.length >= (0, $gXR7h.FRAMES_LIMIT_V2);
    const [tabSelected, setTabSelected] = (0, $cozmU.useState)("styles");
    const { setIsInViewMode: setIsInViewMode } = (0, $bIp5p.useExtensionsActions)();
    let t3;
    let t4;
    if ($[5] !== setIsInViewMode) {
        t3 = ()=>{
            setIsInViewMode(false);
        };
        t4 = [
            setIsInViewMode
        ];
        $[5] = setIsInViewMode;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (event)=>{
            if ($5b5e113a5fd60dc8$var$TRIGGER_BUTTON_KEYS.includes(event.key)) setTimeout(()=>{
                (framesListRef?.current?.lastChild).focus();
            }, 100);
        };
        $[8] = t5;
    } else t5 = $[8];
    const handleAddFrameKeyPress = t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (tab)=>{
            setTabSelected(tab.value);
        };
        $[9] = t6;
    } else t6 = $[9];
    const handleTabClick = t6;
    let t7;
    if ($[10] !== addFrame || $[11] !== frames?.length || $[12] !== hasReachedFrameLimit || $[13] !== isDisabled || $[14] !== tabSelected) {
        t7 = ()=>{
            const isContentTabSelected = tabSelected === "content";
            if (isDisabled) return null;
            const showAddFramesButton = !hasReachedFrameLimit && isContentTabSelected;
            const showFramesErrorMessage = !frames?.length && isContentTabSelected;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $5b5e113a5fd60dc8$var$styles.stickyFooter
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $5b5e113a5fd60dc8$var$styles.carouselListBuilderFooterWrapper
            }, showAddFramesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $chOte.AddItemButton), {
                addItem: addFrame,
                label: (0, $fc8fd7435e1c1593$export$defe85febe8b728c).addFrameText,
                onAddItemKeyPress: handleAddFrameKeyPress,
                analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource),
                actionSubjectIdSuffix: "Carousel"
            }), showFramesErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5KFAG.FormFieldErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fc8fd7435e1c1593$export$defe85febe8b728c).framesInvalidMessage)), !isContentTabSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
                source: (0, $gXR7h.carouselContentAnalyticSource),
                type: (0, $hjUDQ.FeedbackType).CAROUSEL
            })));
        };
        $[10] = addFrame;
        $[11] = frames?.length;
        $[12] = hasReachedFrameLimit;
        $[13] = isDisabled;
        $[14] = tabSelected;
        $[15] = t7;
    } else t7 = $[15];
    const renderConfigPanelFooter = t7;
    if (!carouselParameters) {
        let t8;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6u4w.NoExtensionData), {
                source: (0, $gXR7h.carouselExtensionKey),
                isConfigPanel: true
            });
            $[16] = t8;
        } else t8 = $[16];
        return t8;
    }
    let t8;
    if ($[17] !== updateMainFormField) {
        t8 = (frames_0)=>updateMainFormField({
                cards: frames_0
            });
        $[17] = updateMainFormField;
        $[18] = t8;
    } else t8 = $[18];
    const updateFrames = t8;
    let t9;
    if ($[19] !== formatMessage) {
        t9 = formatMessage((0, $fc8fd7435e1c1593$export$defe85febe8b728c).stylesTabLabel);
        $[19] = formatMessage;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== formatMessage) {
        t10 = formatMessage((0, $fc8fd7435e1c1593$export$defe85febe8b728c).styleSectionGeneralTitle);
        $[21] = formatMessage;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== cornerRadius || $[24] !== cornerStyle || $[25] !== isAutoplayEnabled || $[26] !== isCompanyHub || $[27] !== updateMainFormField) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ac0201e623af209$export$82b81ff3fcd805f0), {
            isCompanyHub: isCompanyHub,
            isAutoplayEnabled: isAutoplayEnabled,
            cornerStyle: cornerStyle,
            cornerRadius: cornerRadius,
            updateMainFormField: updateMainFormField,
            source: (0, $gXR7h.carouselConfigAnalyticSource)
        });
        $[23] = cornerRadius;
        $[24] = cornerStyle;
        $[25] = isAutoplayEnabled;
        $[26] = isCompanyHub;
        $[27] = updateMainFormField;
        $[28] = t11;
    } else t11 = $[28];
    let t12;
    if ($[29] !== t10 || $[30] !== t11) {
        t12 = {
            sectionId: "general",
            title: t10,
            defaultIsExpanded: true,
            component: t11
        };
        $[29] = t10;
        $[30] = t11;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== formatMessage) {
        t13 = formatMessage((0, $fc8fd7435e1c1593$export$defe85febe8b728c).styleSectionNavigationTitle);
        $[32] = formatMessage;
        $[33] = t13;
    } else t13 = $[33];
    let t14;
    if ($[34] !== navigationStyle || $[35] !== updateMainFormField) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5fa7d5cfa674600$export$8be72cf8db455613), {
            updateMainFormField: updateMainFormField,
            navigationType: navigationStyle
        });
        $[34] = navigationStyle;
        $[35] = updateMainFormField;
        $[36] = t14;
    } else t14 = $[36];
    let t15;
    if ($[37] !== t13 || $[38] !== t14) {
        t15 = {
            sectionId: "navigation",
            title: t13,
            defaultIsExpanded: false,
            component: t14
        };
        $[37] = t13;
        $[38] = t14;
        $[39] = t15;
    } else t15 = $[39];
    let t16;
    if ($[40] !== t12 || $[41] !== t15) {
        t16 = [
            t12,
            t15
        ];
        $[40] = t12;
        $[41] = t15;
        $[42] = t16;
    } else t16 = $[42];
    let t17;
    if ($[43] !== t16 || $[44] !== t9) {
        t17 = {
            label: t9,
            value: "styles",
            tabContent: t16
        };
        $[43] = t16;
        $[44] = t9;
        $[45] = t17;
    } else t17 = $[45];
    let t18;
    if ($[46] !== formatMessage) {
        t18 = formatMessage((0, $fc8fd7435e1c1593$export$defe85febe8b728c).contentTabLabel);
        $[46] = formatMessage;
        $[47] = t18;
    } else t18 = $[47];
    const t19 = isDisabled && $5b5e113a5fd60dc8$var$styles.disabledContentWrapper;
    let t20;
    if ($[48] !== contentId || $[49] !== frames || $[50] !== removeFrame || $[51] !== updateFrameFormField || $[52] !== updateFrames) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c12d706c7ab456d1$export$3067bcb36d887961), {
            items: frames,
            itemsListRef: framesListRef,
            contentId: contentId,
            removeItem: removeFrame,
            updateFrameFormField: updateFrameFormField,
            updateItems: updateFrames,
            showBgAndTextColorOptions: true,
            showMediaPicker: true,
            showLayout: true,
            shouldUseCardV2UI: true
        });
        $[48] = contentId;
        $[49] = frames;
        $[50] = removeFrame;
        $[51] = updateFrameFormField;
        $[52] = updateFrames;
        $[53] = t20;
    } else t20 = $[53];
    let t21;
    if ($[54] !== t19 || $[55] !== t20) {
        t21 = [
            {
                sectionId: "frames",
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    direction: "column",
                    gap: "space.300",
                    xcss: t19
                }, t20)
            }
        ];
        $[54] = t19;
        $[55] = t20;
        $[56] = t21;
    } else t21 = $[56];
    let t22;
    if ($[57] !== t18 || $[58] !== t21) {
        t22 = {
            label: t18,
            value: "content",
            tabContent: t21
        };
        $[57] = t18;
        $[58] = t21;
        $[59] = t22;
    } else t22 = $[59];
    let t23;
    if ($[60] !== t17 || $[61] !== t22) {
        t23 = [
            t17,
            t22
        ];
        $[60] = t17;
        $[61] = t22;
        $[62] = t23;
    } else t23 = $[62];
    const tabSections = t23;
    let t24;
    if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fc8fd7435e1c1593$export$defe85febe8b728c).title);
        $[63] = t24;
    } else t24 = $[63];
    const t25 = showConfigPreambleSupportLink ? (0, $fc8fd7435e1c1593$export$defe85febe8b728c).preambleV2 : (0, $fc8fd7435e1c1593$export$defe85febe8b728c).preambleV2WithoutSupportLink;
    let t26;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = {
            number: (0, $gXR7h.FRAMES_LIMIT_V2),
            supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                target: "_blank",
                href: $5b5e113a5fd60dc8$var$SUPPORT_LINK
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fc8fd7435e1c1593$export$defe85febe8b728c).preambleSupportLinkLabelV2))
        };
        $[64] = t26;
    } else t26 = $[64];
    let t27;
    if ($[65] !== t25) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b5e113a5fd60dc8$var$styles.supportLinkWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...t25,
            values: t26
        }));
        $[65] = t25;
        $[66] = t27;
    } else t27 = $[66];
    let t28;
    if ($[67] !== tabSections) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cGll.PremiumGateForExtensionConfigPanel), {
            feature: "premiumCarouselConfig"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zyjT.ConfigPanelGrouping), {
            source: (0, $gXR7h.carouselConfigAnalyticSource),
            tabSections: tabSections,
            onTabClick: handleTabClick
        }));
        $[67] = tabSections;
        $[68] = t28;
    } else t28 = $[68];
    let t29;
    if ($[69] !== closeConfigPanel || $[70] !== renderConfigPanelFooter || $[71] !== t27 || $[72] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
            title: t24,
            footerComponent: renderConfigPanelFooter,
            closeConfigPanel: closeConfigPanel
        }, t27, t28);
        $[69] = closeConfigPanel;
        $[70] = renderConfigPanelFooter;
        $[71] = t27;
        $[72] = t28;
        $[73] = t29;
    } else t29 = $[73];
    return t29;
} : ({ contentId: contentId, closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { carouselActions: carouselActions, carouselParameters: carouselParameters } = (0, $cT2iI.useCarouselExtensionParametersAndActions)({
        localId: localId,
        editorActions: editorActions
    });
    const framesListRef = (0, $cozmU.useRef)(null);
    const { cards: frames, isAutoplayEnabled: isAutoplayEnabled, cornerStyle: cornerStyle, cornerRadius: cornerRadius, navigationStyle: navigationStyle } = carouselParameters || {};
    const { addFrame: addFrame, removeFrame: removeFrame, updateFrameFormField: updateFrameFormField, updateMainFormField: updateMainFormField } = carouselActions;
    const { isCompanyHub: isCompanyHub, showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $cfM7x.useProductDependencies)();
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const CURRENT_FRAMES_LIMIT = (0, $gXR7h.FRAMES_LIMIT_V2);
    const hasReachedFrameLimit = frames?.length >= CURRENT_FRAMES_LIMIT;
    const [tabSelected, setTabSelected] = (0, $cozmU.useState)("styles");
    const { setIsInViewMode: setIsInViewMode } = (0, $bIp5p.useExtensionsActions)();
    (0, $cozmU.useEffect)(()=>{
        setIsInViewMode(false);
    }, [
        setIsInViewMode
    ]);
    const handleAddFrameKeyPress = (event)=>{
        if ($5b5e113a5fd60dc8$var$TRIGGER_BUTTON_KEYS.includes(event.key)) setTimeout(()=>{
            (framesListRef?.current?.lastChild).focus();
        }, 100);
    };
    const handleTabClick = (0, $cozmU.useCallback)((tab)=>{
        setTabSelected(tab.value);
    }, []);
    const renderConfigPanelFooter = (0, $cozmU.useCallback)(()=>{
        const isContentTabSelected = tabSelected === "content"; // when Carousel is disabled (ie. premium gated), don't show the footer
        if (isDisabled) return null;
        const showAddFramesButton = !hasReachedFrameLimit && isContentTabSelected;
        const showFramesErrorMessage = !frames?.length && isContentTabSelected;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b5e113a5fd60dc8$var$styles.stickyFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $5b5e113a5fd60dc8$var$styles.carouselListBuilderFooterWrapper
        }, showAddFramesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $chOte.AddItemButton), {
            addItem: addFrame,
            label: (0, $fc8fd7435e1c1593$export$defe85febe8b728c).addFrameText,
            onAddItemKeyPress: handleAddFrameKeyPress,
            analyticsSource: (0, $gXR7h.carouselConfigAnalyticSource),
            actionSubjectIdSuffix: "Carousel"
        }), showFramesErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5KFAG.FormFieldErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fc8fd7435e1c1593$export$defe85febe8b728c).framesInvalidMessage)), !isContentTabSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
            source: (0, $gXR7h.carouselContentAnalyticSource),
            type: (0, $hjUDQ.FeedbackType).CAROUSEL
        })));
    }, [
        frames,
        addFrame,
        isDisabled,
        hasReachedFrameLimit,
        tabSelected
    ]);
    if (!carouselParameters) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6u4w.NoExtensionData), {
        source: (0, $gXR7h.carouselExtensionKey),
        isConfigPanel: true
    });
    const updateFrames = (frames_0)=>updateMainFormField({
            cards: frames_0
        });
    const tabSections = [
        {
            label: formatMessage((0, $fc8fd7435e1c1593$export$defe85febe8b728c).stylesTabLabel),
            value: "styles",
            tabContent: [
                {
                    sectionId: 'general',
                    title: formatMessage((0, $fc8fd7435e1c1593$export$defe85febe8b728c).styleSectionGeneralTitle),
                    defaultIsExpanded: true,
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ac0201e623af209$export$82b81ff3fcd805f0), {
                        isCompanyHub: isCompanyHub,
                        isAutoplayEnabled: isAutoplayEnabled,
                        cornerStyle: cornerStyle,
                        cornerRadius: cornerRadius,
                        updateMainFormField: updateMainFormField,
                        source: (0, $gXR7h.carouselConfigAnalyticSource)
                    })
                },
                {
                    sectionId: 'navigation',
                    title: formatMessage((0, $fc8fd7435e1c1593$export$defe85febe8b728c).styleSectionNavigationTitle),
                    defaultIsExpanded: false,
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5fa7d5cfa674600$export$8be72cf8db455613), {
                        updateMainFormField: updateMainFormField,
                        navigationType: navigationStyle
                    })
                }
            ]
        },
        {
            label: formatMessage((0, $fc8fd7435e1c1593$export$defe85febe8b728c).contentTabLabel),
            value: "content",
            tabContent: [
                {
                    sectionId: 'frames',
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                        direction: "column",
                        gap: "space.300",
                        xcss: isDisabled && $5b5e113a5fd60dc8$var$styles.disabledContentWrapper
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c12d706c7ab456d1$export$3067bcb36d887961), {
                        items: frames,
                        itemsListRef: framesListRef,
                        contentId: contentId,
                        removeItem: removeFrame,
                        updateFrameFormField: updateFrameFormField,
                        updateItems: updateFrames,
                        showBgAndTextColorOptions: true,
                        showMediaPicker: true,
                        showLayout: true,
                        shouldUseCardV2UI: true
                    }))
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fc8fd7435e1c1593$export$defe85febe8b728c).title),
        footerComponent: renderConfigPanelFooter,
        closeConfigPanel: closeConfigPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5b5e113a5fd60dc8$var$styles.supportLinkWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...showConfigPreambleSupportLink ? (0, $fc8fd7435e1c1593$export$defe85febe8b728c).preambleV2 : (0, $fc8fd7435e1c1593$export$defe85febe8b728c).preambleV2WithoutSupportLink,
        values: {
            number: CURRENT_FRAMES_LIMIT,
            supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                target: "_blank",
                href: $5b5e113a5fd60dc8$var$SUPPORT_LINK
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fc8fd7435e1c1593$export$defe85febe8b728c).preambleSupportLinkLabelV2))
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cGll.PremiumGateForExtensionConfigPanel), {
        feature: "premiumCarouselConfig"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zyjT.ConfigPanelGrouping), {
        source: (0, $gXR7h.carouselConfigAnalyticSource),
        tabSections: tabSections,
        onTabClick: handleTabClick
    })));
};
module.exports["CarouselConfigPanelContent"] = $5b5e113a5fd60dc8$export$97c0055a2666fa5d;

});

parcelRegister("93Axx", function(module, exports) {
const $8b955c884926f762$var$itemDataKey = Symbol('item');
function $8b955c884926f762$export$dc0c4ec5c1198760({ item: item, index: index }) {
    return {
        [$8b955c884926f762$var$itemDataKey]: true,
        item: item,
        index: index
    };
}
function $8b955c884926f762$export$2a210a87dce1e5bc(data) {
    return data[$8b955c884926f762$var$itemDataKey] === true;
}
module.exports["getItemData"] = $8b955c884926f762$export$dc0c4ec5c1198760;
module.exports["isItemData"] = $8b955c884926f762$export$2a210a87dce1e5bc;

});

parcelRegister("9YAKX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $2ot3O = parcelRequire("2ot3O");


var $24dy7 = parcelRequire("24dy7");


var $cfM7x = parcelRequire("cfM7x");


var $fKfsb = parcelRequire("fKfsb");


var $f849I = parcelRequire("f849I");

const $59bd17d8cff0edaf$export$f8da0ec9f5f5f971 = ({ contentId: contentId, handleUploadedImageSelection: handleUploadedImageSelection, analyticsSource: analyticsSource })=>{
    const { createEditorMediaProvider: createEditorMediaProvider, mediaUploadExperienceTracker: mediaUploadExperienceTracker, transformUploadedImageId: transformUploadedImageId } = (0, $cfM7x.useProductDependencies)();
    const [uploadedImageId, setUploadedImageId] = (0, $cozmU.useState)(null);
    const { showFlag: showFlag } = (0, $2ot3O.useFlags)();
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isUploadingImage, setIsUploadingImage] = (0, $cozmU.useState)(false);
    const [isMediaBrowserOpen, setIsMediaBrowserOpen] = (0, $cozmU.useState)(false);
    const [mediaConfig, setMediaConfig] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!!uploadedImageId) handleUploadedImageSelection({
            uploadedImageId: uploadedImageId,
            altDescription: ''
        });
    // We only want this logic to run when uploadedImageId changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        uploadedImageId
    ]);
    const openMediaBrowser = ()=>{
        setIsMediaBrowserOpen(true);
    };
    const closeMediaBrowser = ()=>{
        setIsMediaBrowserOpen(false);
    };
    const handleUploadStart = ()=>{
        setIsUploadingImage(true);
        mediaUploadExperienceTracker?.start({
            analyticsSource: analyticsSource
        });
    };
    const showErrorFlag = (0, $cozmU.useCallback)(()=>{
        showFlag({
            title: formatMessage((0, $fKfsb.messages).errorFlagTitle),
            description: formatMessage((0, $fKfsb.messages).errorFlagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        });
        setIsUploadingImage(false);
    }, [
        formatMessage,
        showFlag
    ]);
    const handleOnError = (payload)=>{
        setIsUploadingImage(false);
        showErrorFlag();
        mediaUploadExperienceTracker?.stopOnError({
            error: payload?.error?.rawError ?? new Error('Error with cards image upload')
        });
    };
    const handleUploadEnd = (event)=>{
        setIsUploadingImage(false);
        const fileType = event?.file?.type;
        const id = event?.file?.id;
        if (!fileType.includes('image')) {
            showErrorFlag();
            mediaUploadExperienceTracker?.stopOnError({
                error: new Error('File type is not image')
            });
        } else if (id) {
            const imageId = transformUploadedImageId ? transformUploadedImageId({
                contentId: contentId,
                fileId: id
            }) : id;
            setUploadedImageId(imageId);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'image',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'customerUpload'
                    }
                }
            }).fire();
            mediaUploadExperienceTracker?.succeed();
        } else {
            showErrorFlag();
            mediaUploadExperienceTracker?.stopOnError({
                error: new Error('File does not have a type or id')
            });
        }
    };
    (0, $cozmU.useEffect)(()=>{
        const showAttachmentLimitReachedFlag = (rejectionData)=>{
            if (rejectionData) {
                showFlag((0, $f849I.getAttachmentSizeLimitErrorFlag)(rejectionData, intl));
                setIsUploadingImage(false);
                mediaUploadExperienceTracker?.succeed();
            }
            return !!rejectionData;
        };
        const createMediaConfig = async ()=>{
            try {
                const { uploadParams: uploadParams, uploadMediaClientConfig: uploadMediaClientConfig } = await createEditorMediaProvider?.({
                    contentId: contentId,
                    contentType: 'page',
                    isExternalShare: false,
                    onUploadRejection: showAttachmentLimitReachedFlag
                }) || {};
                if (uploadMediaClientConfig === undefined) return null;
                setMediaConfig({
                    collection: uploadParams?.collection,
                    authProvider: uploadMediaClientConfig.authProvider,
                    onUploadRejection: uploadParams?.onUploadRejection
                });
            } catch (error) {
                mediaUploadExperienceTracker?.stopOnError({
                    error: new Error(`Error with image media provider: ${error}`)
                });
            }
        };
        createMediaConfig();
    }, [
        contentId,
        showErrorFlag,
        showFlag,
        intl,
        mediaUploadExperienceTracker,
        createEditorMediaProvider
    ]);
    return {
        mediaConfig: mediaConfig,
        handleUploadEnd: handleUploadEnd,
        handleUploadStart: handleUploadStart,
        handleOnError: handleOnError,
        isMediaBrowserOpen: isMediaBrowserOpen,
        openMediaBrowser: openMediaBrowser,
        closeMediaBrowser: closeMediaBrowser,
        isUploadingImage: isUploadingImage
    };
};
module.exports["useUploadMediaConfig"] = $59bd17d8cff0edaf$export$f8da0ec9f5f5f971;

});

parcelRegister("fKfsb", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $bf7ef9a3dfdb9f87$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorFlagTitle: {
        id: "company-hub.company-hub-common.link.cards.image.upload.error.flag.title",
        defaultMessage: "We can\u2019t upload your image"
    },
    errorFlagDescription: {
        id: "company-hub.company-hub-common.link.cards.image.upload.error.flag.description",
        defaultMessage: "Refresh the page and try again."
    }
});
module.exports["messages"] = $bf7ef9a3dfdb9f87$export$defe85febe8b728c;

});

parcelRegister("f849I", function(module, exports) {

var $cteBB = parcelRequire("cteBB");

// Constants
const $c3dd67e8b13c4584$var$SIZE_LIMIT_LEARN_MORE_LINK = 'https://support.atlassian.com/confluence-cloud/docs/upload-a-file/';
const $c3dd67e8b13c4584$var$BYTES_PER_UNIT = 1024;
const $c3dd67e8b13c4584$var$DECIMAL_PLACES = 2;
const $c3dd67e8b13c4584$var$SIZE_UNITS = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB'
];
/**
 * Calculates the appropriate unit index for a given byte size
 */ const $c3dd67e8b13c4584$var$calculateUnitIndex = (bytes, maxMagnitude)=>{
    const calculatedIndex = Math.floor(Math.log(bytes) / Math.log($c3dd67e8b13c4584$var$BYTES_PER_UNIT));
    // Only apply maxMagnitude limit if it's truthy and less than the calculated index
    if (maxMagnitude && maxMagnitude < $c3dd67e8b13c4584$var$SIZE_UNITS.length - 1) return Math.min(calculatedIndex, maxMagnitude);
    return calculatedIndex;
};
/**
 * Formats bytes into a human-readable string with appropriate units
 */ const $c3dd67e8b13c4584$var$formatBytesToString = (bytes, unitIndex)=>{
    const convertedSize = bytes / $c3dd67e8b13c4584$var$BYTES_PER_UNIT ** unitIndex;
    const formattedSize = parseFloat(convertedSize.toFixed($c3dd67e8b13c4584$var$DECIMAL_PLACES));
    return `${formattedSize} ${$c3dd67e8b13c4584$var$SIZE_UNITS[unitIndex]}`;
};
const $c3dd67e8b13c4584$export$f2d538a5633fea72 = (bytes, maxMagnitude)=>{
    if (bytes <= 0) return '0 bytes';
    // Validate maxMagnitude parameter (0 means no limit, so it's valid)
    if (maxMagnitude !== undefined && (maxMagnitude < 0 || maxMagnitude >= $c3dd67e8b13c4584$var$SIZE_UNITS.length)) throw new Error(`maxMagnitude must be between 0 and ${$c3dd67e8b13c4584$var$SIZE_UNITS.length - 1}`);
    const unitIndex = $c3dd67e8b13c4584$var$calculateUnitIndex(bytes, maxMagnitude);
    return $c3dd67e8b13c4584$var$formatBytesToString(bytes, unitIndex);
};
/**
 * Creates a flag configuration for file size limit exceeded error
 */ const $c3dd67e8b13c4584$var$createFileSizeLimitExceededFlag = (fileName, limit, intl)=>({
        title: intl.formatMessage((0, $cteBB.messages).errorTitle, {
            fileName: fileName
        }),
        description: intl.formatMessage((0, $cteBB.messages).errorDescription, {
            size: $c3dd67e8b13c4584$export$f2d538a5633fea72(limit)
        }),
        actions: [
            {
                content: intl.formatMessage((0, $cteBB.messages).learnMore),
                onClick: ()=>{
                    window.open($c3dd67e8b13c4584$var$SIZE_LIMIT_LEARN_MORE_LINK, '_blank');
                }
            }
        ]
    });
/**
 * Creates a flag configuration for empty file error
 */ const $c3dd67e8b13c4584$var$createEmptyFileErrorFlag = (data, intl)=>({
        title: intl.formatMessage((0, $cteBB.messages).zeroByteErrorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage((0, $cteBB.messages).zeroByteErrorDescription)
    });
const $c3dd67e8b13c4584$export$1c61cf0ed486df46 = (data, intl)=>{
    switch(data.reason){
        case 'fileSizeLimitExceeded':
            return $c3dd67e8b13c4584$var$createFileSizeLimitExceededFlag(data.fileName, data.limit, intl);
        default:
            return $c3dd67e8b13c4584$var$createEmptyFileErrorFlag(data, intl);
    }
};
module.exports["getAttachmentSizeLimitErrorFlag"] = $c3dd67e8b13c4584$export$1c61cf0ed486df46;

});

parcelRegister("cteBB", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a8a8eaca16b052d3$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "company-hub-common.attachment-size-limit-error.title",
        defaultMessage: "{fileName} is too large to upload"
    },
    errorDescription: {
        id: "company-hub-common.attachment-size-limit-error.description",
        defaultMessage: "Attachments must be {size} or less."
    },
    learnMore: {
        id: "company-hub-common.attachment-size-limit-error.learn-more",
        defaultMessage: "Learn more"
    },
    zeroByteErrorTitle: {
        id: "company-hub-common.attachment-zero-byte-error.title",
        defaultMessage: "{fileName} is empty (zero bytes)"
    },
    zeroByteErrorDescription: {
        id: "company-hub-common.attachment-zero-byte.description",
        defaultMessage: "Attachments must be at least 1 byte of size"
    }
});
module.exports["messages"] = $a8a8eaca16b052d3$export$defe85febe8b728c;

});


//# sourceMappingURL=cards-extension.eaa4f55c.js.map
